var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eIoXAxwJW5C1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 350",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "6c35cde5c8ad4654bcab0f6a68848ace",
    "export-id": "fbda446e6e9548dd82b353a2f6137e93",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C7-fill",
    x1: 265.723,
    y1: 134.95,
    x2: 323.896,
    y2: 269.706,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C7-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C7-fill-1",
    offset: "100%",
    stopColor: "#bbb5c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C9-fill",
    x1: 3183.09,
    y1: 249.443,
    x2: 611.56,
    y2: 3924.293,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C9-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C9-fill-1",
    offset: "52.3%",
    stopColor: "#ede9f4"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C9-fill-2",
    offset: "99.5%",
    stopColor: "#ffc5ae"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C9-fill-3",
    offset: "100%",
    stopColor: "#d8cfe8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C56-fill",
    x1: 2986.66,
    y1: 193.106,
    x2: 1170.96,
    y2: 2454.386,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C56-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C56-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C56-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C56-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C58-fill",
    x1: 3222.08,
    y1: 245.641,
    x2: 1813.4,
    y2: 2000.011,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C58-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C58-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C58-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C58-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C61-fill",
    x1: 2453.11,
    y1: 1216.26,
    x2: 2276.36,
    y2: 1377.154,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C61-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C61-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C62-fill",
    x1: 2183.53,
    y1: 1316.56,
    x2: 2345.177,
    y2: 1193.736,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C62-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C62-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C63-fill",
    x1: 1980.05,
    y1: 1017.94,
    x2: 2430.93,
    y2: 582.518,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C63-fill-0",
    offset: "0%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C63-fill-1",
    offset: "95.4%",
    stopColor: "#dde8cf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C63-fill-2",
    offset: "100%",
    stopColor: "#ffd6c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C64-fill",
    x1: 1826.93,
    y1: 1044.18,
    x2: 2310.242,
    y2: 759.15,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C64-fill-0",
    offset: "20.9%",
    stopColor: "#005b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C64-fill-1",
    offset: "69.1%",
    stopColor: "#098464"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C64-fill-2",
    offset: "97.6%",
    stopColor: "#25b292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C65-fill",
    x1: 1886.33,
    y1: 1129.53,
    x2: 1988.358,
    y2: 1090.892,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C65-fill-0",
    offset: "0%",
    stopColor: "#034f40"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C65-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C69-fill",
    x1: 2318.3,
    y1: 905.246,
    x2: 2198.654,
    y2: 1019.575,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C69-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C69-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C70-fill",
    x1: 2135.97,
    y1: 846.944,
    x2: 2246.15,
    y2: 846.944,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C70-fill-0",
    offset: "33.1%",
    stopColor: "#d35652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C70-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C72-fill",
    x1: 2081.89,
    y1: 873.24,
    x2: 2226.822,
    y2: 942.255,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C72-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C72-fill-1",
    offset: "100%",
    stopColor: "#a31d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C73-fill",
    x1: 2264.13,
    y1: 945.321,
    x2: 2210.716,
    y2: 1011.703,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C73-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C73-fill-1",
    offset: "92.1%",
    stopColor: "#f05960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C76-fill",
    x1: 2231.56,
    y1: 864.293,
    x2: 2258.545,
    y2: 795.173,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C76-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C76-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C77-fill",
    x1: 2384.31,
    y1: 770.269,
    x2: 2255.98,
    y2: 983.296,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C77-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C77-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C79-fill",
    x1: 2003.99,
    y1: 829.421,
    x2: 2154.673,
    y2: 631.781,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C79-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C79-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C81-fill",
    x1: 2250.93,
    y1: 879.253,
    x2: 2235.148,
    y2: 811.435,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C81-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C81-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C84-fill",
    x1: 2185.64,
    y1: 839.966,
    x2: 2172.637,
    y2: 784.088,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C84-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C84-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C87-fill",
    x1: 2169.66,
    y1: 893.969,
    x2: 2155.66,
    y2: 833.651,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C87-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C87-fill-1",
    offset: "85.6%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C88-fill",
    x1: 2316.37,
    y1: 846.465,
    x2: 2315.258,
    y2: 781.687,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C88-fill-0",
    offset: "12.8%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C88-fill-1",
    offset: "52.9%",
    stopColor: "#ed956e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C90-fill",
    x1: 2118.09,
    y1: 745.011,
    x2: 2158.438,
    y2: 824.642,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C90-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C90-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C91-fill",
    x1: 2194.59,
    y1: 771.965,
    x2: 2217.815,
    y2: 813.669,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C91-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C91-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C101-fill",
    x1: 2290.55,
    y1: 851.283,
    x2: 2266.93,
    y2: 807.498,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C101-fill-0",
    offset: "1.9%",
    stopColor: "#d65764"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C101-fill-1",
    offset: "63%",
    stopColor: "#ffc6a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C104-fill",
    x1: 2255.78,
    y1: 697.908,
    x2: 2183.774,
    y2: 675.272,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C104-fill-0",
    offset: "5.6%",
    stopColor: "#ffddc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C104-fill-1",
    offset: "77.1%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C105-fill",
    x1: 2194.94,
    y1: 799.409,
    x2: 2202.87,
    y2: 832.863,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C105-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C105-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C106-fill",
    x1: 2142.87,
    y1: 864.106,
    x2: 2138.125,
    y2: 856.038,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C106-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C106-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C120-fill",
    x1: 2129.6,
    y1: 782.347,
    x2: 2136.327,
    y2: 810.122,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C120-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C120-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C127-fill",
    x1: 1346.31,
    y1: 1094.45,
    x2: 1694.02,
    y2: 700.477,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C127-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C127-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C128-fill",
    x1: 2403.63,
    y1: 1248.88,
    x2: 2274.439,
    y2: 1394.22,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C128-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C128-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C132-fill",
    x1: 2016.36,
    y1: 754.239,
    x2: 2280.467,
    y2: 1113.393,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C132-fill-0",
    offset: "0%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C132-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C132-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C135-fill",
    x1: 1894.88,
    y1: 913.596,
    x2: 1980.735,
    y2: 867.456,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C135-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C135-fill-1",
    offset: "100%",
    stopColor: "#a31d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C136-fill",
    x1: 1941.6,
    y1: 914.871,
    x2: 2040.062,
    y2: 855.336,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C136-fill-0",
    offset: "32.5%",
    stopColor: "#e53e53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C136-fill-1",
    offset: "100%",
    stopColor: "#ff985f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C137-fill",
    x1: 2077.79,
    y1: 937.929,
    x2: 2047.441,
    y2: 941.197,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C137-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C137-fill-1",
    offset: "100%",
    stopColor: "#a31d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C141-fill",
    x1: 2079.36,
    y1: 900.885,
    x2: 1985.017,
    y2: 964.385,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C141-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C141-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C142-fill",
    x1: 2064.15,
    y1: 835.405,
    x2: 2067.514,
    y2: 835.405,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C142-fill-0",
    offset: "19.7%",
    stopColor: "#bcaebd"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C142-fill-1",
    offset: "74%",
    stopColor: "#e9e6e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C143-fill",
    x1: 2029.75,
    y1: 895.806,
    x2: 2064.564,
    y2: 895.806,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C143-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C143-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C144-fill",
    x1: 2021.94,
    y1: 855.115,
    x2: 2062.778,
    y2: 855.115,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C144-fill-0",
    offset: "0%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C144-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C144-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C145-fill",
    x1: 1842.44,
    y1: 957.658,
    x2: 1949.321,
    y2: 836.556,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C145-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C145-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C146-fill",
    x1: 2041.93,
    y1: 839.865,
    x2: 2064.933,
    y2: 839.865,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C146-fill-0",
    offset: "19.7%",
    stopColor: "#bcaebd"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C146-fill-1",
    offset: "74%",
    stopColor: "#eae7ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C147-fill",
    x1: 1949.88,
    y1: 967.601,
    x2: 2020.967,
    y2: 887.056,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C147-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C147-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C148-fill",
    x1: 1891.64,
    y1: 904.491,
    x2: 2108.178,
    y2: 809.665,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C148-fill-0",
    offset: "0%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C148-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C148-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C150-fill",
    x1: 2506.64,
    y1: 869.511,
    x2: 2125.491,
    y2: 1295.065,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C150-fill-0",
    offset: "15.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C150-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C152-fill",
    x1: 1973.97,
    y1: 1275.29,
    x2: 2012.448,
    y2: 1226.765,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C152-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C152-fill-1",
    offset: "63.7%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C152-fill-2",
    offset: "94.4%",
    stopColor: "#c93d47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C157-fill",
    x1: 2690.9,
    y1: 1318.65,
    x2: 2361.214,
    y2: 1395.018,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C157-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C157-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C157-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C157-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C159-fill",
    x1: 2601.13,
    y1: 1275.66,
    x2: 2596.783,
    y2: 1468.011,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C159-fill-0",
    offset: "8.9%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C159-fill-1",
    offset: "100%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C160-fill",
    x1: 2550.23,
    y1: 1274.48,
    x2: 2545.883,
    y2: 1466.832,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C160-fill-0",
    offset: "8.9%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C160-fill-1",
    offset: "100%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C161-fill",
    x1: 2500.42,
    y1: 1273.33,
    x2: 2496.073,
    y2: 1465.681,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C161-fill-0",
    offset: "8.9%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C161-fill-1",
    offset: "100%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C162-fill",
    x1: 2450.98,
    y1: 1272.19,
    x2: 2446.633,
    y2: 1464.541,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C162-fill-0",
    offset: "8.9%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C162-fill-1",
    offset: "100%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C164-fill",
    x1: 1847.33,
    y1: 1376.28,
    x2: 1983.202,
    y2: 1212.052,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C164-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C164-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C165-fill",
    x1: 1952.41,
    y1: 1415.44,
    x2: 2009.772,
    y2: 1255.726,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C165-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C165-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C167-fill",
    x1: 2316.51,
    y1: 1086.95,
    x2: 2275.764,
    y2: 989.989,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C167-fill-0",
    offset: "0%",
    stopColor: "#7bcfba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C167-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C170-fill",
    x1: 1828.98,
    y1: 1496.89,
    x2: 1695.784,
    y2: 1384.451,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C170-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C170-fill-1",
    offset: "100%",
    stopColor: "#f8914f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C172-fill",
    x1: 1823.49,
    y1: 1282.62,
    x2: 1856.689,
    y2: 1269.451,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C172-fill-0",
    offset: "0%",
    stopColor: "#e53e53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C172-fill-1",
    offset: "100%",
    stopColor: "#ff985f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C173-fill",
    x1: 1855.39,
    y1: 1309.51,
    x2: 1882.306,
    y2: 1298.833,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C173-fill-0",
    offset: "0%",
    stopColor: "#e53e53"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C173-fill-1",
    offset: "100%",
    stopColor: "#ff985f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C180-fill",
    x1: 1915.28,
    y1: 1267.39,
    x2: 1802.516,
    y2: 1272.05,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C180-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C180-fill-1",
    offset: "100%",
    stopColor: "#f8914f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C186-fill",
    x1: 1852.37,
    y1: 1404.03,
    x2: 1856.477,
    y2: 1404.03,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C186-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C186-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C189-fill",
    x1: 2568.36,
    y1: 1231.46,
    x2: 2468.419,
    y2: 1312.401,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C189-fill-0",
    offset: "25%",
    stopColor: "#ffc98f"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C189-fill-1",
    offset: "70.4%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C190-fill",
    x1: 2391.77,
    y1: 1308.79,
    x2: 2554.376,
    y2: 1193.987,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C190-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C190-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C190-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C195-fill",
    x1: 2591.86,
    y1: 1178.25,
    x2: 2442.875,
    y2: 1285.112,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C195-fill-0",
    offset: "25%",
    stopColor: "#ffc98f"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C195-fill-1",
    offset: "70.4%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C197-fill",
    x1: 2525.18,
    y1: 1227.79,
    x2: 2520.88,
    y2: 1150.872,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C197-fill-0",
    offset: "39.6%",
    stopColor: "#ffdbc0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C197-fill-1",
    offset: "78%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C198-fill",
    x1: 2402.78,
    y1: 1255.71,
    x2: 2536.175,
    y2: 1163.391,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C198-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C198-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C198-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C203-fill",
    x1: 2445.68,
    y1: 1224.46,
    x2: 2511.802,
    y2: 1186.313,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C203-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C203-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C203-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C204-fill",
    x1: 2504.61,
    y1: 1190.17,
    x2: 2510.026,
    y2: 1187.045,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C204-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C204-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C204-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C205-fill",
    x1: 2453.66,
    y1: 1237.78,
    x2: 2517.605,
    y2: 1200.889,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C205-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C205-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C205-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C206-fill",
    x1: 2459.02,
    y1: 1251.46,
    x2: 2523.412,
    y2: 1214.311,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C206-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C206-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C206-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C207-fill",
    x1: 2435.74,
    y1: 1228.37,
    x2: 2530.223,
    y2: 1173.861,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C207-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C207-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C207-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C208-fill",
    x1: 2439.96,
    y1: 1211.88,
    x2: 2504.843,
    y2: 1174.448,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C208-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C208-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C208-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C209-fill",
    x1: 2437.02,
    y1: 1241.89,
    x2: 2501.843,
    y2: 1196.123,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C209-fill-0",
    offset: "25.4%",
    stopColor: "#7a6800"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C209-fill-1",
    offset: "77.5%",
    stopColor: "#adae1d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C225-fill",
    x1: 2570.35,
    y1: 1159.31,
    x2: 2468.658,
    y2: 1241.669,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C225-fill-0",
    offset: "25%",
    stopColor: "#ffc98f"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C225-fill-1",
    offset: "70.4%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C226-fill",
    x1: 2388.98,
    y1: 1235.36,
    x2: 2554.16,
    y2: 1118.74,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C226-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C226-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C226-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C231-fill",
    x1: 2591.86,
    y1: 1103.69,
    x2: 2442.875,
    y2: 1210.552,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C231-fill-0",
    offset: "25%",
    stopColor: "#ffc98f"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C231-fill-1",
    offset: "70.4%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C233-fill",
    x1: 2525.18,
    y1: 1153.23,
    x2: 2520.88,
    y2: 1076.312,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C233-fill-0",
    offset: "39.6%",
    stopColor: "#ffdbc0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C233-fill-1",
    offset: "78%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C234-fill",
    x1: 2402.78,
    y1: 1181.16,
    x2: 2536.175,
    y2: 1088.841,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C234-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C234-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C234-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C239-fill",
    x1: 2445.68,
    y1: 1149.9,
    x2: 2511.802,
    y2: 1111.753,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C239-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C239-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C239-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C240-fill",
    x1: 2504.61,
    y1: 1115.61,
    x2: 2510.026,
    y2: 1112.485,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C240-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C240-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C240-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C241-fill",
    x1: 2453.66,
    y1: 1163.22,
    x2: 2517.604,
    y2: 1126.329,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C241-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C241-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C241-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C242-fill",
    x1: 2459.02,
    y1: 1176.9,
    x2: 2523.412,
    y2: 1139.751,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C242-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C242-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C242-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C243-fill",
    x1: 2435.74,
    y1: 1153.81,
    x2: 2530.223,
    y2: 1099.301,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C243-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C243-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C243-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C244-fill",
    x1: 2439.96,
    y1: 1137.32,
    x2: 2504.843,
    y2: 1099.888,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C244-fill-0",
    offset: "33.1%",
    stopColor: "#b74e00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C244-fill-1",
    offset: "57.3%",
    stopColor: "#dd6514"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C244-fill-2",
    offset: "77.5%",
    stopColor: "#f29955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C245-fill",
    x1: 2437.02,
    y1: 1167.33,
    x2: 2501.843,
    y2: 1121.563,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C245-fill-0",
    offset: "25.4%",
    stopColor: "#7a6800"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C245-fill-1",
    offset: "77.5%",
    stopColor: "#adae1d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C262-fill",
    x1: 2393.21,
    y1: 1104.1,
    x2: 2105.663,
    y2: 1415.12,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C262-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C262-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C263-fill",
    x1: 2161.74,
    y1: 1189.9,
    x2: 2218.37,
    y2: 1147.348,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C263-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C263-fill-1",
    offset: "86.4%",
    stopColor: "#d85335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C269-fill",
    x1: 2378.37,
    y1: 1156.28,
    x2: 2119.697,
    y2: 1355.337,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C269-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C269-fill-1",
    offset: "99.9%",
    stopColor: "#d85335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C273-fill",
    x1: 1947.8,
    y1: 888.76,
    x2: 1658.215,
    y2: 1070.038,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C273-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C273-fill-1",
    offset: "64.1%",
    stopColor: "#f47555"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C273-fill-2",
    offset: "92%",
    stopColor: "#ce343f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C277-fill",
    x1: 1884.04,
    y1: 890.873,
    x2: 1691.402,
    y2: 1017.546,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C277-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C277-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C277-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C277-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C278-fill",
    x1: 1853.28,
    y1: 950.344,
    x2: 1714.172,
    y2: 1041.817,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C278-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C278-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C278-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C278-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C279-fill",
    x1: 1859.08,
    y1: 959.165,
    x2: 1719.972,
    y2: 1050.638,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C279-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C279-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C279-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C279-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C283-fill",
    x1: 2573.66,
    y1: 927.411,
    x2: 2800.374,
    y2: 666.917,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C283-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C283-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C283-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C283-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C295-fill",
    x1: 2732.01,
    y1: 497.255,
    x2: 2494.268,
    y2: 752.252,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C295-fill-0",
    offset: "24.1%",
    stopColor: "#b5a3b7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C295-fill-1",
    offset: "64.4%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C295-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C308-fill",
    x1: 2456.53,
    y1: 1018.36,
    x2: 2612.873,
    y2: 790.08,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C308-fill-0",
    offset: "0%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C308-fill-1",
    offset: "95.4%",
    stopColor: "#dde8cf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C308-fill-2",
    offset: "100%",
    stopColor: "#ffd6c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C309-fill",
    x1: 2848.56,
    y1: 905.779,
    x2: 2534.532,
    y2: 1089.914,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C309-fill-0",
    offset: "10.3%",
    stopColor: "#e6e2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C309-fill-1",
    offset: "95.4%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C316-fill",
    x1: 2218.39,
    y1: 629.169,
    x2: 2412.11,
    y2: 388.353,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C316-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C316-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C316-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C316-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C318-fill",
    x1: 1807.85,
    y1: 726.966,
    x2: 2015.427,
    y2: 515.58,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C318-fill-0",
    offset: "0%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C318-fill-1",
    offset: "95.4%",
    stopColor: "#dde8cf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C318-fill-2",
    offset: "100%",
    stopColor: "#ffd6c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C321-fill",
    x1: 1918.57,
    y1: 656.556,
    x2: 1930.074,
    y2: 980.587,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C321-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C321-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C322-fill",
    x1: 1938.16,
    y1: 657.488,
    x2: 1949.235,
    y2: 969.449,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C322-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C322-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C337-fill",
    x1: 1947.8,
    y1: 888.76,
    x2: 1658.215,
    y2: 1070.038,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C337-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C337-fill-1",
    offset: "64.1%",
    stopColor: "#f47555"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C337-fill-2",
    offset: "92%",
    stopColor: "#ce343f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C341-fill",
    x1: 1884.04,
    y1: 890.873,
    x2: 1691.402,
    y2: 1017.546,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C341-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C341-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C341-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C341-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C342-fill",
    x1: 1853.28,
    y1: 950.344,
    x2: 1714.172,
    y2: 1041.817,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C342-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C342-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C342-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C342-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C343-fill",
    x1: 1859.08,
    y1: 959.165,
    x2: 1719.972,
    y2: 1050.638,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C343-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C343-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C343-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C343-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C353-fill",
    x1: 2573.66,
    y1: 927.411,
    x2: 2800.374,
    y2: 666.917,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C353-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C353-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C353-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C353-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C357-fill",
    x1: 2456.53,
    y1: 1018.36,
    x2: 2612.873,
    y2: 790.08,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C357-fill-0",
    offset: "0%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C357-fill-1",
    offset: "95.4%",
    stopColor: "#dde8cf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C357-fill-2",
    offset: "100%",
    stopColor: "#ffd6c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C358-fill",
    x1: 2848.56,
    y1: 905.779,
    x2: 2534.532,
    y2: 1089.914,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C358-fill-0",
    offset: "10.3%",
    stopColor: "#e6e2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C358-fill-1",
    offset: "95.4%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C365-fill",
    x1: 2218.39,
    y1: 629.169,
    x2: 2412.11,
    y2: 388.353,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C365-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C365-fill-1",
    offset: "46.3%",
    stopColor: "#dbe5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C365-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C365-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C369-fill",
    x1: 2732.01,
    y1: 497.255,
    x2: 2494.268,
    y2: 752.252,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C369-fill-0",
    offset: "24.1%",
    stopColor: "#b5a3b7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C369-fill-1",
    offset: "64.4%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C369-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C383-fill",
    x1: 1807.85,
    y1: 726.966,
    x2: 2015.427,
    y2: 515.58,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C383-fill-0",
    offset: "0%",
    stopColor: "#1fb090"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C383-fill-1",
    offset: "95.4%",
    stopColor: "#dde8cf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C383-fill-2",
    offset: "100%",
    stopColor: "#ffd6c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C386-fill",
    x1: 1918.57,
    y1: 656.556,
    x2: 1930.074,
    y2: 980.587,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C386-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C386-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eIoXAxwJW5C387-fill",
    x1: 1938.16,
    y1: 657.488,
    x2: 1949.235,
    y2: 969.449,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C387-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eIoXAxwJW5C387-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.353416 0 0 0.364577 116.565761 363.13782)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1972.051163-1389.909619)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1.001118 0-111.245547)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.572653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C55",
    transform: "matrix(0 0 0 0 2352.876831 742.049469)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2252.2,788.6c11.9,13.1,24.4,25,38.1,35.5c13.7,10.4,28.6,19.2,45.4,26.2c15.8,6.5,32.6,9.6,49.7,9.6c17.1.1,34.5-2.9,51.3-8.3c12.5-4.1,25.9-11.2,36.6-20.7c10.7-9.6,18.7-21.5,20.4-34.9c2-16.6-4-32.5-14.1-45.7s-24.3-23.8-38.5-29.9c-10.4-4.6-21.2-8.7-31.5-13.5-10.4-4.8-20.3-10.3-29.2-17.4-7.3-5.8-13.7-12.6-19.9-19.6s-12.2-14.2-18.8-20.8q-.5-.6-1.1-1.1-.5-.5-1.1-1c-8.5-8.1-17.9-14.3-28.2-18.2-10.4-3.9-21.5-5.4-33.6-4.2-12,1.3-23.3,4.8-33,10.7-9.7,6-17.9,14.3-23.5,25.1-11.7,22.3-11.7,45.7-5,67.8s20.2,42.9,35.5,59.9q.2.1.3.2.1.2.2.3Z",
    fill: "url(#eIoXAxwJW5C56-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C57",
    transform: "matrix(0 0 0 0 2178.88269 944.030189)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2579.9,955.4c-27.5-20.4-59.4-31.8-92.8-40.4-33.3-8.6-68.1-14.3-101.3-23.3-48.4-13.2-94.5-34-136.8-60.7-42.2-26.8-80.8-59.4-114.2-96.5-14.4-16.1-28.3-33.2-43.5-48.7-15.1-15.6-31.5-29.5-51-39.1-20.8-10.4-43.8-15-67.1-15.3s-47.1,3.7-69.4,10.6c-39.8,12.3-76.6,33.8-107.4,61.8-30.7,27.9-55.5,62.4-71.2,100.6-32,77.5-26.4,164.9.4,247.4c26.9,82.5,75,160.1,128,218.2q1,1,2,2.1t2,2.2h371.3h371.3c9-12.7,17.1-26,24.2-39.9c7.1-14,13.2-28.5,18.3-43.7c13.7-41.2,15.5-87,5.1-129-10.3-42.1-32.9-80.3-67.9-106.3Z",
    fill: "url(#eIoXAxwJW5C58-fill)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C60",
    transform: "translate(2049.245143 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2398.2,1200.6c-2.1,6.5-5.9,12.9-10,18.8-4.2,5.8-8.7,11.1-12.3,15.3q-2.1,2.4-4.4,4.9-2.2,2.6-4.6,5.2c-6.3,6.8-11.6,12.6-17.5,17.2s-12.4,8.1-21.2,10.3c-5,1.3-11,1.8-17,2s-11.8.1-16.5.1c-1.4-8.1-2.3-18.5-1.7-28.7s2.6-20.1,7-27.2c2.7-4.3,6.8-7.8,11.4-10.7c4.6-3,9.7-5.3,14.2-7q10.7-4.1,21.4-8.1t21.6-7.7c3-1,9.7-4.1,15.9-5.5c6.2-1.5,12-1.4,13.1,3.8l.7.7.7.7c.7,2.5.9,5.2.8,7.8-.2,2.7-.8,5.4-1.6,8.1Z",
    fill: "url(#eIoXAxwJW5C61-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2398.2,1200.6c-1.3,4-3,7.9-5.2,11.5-2.2,3.5-4.9,6.7-8.2,9.3q-4.8,3.7-9.9,7.1t-10.4,6.5c-7.1,4-14.5,7.5-22.1,10.5-7.7,3-15.5,5.5-23.4,7.3-2,.5-4.3,1-6.7,1-2.3.1-4.6-.3-6.3-1.7-2.4-1.8-2.2-5.2-1.1-8.5c1-3.4,3-6.7,4.1-8.5c2-2.9,4.4-5.5,7.1-7.8c2.6-2.4,5.6-4.4,8.6-6.2c5.4-3.3,11-5.6,16.7-7.5s11.5-3.3,17.6-4.8c6.5-1.6,12.9-3.4,19.4-4.9c6.4-1.5,13-2.7,19.8-3.3Z",
    fill: "url(#eIoXAxwJW5C62-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2417.9,1199.7q-7.2,3.3-14.6,6-7.4,2.8-14.9,5-9.3,2.8-18.7,4.8t-19,3.3c-3.3.5-8.5.8-13.7,1.1-5.1.3-10.3.5-13.7.6-.2,0-.8,5.2-1.3,10.8-.6,5.6-1.1,11.6-1.4,13.3q-.7,5.1-1.5,10.2-.8,5-1.7,10c-.8,4.6-1,7-2.3,8.2-1.2,1.3-3.4,1.5-7.9,1.5q-13.8.1-27.6.2-13.8,0-27.6.1-28.7.1-57.5.1-28.8-.1-57.5-.3-6.6,0-13.1-.1-6.6,0-13.1-.1c-2,0-3.7.1-5.3.2-1.5,0-2.8,0-4-.3q-.1,0-.1,0t-.1,0c-1.2-.2-2.2-.7-3.2-1.5-1-.9-1.9-2.1-2.8-3.9-3.7-7-6.4-15.2-8.7-23.5s-4.3-16.7-6.6-24.3q-3.5-12.1-6.9-24.2-3.4-12.2-6.6-24.4c-.7-2.6-4.3-13.7-7.4-24.5s-5.6-21.3-4.1-22.7q-17.1,14.8-34.1,29.6-17.1,14.7-34.1,29.5c-1.9,1.7-4,3.4-6.2,4.6-2.3,1.1-4.7,1.8-7.1,1.3-1.6-.3-3-1-4.3-1.9s-2.5-2.1-3.6-3.3c-7-7.1-12.7-15.4-16.9-24.4s-7-18.7-8.1-28.7c-.1-1.2-.2-2.5-.2-3.8s.2-2.6.5-3.9c.5-1.6,1.2-3,2.2-4.4.9-1.4,2-2.8,3.1-4.1c18.7-22.9,33.5-48.9,49.1-74.2s32-49.9,54-69.7c2.3-2,4.6-4,7-5.8c2.5-1.8,5-3.4,7.8-4.7c2.1-1,4.4-1.9,6.6-2.6c2.3-.8,4.6-1.4,6.8-2q15.8-4.3,31.4-8.7q15.7-4.3,31.4-8.6.9,3.4,2.3,6.8q1.3,3.4,3,6.6.3.6.6,1.2.4.7.7,1.2.6,1,1.1,1.9.6.9,1.2,1.7q1.2,1.7,2.5,3.2q1.3,1.6,2.7,3q.9.9,1.8,1.7t1.8,1.5c6.5,5.1,15.3,9,24.5,11.3c9.1,2.3,18.7,3,26.7,1.8c4.9-.7,9.4-2.4,13.6-4.5c4.3-2.1,8.3-4.7,12.5-7.2c4.2-2.7,9.1-6,13.5-9.7c4.5-3.8,8.5-7.9,11.1-12.2q.8.2,1.5.5.8.3,1.6.6.9.2,1.7.5t1.7.6q.5.2,1,.4t1,.3q1.3.4,2.6.9q1.2.4,2.5.8c3,1,6,2,8.9,3c2.8,1,5.6,2,7.9,3c8.9,3.8,15.8,6.9,22.4,10c6.6,3.2,12.9,6.4,20.7,10.7c5.3,2.9,10,5.6,13.7,8.6c3.8,3.1,6.7,6.5,8.5,10.8c12.4,29.8,24,64.5,34.5,99.5s19.9,70.4,27.8,101.7Z",
    fill: "url(#eIoXAxwJW5C63-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2345.3,1219.6q-4.9.7-10,1.2-5,.5-10.1.7c-.2,0-1.2,4.9-2.3,10.3-1,5.3-2,11.1-2.3,12.8q-.7,5.1-1.5,10.2-.8,5-1.7,10c-.4,2.3-.7,4.4-1,6-.3,1.7-.5,2.9-.8,3.3c0,0-.9.1-2.5.2-1.5.1-3.6.2-5.9.2q-13.8.1-27.6.2-13.8,0-27.6.1-28.7.1-57.5.1-28.8-.1-57.5-.3-6.6,0-13.1-.1-6.6,0-13.1-.1-2.4,0-4.7,0-2.3-.1-4.8-.1c-1.2-.2-2.2-.7-3.2-1.5-1-.9-1.9-2.1-2.8-3.9-3.7-7-6.4-15.2-8.7-23.5s-4.3-16.7-6.6-24.3q-1.3-4.6-2.6-9.1t-2.6-9q-2.2-7.6-4.2-15.2-2.1-7.6-4.1-15.3c-.7-2.6-4.3-13.7-7.4-24.5s-5.6-21.3-4.1-22.7q-.4.3-.7.6-.4.4-.7.7c-7.1,6.5-12.9,14.1-18.3,22-5.5,7.9-10.5,16.1-16,23.9-1,1.5-1.9,2.9-3,4.2s-2.3,2.5-3.6,3.5c-1.1.8-2.3,1.5-3.6,2.1-1.2.6-2.5,1.2-3.7,1.7-6.2,2.4-13.5,5.5-20.6,6.7-7.1,1.1-13.9.2-19.2-5.6-7-7.1-12.7-15.4-16.9-24.4s-7-18.7-8.1-28.7c-.1-1.2-.2-2.5-.2-3.8s.2-2.6.5-3.9c.5-1.6,1.2-3,2.2-4.4.9-1.4,2-2.8,3.1-4.1c18.7-22.9,33.5-48.9,49.1-74.2s32-49.9,54-69.7c2.3-2,4.6-4,7-5.8c2.5-1.8,5-3.4,7.8-4.7c2.1-1,4.4-1.9,6.6-2.6c2.3-.8,4.6-1.4,6.8-2q6.1-1.7,12.1-3.3q6-1.7,12-3.4q9.7-2.6,19.4-5.3q9.7-2.6,19.3-5.3.9,3.4,2.3,6.8q1.3,3.4,3,6.6.3.6.6,1.2.4.7.7,1.2.6,1,1.1,1.9.6.9,1.2,1.7.8,1.3,1.8,2.4.9,1.2,2,2.3.5.6,1.1,1.2t1.3,1.2q.6.6,1.3,1.2.6.6,1.3,1.1c6.5,5.1,15.3,9,24.5,11.3c9.1,2.3,18.7,3,26.7,1.8c4.9-.7,9.4-2.4,13.6-4.5c4.3-2.1,8.3-4.7,12.5-7.2c4.2-2.7,9.1-6,13.5-9.7c4.5-3.8,8.5-7.9,11.1-12.2q.8.2,1.5.5.8.3,1.6.6.9.2,1.7.5t1.7.6q.5.2,1,.4t1,.3q1.3.4,2.6.9q1.2.4,2.5.8c-2.2,5.8-4.4,10.9-7.1,15.7-2.8,4.8-6.1,9.3-10.7,13.9-5.3,5.3-10.8,10.1-16.6,14.6-5.7,4.5-11.6,8.7-17.6,13-9.9,7.1-21.4,12.8-33.3,17.6s-24.3,8.6-35.9,11.7c-5.6,1.5-11.3,3.1-17.1,4.6-5.8,1.4-11.7,2.6-17.4,3.2-3.6,30.9,1.6,64.1,13.3,95c11.7,30.8,30,59.3,52.3,80.9c2.5,2.5,6.3,7.2,10.5,11.3c4.1,4.1,8.6,7.5,12.4,7.6c1.2,0,2.3-.2,3.4-.6s2.2-1,3.3-1.5c14.8-7.9,28.7-17.6,41.2-28.8c12.6-11.2,23.7-23.9,33.2-37.7c10.1-14.7,18-29.5,23.3-45.1s8-32,7.7-50.2c5,7.8,9.7,17.8,13.6,28.1c3.9,10.2,7,20.8,8.7,29.9c2.3,11.9,3.9,27.6,4.7,43s.8,30.4-.1,41Z",
    fill: "url(#eIoXAxwJW5C64-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1960.4,1108.9c-1.7,2.7-4.3,4.7-6.5,7-2.3,2.2-4.3,4.7-4.9,8.1-.7,3.4-.5,7.2,0,11c.6,3.8,1.6,7.5,2.7,10.6c2.1,5.9,5.6,15.2,10.5,23.1c4.9,7.8,11.1,14.1,18.5,13.9c8.5-.3,16.7-4.2,23.7-9.8s12.8-13,16.4-20c3.2-6.5,5.6-14.6,5.1-22.1-.4-7.5-3.6-14.3-11.4-18.1-4.4-2.1-9.3-3.4-14.3-4.2-4.9-.9-10-1.3-14.7-1.7-2.6-.3-8.1-1-13.3-1-5.3.1-10.2.7-11.8,3.2Z",
    fill: "url(#eIoXAxwJW5C65-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2268.4,950.7c-.2,2.5-1.4,5.1-2.8,7.6s-3.1,4.9-4.3,6.8c-1.9,3-3.9,5.9-6.2,8.6-2.2,2.8-4.7,5.3-7.5,7.5-7.2,6-15.5,10-24.3,12.7-8.8,2.8-18.1,4.3-27.3,5.2-6.4.6-12.5.7-18.5.1-6.1-.7-12-2.1-18-4.6-5.9-2.5-11.7-5.3-17.3-8.5-5.6-3.1-11-6.7-16-10.7-4.9-3.9-8.5-6.7-12.2-10.3s-7.4-8-12.4-15q9.7-2.6,19.4-5.3q9.7-2.6,19.3-5.3.9,3.4,2.3,6.8q1.3,3.4,3,6.6.3.6.6,1.2.4.7.7,1.2.6,1,1.1,1.9.6.9,1.2,1.7.8,1.3,1.8,2.4.9,1.2,2,2.3.5.6,1.1,1.2t1.3,1.2q.6.6,1.3,1.2.6.5,1.3,1.1c6.5,5.1,15.3,9,24.5,11.3c9.1,2.3,18.7,3,26.7,1.8c4.9-.7,9.4-2.4,13.6-4.5c4.3-2.1,8.3-4.7,12.5-7.2c4.2-2.7,9.1-6,13.5-9.7c4.5-3.8,8.5-7.9,11.1-12.2q.8.2,1.5.5.8.3,1.6.6.9.2,1.7.5t1.7.6q.5.2,1,.4t1,.3Z",
    fill: "#034f40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2074.8,1203q-2.2-7.6-4.2-15.2-2.1-7.6-4.1-15.3c-.7-2.6-4.3-13.7-7.4-24.5s-5.6-21.3-4.1-22.7q-.4.3-.7.6-.4.4-.7.7c.5-11.1,2.4-22.2,5.4-32.9c3.1-10.7,7.5-21.1,12.9-30.8q-1.6,8.2-2.6,16.5t-1.6,16.6c-.6,9.8-.8,19.7-.6,29.6.1,9.8.5,19.7,1,29.5.5,8.1,1.4,16.1,2.5,24.1c1.2,7.9,2.7,15.9,4.2,23.8Z",
    fill: "#004437"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2253.9,952c.1,1.2-.8,2.9-1.9,4.5s-2.4,3.2-3.3,4.1c-2.6,3.1-6.2,5.9-10,8.3-3.9,2.4-8,4.5-11.7,6.2-8.2,3.6-17.1,6-26.1,6.8-9.1.8-18.2-.1-26.9-3.2-4.5-1.6-8.7-3.7-12.8-6.1-4-2.4-8-5.1-11.9-7.7-2.3-1.6-4.4-3.6-6.1-6-1.8-2.4-3.2-5-4.4-7.7q-.8-1.8-1.5-3.5-.6-1.8-1.2-3.5-.1-.3-.1-.7-.1-.3.1-.6.1-.3.3-.6.3-.2.6-.4c3.5-2.3,6.8-4.9,9.7-8c2.9-3,5.4-6.4,7.4-10.1c1.9-3.5,3.4-7.2,4.2-11s1.1-7.7.8-11.7c-.2-1.3-.5-2.8-.9-4.4s-.9-3.2-1.2-4.9c-.2-1.4-.4-2.7-.3-4c0-1.2.2-2.4.8-3.4q1.5.2,3,.4q1.6.2,3.1.3.4,0,.7.1.3,0,.4,0q.7.1,1.4.2.6.1,1.3.2q2.1.2,4.2.4t4.2.3q1.6.2,3.3.3q1.6.1,3.3.2q1.1.1,2.4.1q1.2.1,2.4.1q1.4.1,2.7.2q1.3,0,2.6,0h.6.6q3.2,0,6.4-.1t6.4-.4q1.8-.1,3.5-.3q1.7-.1,3.5-.4.2,0,.5,0q.2-.1.5-.1q1.8-.2,3.7-.5q1.9-.4,3.7-.7q3.4-.7,6.9-1.4t6.9-1.7c-.6.2-.6,3.4-.3,7.8s1,10,1.7,14.9c.3,1.8.6,3.6.9,5.1.2,1.5.5,2.9.8,4c1.6,6.3,3,11.1,4.7,15.7c1.6,4.6,3.5,9.2,6,15.2.5,1,1.5,2.5,2.5,3.9.9,1.4,1.8,2.8,1.9,3.8Z",
    fill: "url(#eIoXAxwJW5C69-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2237.1,904.3q-4.6,4.1-9.4,8t-9.7,7.6q-6.7,5.1-13.8,9.4t-14.7,7.7c-7.8,3.6-16.1,6.7-24.7,9.1-8.5,2.4-17.3,4.2-26,5.1q-.8-1.8-1.5-3.5-.6-1.8-1.2-3.5-.1-.3-.1-.7-.1-.3.1-.6.1-.3.3-.6.3-.2.6-.4c3.5-2.3,6.8-4.9,9.7-8c2.9-3,5.4-6.4,7.4-10.1c1.9-3.5,3.4-7.2,4.2-11s1.1-7.7.8-11.7c-.2-1.3-.5-2.8-.9-4.4s-.9-3.2-1.2-4.9c-.1-1.3-.2-2.6-.2-3.9-.1-1.3.1-2.5.7-3.5.1-.2,1.1-.1,2.3.1c1.3.1,2.8.4,3.8.6q.4,0,.7.1.3,0,.4,0q.7.1,1.4.2.6.1,1.3.2q2.1.2,4.2.4t4.2.3q1.6.2,3.3.3q1.6.1,3.3.2q1.1.1,2.4.1q1.2.1,2.4.1q1.4.1,2.7.2q1.3,0,2.6,0h.6.6q3.2,0,6.4-.1t6.4-.4q1.8-.1,3.5-.3q1.7-.1,3.5-.4.2,0,.5,0q.2-.1.5-.1c.9-.1,1.6-.2,2.3-.4.7-.1,1.3-.4,1.9-1.1.7-.6,1.3-1.5,1.8-2.5s1-2,1.4-2.8q1.6-2.7,3.3-5.4q1.6-2.7,3.2-5.4t3.2-5.4q1.6-2.6,3.2-5.3c.3-.6,1.5-3,2.7-5.3c1.3-2.3,2.6-4.5,3.1-4.5q.1-.3.3-.5t.5-.3.5,0q.3.1.6.2c1.3.7,2.3,1.9,2.9,3.2.7,1.3.9,2.8.6,4.3-.1.7-.3,1.5-.4,2s-.2.9-.2.9c-3.7,6.9-6.4,14.7-7.8,22.8-1.4,8-1.6,16.2-.5,23.9Z",
    fill: "url(#eIoXAxwJW5C70-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2265.3,954c-2.7,6.9-6.5,12.8-11.3,18-4.7,5.1-10.4,9.5-16.7,13.3-9.6,5.8-20.6,8.8-31,9.9-10.4,1.2-20.3.6-27.4-1-4.4-.9-8.9-2.3-13.2-4.1s-8.4-4-12-6.5c-2.8-2-5.4-4.3-7.7-6.5-2.3-2.3-4.2-4.5-5.5-6.3-.9-1.4-2.3-3.5-3.6-5.7-1.3-2.1-2.5-4.3-3.1-5.9-.1-.4-.8-2.2-1.5-3.9-.6-1.7-1.3-3.4-1.1-3.5q2.2-1.7,4.4-2.9q2.2-1.1,4.2-1.8c1.4-.6,2.4-1,3.6-1.3c1.1-.4,2.3-.6,3.9-.9.4,2.7,1.7,5,3.2,7.2c1.5,2.3,3.4,4.3,4.9,6.4q1.7,2,3.5,3.7q1.9,1.7,4,3.1c3.6,2.3,7.4,3.9,11.2,5.1c3.9,1.2,7.9,2,12.1,2.6c4.2.7,8.5,1.1,12.8,1.1c4.3.1,8.6-.3,12.9-1.2c4.7-.9,9.2-2.5,13.4-4.7c4.2-2.1,8.2-4.7,11.9-7.8c1.8-1.5,3.4-3.2,4.8-5.1s2.5-3.9,3.3-6.1c.6-1.6,1.2-3.5,1.7-5.5.4-1.9.5-3.8,0-5.5.6.2,1.6.5,2.6.9c1,.3,1.9.6,2.5.9c2.6,1.3,4.4,2.3,6,3.4s3,2.3,4.8,3.9c.4.3,1.1.7,1.7,1.1.7.5,1.4,1,1.7,1.5q0,0,0,.1.1.1.1.2c.1.4-.1,1.2-.4,1.9-.2.7-.6,1.5-.7,1.9Z",
    fill: "#f05960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2265.3,954c-2.7,6.9-6.5,13-11.3,18.3-4.7,5.4-10.4,9.9-16.7,13.7-9.6,5.8-20.6,8.8-31,10-10.4,1.1-20.3.5-27.4-1-4.4-.9-8.9-2.3-13.2-4.1s-8.4-4-12-6.6c-2.8-2-5.4-4.3-7.7-6.5-2.3-2.3-4.2-4.5-5.5-6.3q-2.3-3.2-4.4-6.6t-3.9-6.9c-.3-.7-2-4.3-3.4-7.8-1.5-3.5-2.7-6.9-2.1-7.2q4.5-2.8,9.4-5q4.9-2.1,10-3.6.6,3.4,1.5,6.7t2.1,6.5q.6,1.6,1.4,3.2.7,1.6,1.5,3.2c.3.7,1.1,1.9,1.7,2.8s1.1,1.7,1.1,1.7q1.4,3.4,3.1,6.5q1.8,3.1,4.1,5.7c4,4.5,9.1,7.8,14.6,10.2c5.6,2.4,11.6,3.7,17.5,4.4c5.1.6,10.4.4,15.6-.2c5.2-.7,10.4-1.8,15.4-3.2c2.4-.8,4.9-1.6,7.4-2.6c2.4-.9,4.7-1.9,7-3.1c1.9-.9,4-2,6.1-3.2c2-1.2,4-2.5,5.6-4q3-2.7,5.5-5.7q2.6-3.1,4.8-6.5q1.1-1.7,2.1-3.5q1-1.7,2.1-3.4q0,0,0,.1.1.1.1.2c.1.4-.1,1.2-.4,1.9-.2.7-.6,1.5-.7,1.9Z",
    fill: "url(#eIoXAxwJW5C72-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220.1,974.2c5.2-2.9,10.4-6,15.1-9.7c4.8-3.6,9.2-7.7,12.5-12.6.5-.7,1-1.3,1.5-1.9.5-.7,1.1-1.3,1.5-2q.3-.4.7-.9.3-.4.7-.9.4-.4.9-.7t1-.5q.7-.1,1.4,0q.6.1,1.2.3.7.1,1.3.4.7.3,1.1.8c.4.4.7.9.9,1.5.1.5.1,1.1.1,1.7-.1,2.2-.8,4.2-1.9,6.2-1,1.9-2.4,3.7-3.8,5.5-3.1,3.8-6.8,7-10.8,9.6-4.1,2.6-8.5,4.7-13,6.3q-3.5,1.2-7,2.1-3.5,1-7.1,1.6c-1.5.3-4.8.5-7.7.6s-5.5.1-5.5.1s1.4-.4,2.9-1c1.5-.5,3.1-1,3.6-1.2q2.6-1.2,5.1-2.5t4.9-2.6q.1-.1.2-.1.1-.1.2-.1Z",
    fill: "url(#eIoXAxwJW5C73-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2247.5,956.8c1.8-.8,2.8-2.7,3.9-4.6s2.2-3.6,4.1-4c1.3-.2,1.6.7,1.6,1.7-.1,1-.5,2.3-.7,2.8-.5,1-1.1,2.1-1.9,3.1-.9,1-1.8,1.9-2.9,2.4-1.4.8-2.7.8-3.4.4-.8-.4-1.1-1.2-.7-1.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C75",
    transform: "matrix(.984808-.173648 0.173648 0.984808-103.97714 396.140773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2277.3,822.9q-3.1-.6-6.1-.3-3.1.3-6,1.3-1.5.5-2.9,1.2-1.4.6-2.7,1.3-.2.1-.4.2t-.4.2q-.3.1-.5.3-.3.1-.6.2q0,.1-.1.1t-.1.1q-.9.4-1.8.9-.8.5-1.7,1.1-.1.1-.3.2-.1.1-.3.1c-1.7,1.3-3.2,2.7-4.6,4.3s-2.5,3.4-3.4,5.3q-.4.8-.7,1.7t-.5,1.8q-.6,1.8-.8,3.6-.1,1.9.1,3.7.1,1.2.5,2.3.5,1.1,1.1,2.1.6.9,1.3,1.6t1.4,1.4q.7.5,1.3,1q.7.4,1.4.8t1.4.7t1.5.5q.7.3,1.5.5.7.1,1.5.2t1.6.2q.7,0,1.5,0t1.6,0q.8-.1,1.6-.2t1.6-.3q.9-.2,1.6-.4.9-.2,1.6-.5.8-.3,1.6-.6t1.6-.6q.7-.4,1.5-.8.7-.4,1.5-.8.7-.4,1.4-.9t1.4-1t1.3-1q.7-.5,1.3-1.1.6-.5,1.2-1.1t1.1-1.2t1.1-1.2q.4-.6.9-1.3.4-.6.9-1.3.3-.7.7-1.3.3-.7.6-1.4.3-.6.5-1.1.2-.6.3-1.2c1.1-3.9,1-8.3-.4-12-1.4-3.6-4.2-6.5-8.7-7.3Z",
    fill: "url(#eIoXAxwJW5C76-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2278,783.5l-.3.7-.2.8c-1.6,4.6-3.7,9-5.9,13.2-2.1,4.3-4.5,8.5-6.6,12.9q-1.9,4-3.7,8.1-1.8,4-3.5,8.1-1.2,2.7-2.3,5.4-1.2,2.7-2.3,5.4-.5,1-.9,2-.4,1.1-.8,2.1v.1q-.7,1.6-1.4,3.3-.7,1.6-1.4,3.3t-1.4,3.3q-.7,1.7-1.3,3.4v.1c-.1.2-.2.3-.3.4s-.1.2-.3.5v-.1q0-.1,0-.1t0-.1.1-.1q0,0-.1-.1c-.2-.3-.5-.5-.9-.6s-.7-.2-.9-.4q-.3-.3-.6-.5-.2-.3-.5-.5-.2-.2-.5-.5-.3-.2-.6-.4c0-.1-.3-.3-.6-.5-.3-.3-.7-.6-.9-.8q-.1,0-.1,0q0-.1,0-.1-.1,0-.2-.1q0-.1-.1-.2-.8,1.7-1.6,3.2-.7,1.6-1.5,3.3c-1.9,3.8-3.8,7.6-5.8,11.4s-4,7.5-5.9,11.3c-1.1,2.2-2.2,4.5-3.6,6.7-1.3,2.1-2.8,4-4.5,5.5-.4.4-1,.9-1.8,1.4-.7.6-1.5,1.1-2.3,1.5-1.3.6-2.6,1.2-3.9,1.6-1.4.5-2.8.9-4.2,1.4-3.8,1.1-7.6,2.2-11.4,3.2-3.9,1-7.7,1.9-11.6,2.6-2.6.4-5.3.9-8,1.2-2.6.4-5.3.6-8,.8q-2.1.1-4.1.1-2.1,0-4.2-.1c-.9,0-3.7-.5-6.6-1.1-2.9-.7-5.8-1.4-6.9-1.7q-1.5-.5-3-1.2-1.5-.6-3.1-1.4l-.6-.3-.6-.3q-.1-.1-.2-.1-.1-.1-.1-.2c-.9-.4-1.5-.8-2-1.2s-.9-.8-1.2-1.1h-.1c-.6-.4-1.1-.8-1.5-1.3-.5-.4-.9-.9-1.3-1.4-1.1-1.3-1.9-2.7-2.5-4.2-.7-1.5-1.3-3-1.9-4.5q-1.2-3-2.3-6t-2-6.1q-.3-.8-.5-1.6-.3-.9-.5-1.7-.3-1-.6-1.9-.2-1-.4-2-1.2-4.3-2.1-8.7-.8-4.4-1.4-8.9c-.8-5.4-1.4-10.7-1.1-15.8s1.5-10.1,4.3-15.1c2-3.4,4.1-7,5.9-10.7c1.9-3.7,3.5-7.5,4.8-11.4q.4-1.3.7-2.5t.5-2.5q.1-.3.1-.5.1-.3.1-.5.2-.6.2-1.2.1-.6.2-1.1q0,0,0,0q.1,0,.1,0v-.1-.2c.4-2.6.6-5.2.8-7.8.3-2.6.5-5.2.8-7.8v-.1q0-.9.1-1.7.2-.8.3-1.7q0-.1,0-.1t0-.1q.3-2.1.6-4.1.4-2.1,1-4.1.4-1.5.9-2.9.5-1.5,1.1-2.9c2.4-5.1,5.4-10.4,8.9-15.4c3.5-5.1,7.6-9.8,12.1-13.6v-.1q.8-.7,1.6-1.4.8-.6,1.7-1.2h.1q0-.1,0-.1.1,0,.1,0q.4-.4.9-.7t.9-.5q.6-.2,1.1-.4t1.1-.3q1.1-.4,2.3-.5q1.3-.1,2.5-.1q1,.1,2,.2t2.1.2q.5.1,1,.2.5.2,1,.3.6.1,1.2.3.6.1,1.2.3.7.2,1.5.4.7.2,1.3.4.3.1.5.1.3.1.5.2q1.6.5,3.1.9q1.5.5,2.8.8.2,0,.4.1.2,0,.3.1q4.9,1.3,9.8,2.7q4.8,1.4,9.7,2.9q2.4.7,4.8,1.4t4.8,1.5q2.4.7,4.9,1.5q2.4.7,4.8,1.5q1.3.5,2.7,1q1.3.5,2.7,1q2.6,1.1,5.1,2.3q2.6,1.2,5,2.4q1.3.7,2.6,1.4q1.3.6,2.5,1.3q1.7.9,3.4,1.8q1.7.8,3.3,1.7q1.2.6,2.1,1.1q1,.5,1.7,1q.5.4,1.1.7.5.3.9.7.7.5,1.4.9.7.5,1.3,1q1.2,1,2.5,2.2q1.2,1.1,2.4,2.3h.1q1.7,1.7,3.1,3.7q1.5,2,2.8,4.1.2.4.4.9.3.4.5.8.3.4.5.9.3.4.5.9c1,2.5,1.8,4.4,2.1,6.3.3,2,0,4-.8,6.6Z",
    fill: "url(#eIoXAxwJW5C77-fill)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2276.4,770.5q-.2-.4-.4-.9-.2-.4-.4-.8t-.4-.8q-.3-.5-.5-.9-1.2-2.1-2.7-4.1t-3.2-3.7q-1.2-1.2-2.4-2.3-1.3-1.2-2.5-2.2-.6-.5-1.3-1-.7-.4-1.4-.9-.4-.4-.9-.7-.6-.3-1.1-.7-.7-.5-1.7-1-.9-.5-2.1-1.1-1.6-.9-3.3-1.7-1.7-.9-3.4-1.8c-3.3-1.8-6.7-3.6-10.2-5.2s-7-3.1-10.7-4.3q-4.7-1.6-9.5-3-4.7-1.5-9.5-2.8-4.9-1.5-9.7-2.9-4.9-1.4-9.8-2.7-1.6-.5-3.5-1-1.9-.6-4.1-1.2-.6-.2-1.3-.4-.8-.2-1.5-.4-.6-.2-1.2-.3-.6-.2-1.2-.3-.5-.1-1-.3-.5-.1-1-.2-1.1-.1-2.1-.2t-2-.2c-1.6,0-3.2.1-4.7.5s-2.9,1-4.2,2q0,0-.1,0q0,0,0,.1-.9.6-1.7,1.2-.8.7-1.6,1.4c.9,1.1,2,2.2,3.1,3.3c1.1,1,2.1,1.9,2.6,2.5c1.8,1.9,3.8,3.6,5.9,5.3s4.3,3.2,6.5,4.7c4,2.8,8.1,5.3,12.4,7.5c4.3,2.3,8.6,4.4,13,6.3c4.4,1.8,8.8,3.4,13.2,4.8c4.4,1.5,8.9,2.9,13.3,4.3c1.7.5,3.8,1.1,5.9,1.8s4,1.6,5.3,2.7c1.9,1.7,2.7,3.8,3.1,6c.4,2.3.3,4.6.4,6.8.2,3.5-.1,7-.6,10.4s-1.3,6.8-2.2,10.2q-.3,1.5-.7,2.9t-.8,2.9q0,.1,0,.1t0,0q-.2.7-.4,1.5t-.4,1.5v.1q-.8,2.9-1.6,5.8t-1.7,5.8q0,0,0,.1q0,0-.1,0-1.5,5.1-3.3,10-1.9,4.9-4.1,9.6c-5.1,11.1-10.6,21.7-17.8,30.9s-16,17-27.7,22.2q-2.3,1-4.5,1.8-2.3.8-4.6,1.4c-4.8,1.3-9.8,2.1-14.8,2.4s-10.1.2-15-.3c-1.7-.2-4.1-1-6.2-1.7-2-.7-3.6-1.3-3.6-1.3.3.3.7.7,1.2,1.1.5.3,1.2.8,2.1,1.2q0,.1.1.2.1,0,.2.1l.6.3.6.3q1.6.8,3.1,1.4q1.5.7,3,1.2c1.1.3,4,1,6.9,1.7c2.9.6,5.7,1.1,6.6,1.1q2.1.1,4.2.1q2,0,4.1-.1c2.7-.2,5.4-.4,8-.8c2.7-.3,5.4-.8,8-1.2c3.9-.7,7.7-1.6,11.6-2.6c3.8-1,7.6-2.1,11.4-3.2c1.4-.5,2.8-.9,4.2-1.4c1.3-.4,2.6-1,3.9-1.6c3-1.5,5.4-3.8,7.3-6.5c1.9-2.6,3.5-5.6,4.9-8.6c1.9-3.8,3.9-7.5,5.9-11.3c1.9-3.7,3.9-7.5,5.8-11.4q.7-1.6,1.5-3.2t1.6-3.3c.1.2.5.6,1,.9.4.4.8.7.9.8q.6.4,1.1.9t1.1,1c.1.2.4.5.7.8.3.4.6.7.8,1.1q.2-.4.4-.7.1-.4.2-.8.8-1.6,1.5-3.3t1.4-3.3q.7-1.7,1.4-3.4t1.3-3.4v-.1q.4-1.1.8-2q.4-1,.8-2q1.2-2.6,2.3-5.3q1.1-2.6,2.3-5.2q1.7-4.2,3.5-8.3t3.8-8.1c2.2-4.4,4.4-8.7,6.6-13s4.2-8.6,5.9-13.2l.3-.8.2-.8c.8-2.5,1-4.5.8-6.4-.3-2-1.1-3.9-2.2-6.4Z",
    fill: "url(#eIoXAxwJW5C79-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.000001)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2196.2,795.3c-2,2.9-4.2,6-5.9,9.4-1.7,3.3-3,6.9-3.3,10.4-.1,1-.1,2-.1,2.9s.1,1.9.5,2.9c.7,1.8,2,3.2,3.5,4.4s3.2,2.2,4.7,3.5q1.4,1.1,2.8,2.2t2.9,2c5.6,3.3,12.1,3.3,18,1.4s11.2-5.7,14.3-10.3c1.6-2.3,3.9-6.6,4.8-10.8.8-4.1.2-8.2-4-10.1-.9-.3-1.7-.8-2.5-1.2s-1.7-.8-2.6-1.1q-2.5-.9-5.2-1.3-2.7-.5-5.3-.7c-2.2-.2-4.4-.1-6.5-.2-2.2,0-4.3,0-6.5-.1-.9-.1-1.6-.2-2.3-.5-.7-.2-1.4-.6-2-1.2-.5-.5-1.1-1.3-1.7-2-.6-.6-1.3-1.2-2.1-1-.3,0-.6.3-.9.6-.3.2-.6.6-.6.8Z",
    transform: "translate(0 0.000001)",
    fill: "url(#eIoXAxwJW5C81-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2186.6,817.5c-.4,1.5-.1,2.8.5,4c.6,1.3,1.5,2.4,2.4,3.6q0,.1.1.2q0,0,.1.1c0,0,.1.1.3.3.1.1.4.3.6.6c1,1,2,1.8,3.1,2.5s2.2,1.3,3.5,1.9q.2,0,.5.1.3.2.5.3q1.3.4,2.5.8q1.3.5,2.6.9q1,.3,2,.5t2,.4q2.1.2,4-.3t3.6-1.5q0,0,0,0t.1,0c1.9-1.2,3.6-2.9,5.2-4.7c1.5-1.8,2.8-3.8,3.8-5.8q.2-.4.4-.8.2-.5.3-.9c.4-1.2.7-2.4.7-3.5-.1-1.2-.6-2.3-1.6-3.3-1.3-1.2-2.7-2.1-4.2-2.8-1.5-.8-3.1-1.4-4.7-2-3.7-1.4-7.7-2.5-11.5-2.5s-7.5,1-10.7,3.8q-1.2,1-2.2,2.1-1.1,1-1.9,2.3c-.3.4-.7.9-.9,1.4-.3.5-.5.9-.7,1.3q-.1.2-.2.5-.1.2-.2.5Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2133.4,768.8q0,.1,0,.1t0,.1c-.5,3.1-.8,6.3-1,9.5-.3,3.2-.5,6.4-1,9.7-.2,1.3-.4,2.8-.7,4.2-.2,1.4-.4,2.9-.5,4.3c0,0,.3.1.7.1.4.1.7.2.7.2s0,.3-.1.5c0,.3-.1.5-.1.5.9,2.8,1.7,5.2,2.9,7.1c1.2,2,3,3.5,5.7,4.7c1.5.6,3.1,1,4.8,1.1c1.7,0,3.3-.4,4.7-1.3c1.3-.9,2.4-2,3.3-3.3s1.6-2.8,2.1-4.3c1.1-3.3,1.7-7.2,1.8-11s-.4-7.7-1.6-11c-.1-.2-.3-.4-.6-.6-.2-.2-.5-.4-.7-.6q-2.1-1.8-4.3-3.4-2.2-1.7-4.6-3.1c-1.5-1-3.4-2.1-5.4-2.9-2.1-.8-4.2-1.2-6.1-.6Z",
    fill: "url(#eIoXAxwJW5C84-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2131.7,789.8q-.2.5-.4,1.1-.1.6-.3,1.2-.1.3-.2.7q0,.5-.1.9-.4,1.5-.6,3-.1,1.5-.1,2.9.1.1.1.3t.1.3c.1,1.3.6,2.4,1.3,3.4.7.9,1.7,1.8,2.6,2.6q.2.2.4.3.1.2.3.4.6.4,1.1.9.6.5,1.4,1c1.5,1.1,3.4,2.1,5.2,2.6c1.9.6,3.8.7,5.5.1q.6-.2,1.2-.6t1.1-1q.1-.1.2-.2q0-.1.1-.1q1.1-1.2,1.6-2.7.6-1.5.8-3.1c.2-1.5.2-3.1,0-4.6-.1-1.5-.5-3-.9-4.4-.8-2.8-2.6-5.2-4.9-7.2s-5-3.5-7.7-4.5c-.9-.4-1.9-.7-2.8-.6-.9,0-1.7.4-2.4,1.4q-.4.7-.8,1.5-.4.7-.8,1.4-.2.8-.5,1.5-.3.8-.5,1.5Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2156,842.7c-1.3,0-2.7,0-4-.1-1.4-.2-2.7-.5-4-.9q-1.7-.7-3.5-1.4-1.7-.7-3.3-1.7-.8-.4-1.5-.9-.7-.6-1.4-1.2c-.2-.2-.4-.4-.5-.4-.2-.1-.3,0-.5.4q-.2.2-.3.5q0,.3-.1.6q0-.3.1-.7q0-.3.3-.7c.3-.5.8-1,1.3-1.4.4-.3.9-.4,1.2-.2.8.8,1.8,1.5,2.6,2.1.9.5,1.6.9,2.1,1.2c1.5.8,3,1.5,4.5,2.1c1.6.5,3.2,1,4.9,1.2q1.2.2,2.3.4q1.2.2,2.4.3c.4.1.8.2,1.4.2.5,0,1.3-.1,2.6-.4q-.6.3-1.3.4-.7.2-1.3.3-1,.2-2,.2-1,.1-2,.1Z",
    fill: "#ffe5d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2137.3,836.5c.2-.4.3-.5.5-.4.1,0,.3.2.5.4q.7.6,1.4,1.2.7.5,1.5.9q1.6,1,3.3,1.7q1.8.7,3.5,1.4c1.3.4,2.6.7,4,.9c1.3.1,2.7.1,4,.1q1,0,2-.1q1,0,2-.2.6-.1,1.3-.3.7-.1,1.3-.4.2-.1.5-.2.2-.1.4-.2.4.4.7.9.4.5.6.9c.6.7,1.2,1.4,1.8,2.1.6.8,1.1,1.5,1.5,2.3.4.7.5,1.4.4,2-.1.5-.4,1.1-.9,1.7q-.3.4-.7.8-.3.5-.7.9c-.2.3-.4.6-.7.8-.3.3-.6.4-1,.4q-.3,0-.5-.1-.3,0-.5-.1-.4-.2-.8-.4-.4-.3-.8-.5-.4-.1-.7-.3-.4-.2-.8-.3c-1.3-.6-2.7-1-4.1-1.1-1.4-.2-2.9-.3-4.3-.3q-2-.1-3.9-.5c-1.3-.2-2.6-.6-3.9-.9-1.2-.4-2.4-.9-3.5-1.6-1-.6-1.9-1.5-2.6-2.7-.7-1-1.2-2.3-1.4-3.5-.2-1.3-.2-2.6.1-3.8q0-.1,0-.2.1-.1.1-.2.1-.3.1-.6.1-.3.3-.5Z",
    fill: "url(#eIoXAxwJW5C87-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2136,839.5q0,1.5.5,3q.4,1.4,1.2,2.7c.4.4.7.9,1.1,1.4.4.4.9.9,1.4,1.1q-.4-.4-.6-.6-.2-.3-.4-.5-.4-.6-.7-1.3-.4-.6-.7-1.3t-.6-1.4q-.2-.7-.3-1.5c-.2-.6-.3-1.3-.2-2c0-.7.1-1.4.4-2.1q.2-.4.4-.8.3-.3.6-.6.6-.4,1.2-.7.7-.3,1.3-.6t1.1-.6q.5-.4,1-.7c.8-.5,1.8-1.3,2.7-2.1.8-.8,1.7-1.7,2.3-2.4.8-1,1.4-1.7,2-2.5s1.1-1.7,1.9-2.7q2.9-4.3,4.8-9q1.8-4.7,2.6-9.9c.3-2.3.4-4.6.2-7-.1-2.3-.4-4.7-.9-7q-.2-.6-.3-1.3-.2-.7-.4-1.3t-.4-1.1q-.3-.4-.6-1q0,0-.1-.1q0,0-.2,0q0,.1,0,.2t0,.2c.6,1.7,1.1,3.5,1.4,5.4.4,1.9.6,3.8.6,5.6c0,1.1,0,2,0,3s-.1,1.9-.2,3c-.3,3-1,6-2,9-1,2.9-2.3,5.7-3.8,8.3-.6,1.1-1.4,2.3-2.2,3.5s-1.7,2.4-2.5,3.3c-1.1,1.3-2,2.4-3,3.4-1.1,1-2.2,1.9-3.7,2.8q-.6.4-1.2.6-.6.3-1.2.5-.5.2-.8.6-.4.3-.7.7c-.4.5-.7,1.1-.9,1.8-.1.7-.2,1.4-.1,2Z",
    fill: "url(#eIoXAxwJW5C88-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2306.2,758.7q-1.1-1.9-2.5-3.6-1.4-1.8-3-3.3c-2.6-2.6-5.5-4.9-8.6-6.9-3.2-1.9-6.6-3.5-10.1-4.3c3.2-4.1,7.7-6.3,12.4-7c4.8-.7,9.8.2,14.3,2.6.1-1.7-1.3-3.5-2.9-5-1.7-1.6-3.6-2.9-4.8-3.8-1.8-1.2-3.7-2.4-5.7-3.3-1.9-.9-4-1.7-6.2-2.1-2.5-.6-5.7-.8-8.8-.5s-6.2,1.1-8.3,2.6c-1.6-1.8-2.9-3.7-4.2-5.6-1.4-2-2.7-3.9-4.4-5.6-1.7-1.9-3.4-3.9-5.1-5.9-1.8-1.9-3.5-3.9-5.4-5.6-3.4-3-6.8-5.8-10.3-8.2-3.6-2.5-7.4-4.7-11.4-6.7-7.2-3.5-14.7-6-22.3-7.4-7.7-1.3-15.5-1.6-23.3-.6-2.6.3-6.4,1-10,2-3.5,1.1-6.8,2.7-8.5,4.9c4.6,3,8.9,6.7,12.6,11c3.7,4.2,6.9,8.9,9.2,13.7-2.5-.8-4.9-1.7-7.3-2.5-2.4-.7-4.8-1.3-7.6-1.6-2.4-.2-4.7-.3-7.1-.3-2.3,0-4.6.1-6.9.5-5,.8-9.4,2.7-13.5,5.3-4,2.7-7.6,6-10.8,9.7c2.8-.8,6.9-1.7,11-2.1s8.2-.3,11.2,1.1q.9.7,1.7,1.4.9.7,1.8,1.5c2.1,1.8,4.2,3.6,6.4,5.3c2.1,1.7,4.4,3.4,6.8,4.8q5.2,3,10.4,5.8q5.2,2.7,10.7,5.1c7.3,3.2,15,5.4,22.8,7.1c7.7,1.8,15.6,3.3,23.3,5.3c3.3.8,7,1.7,10.7,2.2c3.7.6,7.5.9,11,.7q-.2.6-.4,1.2t-.4,1.2q0,.2-.1.3t-.1.2q-.2.7-.5,1.4t-.6,1.4q-.4,1.2-.8,2.4t-.8,2.3c-.5,1.3-1,2.6-1.5,3.9s-.9,2.7-1.2,4v.3.3c.1.4.7.9,1.3,1.4.7.4,1.4.9,1.7,1.1q.9.7,1.8,1.5.8.7,1.6,1.5.1.2.3.3.1.1.2.3q0,.2,0,.5.1.2.1.4-.2,1.6-.6,3.1t-.8,3q-2.8,10.2-6.2,20.1t-7.5,19.7q-.3.7-.6,1.3-.3.7-.6,1.4-.4.8-.7,1.5t-.6,1.5q-.9,1.8-1.7,3.6t-1.6,3.7q-.9,1.7-1.8,3.6-1,1.8-1.9,3.7c0,0,0,.1.1.2s.2.1.2.2q.1.1.2.2q0,.1.1.2.3.1.5.3t.4.4q.9.8,1.8,1.7.8.9,1.6,1.8.2.2.3.3.1.2.3.4c0,0,.1.1.2.2s.2.2.2.2q.1-.5.3-.9.2-.5.4-.9.1-.4.3-.8t.4-.8q.1-.2.2-.5t.2-.6c.3-1,.7-1.9,1.1-2.9s.8-2,1.4-3.3q.5-1.1.9-2.1.5-1.1.9-2.1.4-1.2.9-2.4t1.1-2.5q1.2-2.8,2.5-5.6q1.4-2.7,2.8-5.4q1-1.8,1.9-3.6.9-1.9,1.9-3.7q3.2-6.3,6.6-12.4q3.4-6.2,6.9-12.4c1.3-2.3,2.8-4.5,4.2-6.7c1.5-2.3,3-4.5,4.3-6.7s2.6-4.4,4-6.4c1.5-2,3.1-4,5-5.6c2.2-1.8,4.9-3.3,7.7-4s5.7-.5,8.1,1.1c.1-1.3-.4-2.7-1-4-.7-1.3-1.5-2.6-2.2-3.7Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2159.5,777.5c-1.2.4-2.5-.2-3.6-1-1.1-.9-2.1-2-2.8-2.8-1-1.2-2-2.3-3.1-3.5-1.1-1.1-2.2-2.2-3.4-3.2q-2.3-1.8-4.8-3.4-2.5-1.5-5.2-2.6c-.5-.2-.9-.3-1.4-.4-.5,0-1,0-1.4.2-.5.3-.9.8-1.2,1.4s-.6,1.2-.8,1.7q-.4.9-.7,1.9-.2,1.1-.1,2.1q0,.8.2,1.6.3.8.7,1.5.1.2.3.5.1.2.2.4c.3.3.6.6,1,.9.3.2.7.4,1,.7q.7.5,1.4.9.7.5,1.3.9.8.6,1.6,1.1.8.6,1.6,1.2c1.8,1.3,3.6,2.7,5.4,4.1c1.8,1.3,3.7,2.6,5.5,3.9.8.5,1.8,1.1,2.8,1.5c1,.3,2,.4,2.9-.2q.5-.3.9-.7.3-.4.6-.9c.7-1.1,1-2.4,1.2-3.8.1-1.3.1-2.7-.1-4Z",
    fill: "url(#eIoXAxwJW5C90-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2193.6,788.2c-.3.3.6.8,1.5,1.3.9.4,2,.8,2.1.8c1,.3,2.4.6,3.8.9c1.5.2,2.9.4,3.9.5c1.8.1,3.4.2,4.9.3c1.4.1,2.7.3,4.1.5c3.4.5,6.1,1,8.7,1.5c2.7.5,5.3,1,8.7,1.9.9.2,1.7.4,2.5.7.8.2,1.6.5,2.3,1.1q.8.6,1.4,1.3.7.7,1.4,1.5.7.9,1.3,2q.5,1,1,2.1c.7,1.6,1.2,3.3,1.3,5.1.1,1.7-.1,3.5-.7,5.1-.2.5-.7.1-1.2-.5s-1-1.3-1.1-1.5c-1.3-1.3-3-2.4-4.7-3.2-1.8-.8-3.6-1.5-5.4-2.1q-3.1-1.2-6.3-1.9-3.2-.8-6.5-1.3c-2.2-.4-4-.7-5.7-.9-1.8-.3-3.5-.6-5.8-.9-1.4-.2-2.9-.4-4.4-.6-1.4-.2-2.8-.5-3.7-.8-.9-.4-1.6-.8-2.3-1.3-.6-.5-1.2-1.1-1.8-2q-.5-.7-.7-1.6t-.1-1.9c0-.9,0-2.1.3-3.2.2-1.1.5-2.1,1.2-2.9Z",
    fill: "url(#eIoXAxwJW5C91-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2254.2,853.2c.7.6,1.8.9,2.9,1.1s2.3.2,3.1.2q1.5,0,3.1-.4q1.5-.3,2.9-1c1.5-.6,3.1-1.8,4.4-3.2c1.4-1.4,2.5-3,3.1-4.8q.5-1.2.6-2.5.1-1.2-.3-2.5c-.2-1-.8-2.1-1.6-3-.7-1-1.6-1.9-2.5-2.5-1.7-1.1-3.5-1.7-5.3-1.6-1.9,0-3.7.5-5.5,1.5q-1,.5-1.9,1.1t-1.7,1.3q-.1.1-.3.2-.1.1-.2.3-.4.3-.6.5-.3.3-.7.6c1.1-.7,2.3-1.2,3.5-1.4c1.3-.2,2.5-.1,3.6.3q.8.4,1.5,1q.7.7,1.1,1.7c.9,1.8.7,3.8-.1,5.7-.8,1.8-2.1,3.4-3.5,4.6-.9.8-1.7,1.3-2.6,1.8-.9.4-1.9.7-3,1Z",
    fill: "#910f2e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2166.4,844.8q.4.4.7.8.4.4.7.8.2.4.5.7.3.4.5.8c.3.6.3,1.2.2,1.8-.2.6-.5,1.2-.9,1.7q-.6.9-1.4,1.5-.7.7-1.6,1.2c0,0,.4-.5.9-1c.5-.6,1-1.3,1.4-1.8.2-.3.4-.7.6-1.2.2-.4.3-.9.3-1.2q0-.4-.3-.8-.2-.4-.5-.7-.6-.8-1.2-1.6t-1.2-1.5q-.3-.4-.6-.8-.2-.4-.5-.8c-.2-.2-.4-.7-.5-1-.1-.4-.2-.6,0-.4q.6.9,1.4,1.7.7.9,1.5,1.8Z",
    fill: "#cc5e48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2149.8,851.2c.1-.3.4-.5.8-.7.4-.1.8-.2,1-.3q.7-.1,1.4-.2.7,0,1.4-.1c.9,0,1.9-.1,2.8,0c1,.1,1.9.3,2.7.9.4.2.6.4.7.7s0,.6-.4.9c-.3.3-.6.4-1,.5-.4,0-.8,0-1.1,0q-1.1-.1-2.1-.3-1-.3-2-.6t-2-.5q-1-.3-2.2-.3Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2224.3,821q-.2.5-.4.9-.1.4-.4.9-.1.3-.3.6-.1.3-.3.7-.2.2-.3.4-.2.3-.3.6-.3.4-.6.8-.3.5-.7.9-.3.4-.6.8t-.7.8q-.2.3-.5.5-.2.3-.5.6-.6.6-1.2,1.2-.6.7-1.3,1.2-1.3,1.1-2.8,1.9t-3.2,1.1q-.5.1-1,.1t-1,0h-.6-.7q-.8-.1-1.7-.3t-1.8-.4q-.1,0-.3-.1-.1,0-.2,0l-.3-.1-.2-.1q-.1,0-.2-.1q0,0-.1-.1-.2,0-.3,0-.1-.1-.3-.1-.9-.4-1.9-.7-.9-.3-1.8-.6-.3-.1-.5-.2-.3-.1-.5-.2c-1.4-.6-2.5-1.2-3.5-1.9-1.1-.7-2.1-1.5-3.2-2.5-.2-.3-.4-.5-.6-.6-.1-.2-.2-.3-.2-.3q-.1,0-.2-.1q0-.1-.1-.2c-.8-1.2-1.8-2.3-2.4-3.5s-.9-2.6-.4-4.1l.1-.2.1-.2.1-.3.1-.2q.3-.8.7-1.5.3-.7.9-1.3.8-1.2,1.8-2.3q1.1-1.1,2.2-2.1c3.3-2.8,7-3.8,10.8-3.8c3.8.1,7.7,1.2,11.5,2.5c1.6.6,3.2,1.2,4.7,2s2.9,1.7,4.2,2.9c1,1,1.5,2.1,1.6,3.2c0,1.1-.3,2.3-.7,3.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2186.4,818.4q3.5-.1,6.9.1t6.8.9q1.9.4,3.8.9q1.9.4,3.7,1q.8.1,1.5.3t1.4.5q2.7,1,5.3,2.2t5.2,2.5q.8-1,1.4-2q.7-1,1.2-2q.2-.5.3-.9.2-.4.4-.9c.4-1.1.7-2.3.6-3.5c0-1.1-.5-2.3-1.5-3.2-1.3-1.2-2.7-2.1-4.2-2.9s-3.1-1.4-4.7-2c-3.8-1.4-7.7-2.4-11.5-2.5-3.8,0-7.5,1-10.7,3.8q-1.2,1-2.2,2.1-1.1,1.1-1.9,2.3-.5.6-.9,1.3t-.7,1.5c0,0-.1.1-.1.2s-.1.2-.1.3Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2152.6,804q0,.3,0,.5q0,.3,0,.5v.2.1q-.1.3-.1.6-.1.3-.2.6-.2,1.1-.6,2.1-.5,1-1.3,1.9q0,.1,0,.2t-.1.1q-.2.2-.3.4-.1.1-.3.3-.1.1-.1.2-.1.1-.2.2-.1,0-.2.1q0,0-.2.1-.2.2-.6.4t-.9.4q-.4.2-.8.3t-.8.1q-1.2.1-2.4-.1t-2.4-.7q-.2-.1-.4-.1-.2-.1-.3-.2-.1,0-.2,0q0-.1,0-.1-.1-.1-.2-.1-.2,0-.3-.1t-.4-.2q-.2-.1-.4-.2-.1-.1-.2-.2-.1,0-.2-.1-.4-.2-.7-.4-.4-.2-.7-.4-.1,0-.1-.1-.1,0-.2-.1-.1.1-.1.1t0-.1q-.3-.3-.7-.5-.4-.3-.7-.5-.1-.1-.1-.2-.1,0-.2,0-.1-.2-.3-.4-.2-.1-.4-.3-.1-.1-.3-.3-.2-.1-.4-.3c-.7-.7-1.5-1.3-2.1-2.1-.6-.7-1.1-1.6-1.4-2.5q-.2-.8-.3-1.7-.1-.8-.1-1.6q0-.4.1-.8t.1-.8c0-.2.1-.7.2-1.1c0-.5.1-.8.1-.8v-.1l.1-.2v-.3-.3q.1-.8.3-1.6t.4-1.7q0-.2.1-.4t.1-.4q.2-.8.5-1.5.3-.8.6-1.5.2-.5.5-1.1.3-.5.5-1q.2-.2.3-.4t.3-.5c.6-.9,1.4-1.3,2.3-1.4.9,0,1.9.3,2.8.6c2.5.9,4.9,2.3,7,4c2.2,1.7,3.9,3.8,5,6.2q.1.2.2.4t.2.5q.1,0,.1.1q0,.2,0,.3.1.1.1.2q0,0,0,.1.1.2.2.3q0,.2.1.4q0,.2.1.5.1.2.1.5.1.1.1.3t0,.3q.1.3.2.6q0,.3,0,.6q0,.1,0,.2.1.1.1.2q0,.2,0,.3.1.2.1.3.1.8.1,1.6t-.1,1.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2131.2,791.3q0,.2-.1.4q0,.3-.1.5-.2.8-.4,1.6t-.3,1.6l-.1.5v.4q.8.4,1.7.9.8.4,1.7.8q2.2,1.1,4.3,2.3t4.2,2.6q1,.7,1.9,1.4.9.6,1.7,1.4q1.3,1.1,2.5,2.4t2.1,2.7q1-1.2,1.5-2.6.6-1.4.7-2.9c.2-1.2.2-2.5.2-3.7-.1-1.2-.3-2.4-.6-3.6-1.5-1.8-3.3-3.5-5.2-4.9-1.9-1.5-3.9-2.7-6-3.8-1.1-.5-2.4-1.1-3.6-1.7-1.3-.5-2.6-1-3.9-1.4q-.3.5-.6,1.1-.3.5-.5,1-.3.8-.6,1.5t-.5,1.5Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2299.3,706.4c-3.3-.2-5.9-.2-8.2.2-2.4.5-4.5,1.3-7,2.6-2.4,1.2-4.8,2.8-6.7,4.7s-3.5,4.2-4.3,6.8c.6-1.1,1.6-2.1,2.8-3c1.2-.8,2.4-1.6,3.4-2.4q1.6-1.3,3.2-2.3q1.7-1,3.4-2c2.2-1.3,4.3-2.4,6.5-3.1c2.2-.8,4.5-1.2,6.9-1.5Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2280.5,832.6c1-3.4-.6-5.9-3.3-7.4-2.6-1.4-6.1-1.8-8.8-1-.8.3-1.6.5-2.3.8-.8.3-1.6.7-2.2,1.2-.6.4-1.2,1.1-1.4,1.8-.3.7-.3,1.4.5,2c.5.5,1.3.7,2.2.8.8.2,1.7.3,2.3.6q1.3.4,2.5,1.1q1.2.6,2.3,1.3c.8.5,1.5.8,2.2,1c.7.3,1.5.3,2.4.2.7-.1,1.6-.3,2.3-.7s1.2-1,1.3-1.7Z",
    fill: "url(#eIoXAxwJW5C101-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2253.7,838.5c1.1-.7,2.3-1.2,3.5-1.4c1.3-.2,2.5-.1,3.6.3c1-.1,2,.6,2.7,1.5s1.2,2.1,1.5,3c.3,1,.4,2.2.3,3.3-.1,1.2-.4,2.4-1,3.3-.3.8-.9,1.9-1.7,2.8-.8,1-1.7,1.8-2.7,1.9c1.7,0,3.4-.4,5-1.1s3.1-1.6,4.3-2.7c.9-.9,1.7-1.9,2.2-3.1.6-1.2.9-2.5,1-3.8.2-1.6-.2-3-1-4.2-.7-1.2-1.9-2.2-3.3-2.9-2.1-.9-4.3-1.2-6.5-.9-2.1.3-4.2,1.2-6.1,2.4q-.1.1-.3.2-.1.1-.2.3-.4.3-.6.5-.3.3-.7.6Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2252.5,708q.1.4-.2.8t-.9.8c-.7.4-1.5.9-2.3,1.3s-1.6.7-2.4.9c-1.6.4-3.2.5-4.8.6s-3.3.1-4.9.1c-.7,0-1.5-.1-2.3-.2-.7,0-1.5-.2-2.1-.6-.6-.2-1.1-.6-1.6-1.1-.4-.4-.9-.9-1.4-1.3-2.1-2-4.2-3.9-6.5-5.7-2.2-1.9-4.4-3.6-6.8-5.2s-5-3.1-7.6-4.2c-2.6-1.2-5.4-2-8.2-2.5c4.2,1.4,8.2,3.6,11.8,6.2c3.5,2.7,6.7,5.9,9.3,9.5q.3.5.6.9.2.5.2,1c0,1.7-1.8,1.8-3.8,1.4s-4.2-1.3-4.8-1.7c-1.6-.8-3-1.9-4.4-2.9-1.4-1.1-2.7-2.2-4.1-3.3-4-3-8-5.9-12.2-8.5s-8.5-4.9-13.2-6.8c.3.1.8.1,1.4,0c.5,0,1-.1,1.3-.1q.9,0,1.7,0q.9.1,1.7.1q1.7.1,3.3.2q1.7.1,3.3.4c3.7.5,7.3,1.2,10.9,1.9c3.6.8,7.1,1.6,10.7,2.7q-3.2-1.8-6.5-3.2-3.4-1.4-6.9-2.4-1.7-.5-3.5-1t-3.6-.9q-.4-.1-.9-.2-.4-.2-.9-.3c-.2,0-.5,0-.8-.1s-.6-.1-.8-.2c-.3-.3-.2-.5,0-.6.3-.2.7-.3.9-.3q.9-.2,1.8-.3t1.7-.2q1.8-.1,3.6-.1q1.8.1,3.5.3q2.1.2,4.1.5t4,.7c4.1.8,8.1,1.6,12,2.8s7.6,2.8,11.3,4.8q5.1,2.8,9.7,6.4q4.6,3.5,8.6,7.8.5.5.7.9.3.5.3.9Z",
    fill: "url(#eIoXAxwJW5C104-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2188.2,814.8c-.8,1.1-1.2,1.9-1.5,2.5-.2.6-.3.9-.3.9q.3-.3.6-.5.3-.3.6-.4q1-.7,2.1-1.3q1-.6,2.1-1.1c.9-.4,1.8-.7,2.6-.8.9-.2,1.7-.2,2.8-.1c2.5,0,5,.5,7.5,1.1s4.9,1.4,7.3,2.2c.6.1,3.6,1,6.6,1.9c2.9.9,5.7,1.7,5.7,1.7.5-1.1.8-2.4.7-3.5-.1-1.2-.5-2.3-1.6-3.3-1.2-1.2-2.7-2.1-4.2-2.9-1.5-.7-3-1.4-4.7-2-3.7-1.3-7.7-2.4-11.5-2.4-3.8-.1-7.5,1-10.7,3.8-.8.7-1.5,1.3-2.2,2s-1.4,1.4-1.9,2.2Z",
    fill: "url(#eIoXAxwJW5C105-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2137.8,867.1q.2-.2.4-.3t.4-.2q.1-.1.3-.2t.3-.3q.4-.3.7-.6.2-.3.5-.7.2-.4.4-.8.2-.5.3-.9c.1-.7,0-1.3-.2-1.9q-.3-1-.8-1.8-.3-.4-.6-.8-.4-.4-.8-.8-.1-.2-.4-.3-.2-.2-.4-.3c-.1-.1-.3-.2-.5-.3s-.3-.2-.3-.2.3.6.7,1.4.8,1.8,1,2.4q.3,1.2.3,2.3t-.3,2.2c-.1.4-.2.8-.4,1.1-.1.4-.3.7-.6,1Z",
    fill: "url(#eIoXAxwJW5C106-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2222.9,824.1q-.2.2-.3.4-.2.3-.3.6-.3.4-.6.8-.3.5-.7.9-.3.4-.6.8t-.7.8q-.2.3-.5.5-.2.3-.5.6-.6.6-1.2,1.2-.6.7-1.3,1.2-1.3,1.1-2.8,1.9t-3.2,1.1q-.5.1-1,.1t-1,0h-.6-.7q-.8-.1-1.7-.3t-1.8-.4q-.1,0-.3-.1-.1,0-.2,0l-.3-.1-.2-.1q-.1,0-.2-.1q0,0-.1-.1-.5-.9-.7-1.9-.2-1.1-.2-2.2c0-3.2,1.3-6.1,3.4-8.2s5-3.4,8.2-3.4c2.2,0,4.2.6,6,1.7c1.7,1,3.1,2.5,4.1,4.3Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2222.3,825.1q-.3.4-.6.8-.3.5-.7.9-.3.4-.6.8t-.7.8q-.2.3-.5.5-.2.3-.5.6-.6.6-1.2,1.2-.6.7-1.3,1.2-1.3,1.1-2.8,1.9t-3.2,1.1q-.5.1-1,.1t-1,0h-.6-.7q-.8-.1-1.7-.3t-1.8-.4q-.6-1-.9-2.2t-.3-2.4c0-1.8.5-3.5,1.3-5c.8-1.4,1.9-2.7,3.2-3.6q1.3-1,2.9-1.5q1.5-.5,3.2-.5c2.1,0,4,.6,5.7,1.7c1.6,1,2.9,2.5,3.8,4.3Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2222.3,825.1q-.3.4-.6.8-.3.5-.7.9-2.6-1.2-5.2-2.4t-5.3-2.3c-.5-.2-1.4-.4-2.2-.6-.7-.2-1.4-.4-1.6-.4q1.3-1,2.9-1.5q1.5-.5,3.2-.5c2.1,0,4,.6,5.7,1.7c1.6,1,2.9,2.5,3.8,4.3Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2219.7,828.4q-.2.3-.5.5-.2.3-.5.6-.6.6-1.2,1.2-.6.7-1.3,1.2-1.3,1.1-2.8,1.9t-3.2,1.1q-.5.1-1,.1t-1,0q-1.1-1-1.8-2.4-.6-1.3-.6-2.9c0-2,.7-3.7,2-5s3.1-2,5-2c1.1,0,2.1.2,3,.6s1.7,1.1,2.3,1.9c.4.3.8,1.1,1.1,1.8s.5,1.3.5,1.4Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2207,823.1c-.3.3-.5.7-.5,1.1s.2.8.5,1.1.7.4,1.1.4c.3,0,.7-.1,1-.4s.5-.7.5-1.1-.1-.8-.4-1.1-.7-.4-1.1-.4-.8.1-1.1.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2186.4,818.2c0,0,.5-.3,1-.6s1.1-.7,1.3-.7q.8-.4,1.7-.7.8-.3,1.8-.5c1.9-.5,3.9-.6,6-.4c2,.2,4,.7,5.9,1.3c1.1.4,2.1.7,3,1c1,.4,1.9.7,2.9,1.2c1.1.5,2.2,1,3.3,1.6c1.1.5,2.2,1,3.2,1.5q1.6.8,3.2,1.4t3.2,1c1.1.3,2.3-.2,3.2-.9c1-.6,1.7-1.6,1.9-2.2c0,0-.5,0-1-.1-.6-.1-1.4-.2-2-.4-1-.3-1.5-.5-2-.7s-1.1-.4-2.3-1q-3.5-1.4-6.9-2.7-3.5-1.2-7.1-2.1c-2.4-.6-4.8-1.1-7.2-1.2-2.4-.2-4.8,0-7,1q-.8.3-1.5.6-.7.4-1.3.8c-.4.3-1.3,1-2,1.6s-1.3,1.2-1.3,1.2Z",
    fill: "#020102"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2152.6,804q0,.3,0,.5q0,.3,0,.5v.2.1q-.1.3-.1.6-.1.3-.2.6-.2,1.1-.6,2.1-.5,1-1.3,1.9q0,.1,0,.2t-.1.1q-.2.2-.3.4-.1.1-.3.3-.1.1-.1.2-.1.1-.2.2-.1,0-.2.1q0,0-.2.1-.2.2-.6.4t-.9.4q-.4.2-.8.3t-.8.1q-1.2.1-2.4-.1t-2.4-.7q-.2-.1-.4-.1-.2-.1-.3-.2-.1,0-.2,0q0-.1,0-.1-.1-.1-.2-.1-.2,0-.3-.1t-.4-.2q-.2-.1-.4-.2-.4-.9-.6-1.8-.1-.9-.1-1.8c0-2.7,1-5,2.7-6.7s4.1-2.8,6.7-2.8q1.3,0,2.5.3q1.2.4,2.3,1.1q0,.1,0,.2.1.1.1.2q0,.2,0,.3.1.2.1.3.1.8.1,1.6t-.1,1.6Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2152.6,800.8q.1,1.1.1,2.3q0,1.1-.1,2.2q0,.2-.1.4q0,.2-.1.4q0,0,0,.1t-.1.3q-.1.8-.4,1.6t-.7,1.5q-.2.3-.4.6t-.5.6q-.2.3-.3.4-.1.2-.3.3-.1.1-.1.2-.1.1-.2.2-.1,0-.2.1q0,0-.2.1-.2.2-.6.4t-.9.4q-.4.2-.8.3t-.8.1q-1.2.1-2.4-.1t-2.4-.7q-.2-.1-.4-.1-.2-.1-.3-.2-.1,0-.2,0q0-.1,0-.1-.6-.9-.9-2t-.3-2.2q0-1.7.6-3.1.5-1.4,1.5-2.6c.8-.9,1.8-1.6,2.9-2.1s2.3-.8,3.6-.8q1.4,0,2.6.4q1.3.4,2.4,1.1Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2152.6,800.8q.1,1.1.1,2.3q0,1.1-.1,2.2q0,.2-.1.4q0,.2-.1.4q0,0,0,.1t-.1.3q0,0,0,0q0,.1,0,.1-.2.8-.5,1.5-.2.8-.6,1.5-.2.3-.4.6t-.5.6q-1-1.5-2.1-2.8-1.2-1.2-2.5-2.3-.8-.8-1.7-1.5-.9-.6-1.8-1.3h-.1q-.3-.2-.5-.4-.2-.1-.5-.3c.8-.9,1.8-1.6,2.9-2.1s2.3-.8,3.6-.8q1.4,0,2.6.4q1.3.4,2.4,1.1Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2152.6,805v.2.1q-.1.3-.1.6-.1.3-.2.6c-.2.9-.3,1.6-.6,2.4-.3.7-.9,1.5-1.9,2.6-.5.5-1.1.9-1.8,1.3-.6.3-1.4.5-2.1.5-1.2-.4-2.2-1.1-2.9-2-.7-1-1.1-2.1-1.1-3.4c0-1.6.6-3.1,1.7-4.1c1-1,2.4-1.6,4-1.6q1.3,0,2.5.5q1.1.6,1.9,1.6.2.1.3.3.2.2.3.4Z",
    fill: "#020102"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2132,788.9c.9.6,1.6,1.2,2.4,1.8s1.5,1.2,2.4,1.7q1.3.8,2.7,1.5q1.3.7,2.7,1.5c1.1.7,2.3,1.4,3.4,2.2q1.7,1.2,3.1,2.7.7.7,1.2,1.5.4.8.8,1.7.2.5.4,1q.3.6.5,1.1c0,.1.2.4.4.8.1.3.2.6.2.7q0,.1.2-.4.1-.5.3-1.6c.2-1.5.2-3.1,0-4.6-.1-1.4-.4-2.9-.8-4.3-.9-2.8-2.7-5.2-5-7.3-2.3-2-5-3.6-7.7-4.6-1-.3-2-.5-2.9-.4-1,.1-1.8.5-2.5,1.5-.3.5-.6,1.1-1,1.7-.3.6-.6,1.2-.8,1.8Z",
    fill: "url(#eIoXAxwJW5C120-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2152.2,807.1q-.3-.6-.7-1.1t-.8-1-.8-1-.8-1q-.7-.8-1.4-1.5-.8-.8-1.6-1.4c-1.9-1.4-3.6-2.4-5.4-3.3s-3.6-1.7-5.5-2.5c-.8-.3-1.6-.7-2.3-1.1-.8-.4-1.5-.8-2.1-1.4q-.6-.5-.9-1.2-.3-.6-.4-1.4q0-.3,0-.7-.1-.3,0-.7c0-.1,0-.3,0-.5s0-.4.1-.8c.5.8,1.2,1.4,2,2c.7.6,1.6,1.1,2.4,1.6q1.3.8,2.7,1.6t2.9,1.5c2,1.2,4.2,2.3,6.1,3.7c2,1.4,3.8,3,4.9,5.1.4.7.6,1.3.8,1.8.3.6.4,1.2.6,2.1.1.2.2.5.2.7c0,.3,0,.5,0,.5Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2143.7,813.2q-2.1-.6-4.1-1.6t-3.8-2.2c-1.1-.8-2.3-1.9-3.4-3.1s-2.1-2.5-2.6-3.9q.2,1.3.6,2.4.3,1.1.9,2.2c.4.6.9,1.3,1.6,1.8.6.5,1.3,1,2,1.4.7.5,1.5.9,2.3,1.3s1.7.8,2.5,1q1,.3,1.9.5q1,.2,2.1.2Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2189.3,826.8c0,0,.1.2.2.4.2.3.4.6.6.9c1.3,1.1,2.2,1.9,3.3,2.6c1.1.8,2.3,1.4,3.9,2c1.4.5,3.1,1.1,4.7,1.6c1.7.5,3.4.9,4.9,1.1q2,.2,3.9-.3q1.8-.5,3.3-1.7c-1.4.1-2.9.1-4.1,0s-2.2-.2-2.7-.3q-3.1-.5-6.1-1.4-2.9-.8-5.8-2-1.4-.6-2.8-1.3-1.3-.6-2.6-1.3-.2,0-.3-.1-.2-.1-.4-.2Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2142.6,802.9c-.3.3-.5.7-.5,1.1s.2.8.5,1.1.7.5,1,.5c.4,0,.8-.2,1.1-.5s.5-.7.5-1.1-.1-.8-.4-1.1-.7-.4-1.1-.4-.8.1-1.1.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C126",
    transform: "matrix(.990268-.139173 0.139173 0.990268-132.675467 284.707952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2021.1,1130.9v.1.2c-1.3,8.9-5.2,17.4-11.1,23.8-5.9,6.5-13.9,10.9-23.4,11.8-4.4.4-8.6-.1-12.4-1.6-3.9-1.4-7.4-3.8-10.4-7.1-3.1-3.4-4.8-7.6-5.9-12-1-4.5-1.2-9.2-1.3-13.6-.7-18.8-.1-37.3,1.6-55.7s4.6-36.7,8.5-55c2.1-9.4,4.6-18.6,7.3-27.7c2.8-9.2,5.7-18.3,8.4-27.4c1.4-4.7,2.9-9.2,4.5-13.7c1.6-4.6,3.2-9.1,4.9-13.7.9-2.5,2.1-5.3,3.2-8.1c1.2-2.8,2.3-5.7,3.1-8.6q3.1-1.9,6.3-3.5q3.3-1.6,6.6-2.9.6.3,1,.7.5.3,1,.6c2.3,1.5,3.9,2.6,5,4c1,1.4,1.6,3.1,1.7,5.8q.2,3.4.4,6.8.1,3.4.1,6.9t.1,7q0,3.5.1,7c-.2.4-3.3,4-7.2,8.5-3.9,4.6-8.6,10.2-12,14.5-2,2.4-4.5,5.6-6.9,9s-4.5,6.9-5.6,9.7c-1.8,4.8-2.9,7.7-3.7,10.2-.9,2.4-1.4,4.4-2,7.1-1.5,7-2.9,14.2-4.1,21.3-1.1,7.2-1.9,14.4-2.5,21.6-.5,7.5-1.1,15.1-1.3,22.7-.3,7.7-.2,15.3.8,22.8.9,6.9,2.3,14.7,5.5,21.2c3.1,6.4,8,11.5,15.9,13c4.5.8,8.4.3,12.3-.8s7.6-2.9,11.4-4.8h.1v-.1Z",
    fill: "url(#eIoXAxwJW5C127-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2021.1,1130.9v.1.2c-1.2,8.2-5.2,15.4-11.1,20.5s-13.5,8.1-22,7.9c-1.6,0-3.3-.2-4.9-.6-1.6-.3-3.2-.9-4.6-1.7q-1.6-1-3-2.3-1.3-1.3-2.4-2.8c-3.5-4.5-5.8-9.8-7.2-15.3-1.5-5.6-2.1-11.4-2.5-17.1-1.4-19.2-.2-38.3,2.4-57.4c2.6-19,6.6-37.9,10.8-56.7c1.3-6,2.7-12,4.2-17.9c1.5-6,3.1-11.9,4.9-17.8q4.2-13.4,9.8-26.2t12.5-24.9c.8-1.4,3.3,0,5.6,1.9c2.4,1.9,4.7,4.3,5,4.9c1.2,2.2,1.6,4.8,1.7,7.5.1,2.6-.1,5.3-.1,7.8q0,3.5.1,7q0,3.5.1,7q.1,3.2.2,6.5q0,3.3,0,6.7c0,15.1.2,30.3.4,45.4.2,15.2.4,30.4.5,45.5q.1,9.4.2,18.9.1,9.4.1,18.9c.1,5.7.3,11.4.3,17.1.1,5.7-.2,11.3-1,16.9Z",
    fill: "url(#eIoXAxwJW5C128-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C129",
    transform: "matrix(.932136-.362109 0.362109 0.932136-213.564782 812.835231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2066.7,884.8l-2.5,3.2-2.5,3.3-5.8,7.7-5.9,7.7-16.6,21.7-16.5,21.6-7.8,10.4-7.9,10.3-1.2,1.5-1.2,1.6c-13-3.5-20.1-8.3-23.9-12.2-3.9-3.9-4.4-6.9-4.4-6.9l4.8-12.8l4.9-12.8l9-23.8l9.1-23.8l5.1-13.3l5.2-13.3l29,15l29.1,14.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2066.7,884.8l-2.5,3.2-2.5,3.3c-3,.4-6.3.3-9.5,0-3.3-.3-6.6-.7-9.5-1-4.3-.4-8.7-.7-13.1-1.1s-8.7-.9-13-1.6c-1.7-.3-3.4-.6-5.2-.9-1.7-.4-3.4-.8-5-1.5-.4,1.3-1.2,2.6-2.2,3.8-.9,1.2-2,2.4-2.7,3.6q-1.3,2.1-2.4,4.2-1.2,2.2-2.2,4.3c-1.6,3.6-3,7.3-4.2,11.1-1.1,3.8-2,7.7-2.8,11.5-1,5.1-1.6,10.1-1.6,15.1c0,4.9.7,9.9,2.4,14.8.8,2.5,1.7,4.9,2.9,7.1c1.1,2.3,2.5,4.4,4.2,6.4q.8.9,1.7,1.8t1.7,1.8l-1.2,1.5-1.2,1.6c-13-3.5-20.7-8.1-25.2-11.7-4.4-3.7-5.6-6.4-5.6-6.4l5.4-14.1l5.5-14.1l9-23.6l9.1-23.7l5.1-13l5-13l29.8,15.3l29.8,15.3Z",
    fill: "url(#eIoXAxwJW5C132-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2073.9,884.6c-.4,1-1.3,2.7-2.5,4-1.1,1.4-2.4,2.4-3.5,2.3-1.3-.2-2.7-.7-4-1.2s-2.6-1.1-3.8-1.6q-3.9-1.6-7.7-3.3-3.8-1.8-7.4-3.7c-2.9-1.5-5.6-3-8.2-4.4-2.7-1.5-5.3-3-8-4.8-2.8-1.8-5.7-3.6-8.7-5.4-2.9-1.9-5.7-3.8-8.4-5.7q-2.4-1.8-4.7-3.6-2.3-1.9-4.5-3.9-.2-.2-.4-.4-.1-.2-.2-.5q0-.2.1-.4q0-.2.1-.5.4-.9.9-1.7t1-1.6q.3-.5.6-.9.3-.5.6-.9c2.3.5,4.6,1.2,6.8,1.9c2.3.7,4.5,1.5,6.8,2.2c5.3,1.6,10.5,3.6,15.5,6c5,2.3,9.9,5,14.8,7.7c2.4,1.4,4.7,2.9,7,4.6c2.3,1.6,4.6,3.4,6.7,5.2q1.7,1.3,3.2,2.7q1.6,1.4,3.1,2.9c.6.6,1.3,1.2,2,1.9.8.7,1.5,1.4,2,2.1q.3.2.5.5.2.2.3.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2141.1,861.7c0,0-.5.2-1.2.4-.6.2-1.5.4-2.1.5-1,.3-2.5.5-4,.6s-3.1.2-4.5.2c-2.7.1-5.4-.2-8.2-.5-2.7-.4-5.4-.9-8-1.4-5.6-1-10.7-2.6-15.7-4.5-5-2-9.9-4.2-14.9-6.7-2.4-1.2-5.1-2.5-7.7-4-2.5-1.5-5-3.1-7.1-5.1.8,1.8,1.4,3.7,2,5.5.6,1.7,1.1,3.3,1.6,4.4-.5-.3-2.9-1.7-5.4-3.2s-5-3-6-3.3c.8,1.6,1.7,3.1,2.4,4.3.7,1.1,1.2,1.8,1.2,1.8s-1.3,1-2.7,2.2c-1.5,1.2-3.1,2.5-3.8,3.2-1.8,2-3.9,4.1-6,6.2-2,2.2-4,4.4-5.5,6.7q-.5-.3-1.1-.5-.5-.2-1.1-.4-.4-.2-.8-.5t-.6-.7c1.4-1.6,3-3.3,4.5-5c1.6-1.7,3.2-3.5,4.5-5.1c1.2-1.3,3.4-3.4,5.3-5.2c1.9-1.7,3.6-3.1,3.6-3.1-.7-1-1.7-2.8-2.5-4.6-.9-1.7-1.6-3.4-1.6-4c1.2.6,2.8,1.5,4.5,2.3c1.6.8,3.4,1.6,4.7,2.3q.1,0,.1,0t0,0q1,.5,1.7.8.7.4,1,.4q0-.1-.1-.2q0-.2-.2-.4c-.2-.5-.5-1.4-.8-2.2-.3-.9-.6-1.7-.9-2.4-.3-.8-.6-2-1-3.1-.3-1.1-.5-2-.5-2q.4.3.8.6.4.4.8.7c1.9,1.4,4.1,2.9,6.3,4.3c2.3,1.5,4.7,2.9,7.1,4.3s4.8,2.7,7.2,3.9c2.4,1.1,4.7,2.2,6.9,3.2c4.5,2,7.9,3.3,11.4,4.3s7.1,1.8,12,2.7c2.3.5,4.5.7,6.5.7c2.1.1,4,.1,5.7.1c1.3,0,3-.1,4.7-.3s3.4-.5,4.6-1l.5-.3.6-.2c.9,1,1.3,1.8,1.5,2.4.3.6.3.9.3.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2008.1,908.9c.6.8.5,2.2,0,3.4-.5,1.3-1.3,2.4-2.1,3-1.1.8-2.5,1.4-3.9,2-1.4.5-2.9.9-4.2,1.2c2.9,3,2.2,6.4,0,9.2s-6,5.1-9.5,5.8q0,.9-.1,1.8q0,.9,0,1.8-2.7-2.1-5-4.5-2.4-2.4-4.4-5.1l9-23.6l9.1-23.7q.4.5.7.8t.6.5q1.7,1.5,3.5,3q1.8,1.4,3.7,2.8c-.6.9-1.3,1.8-2.1,2.7-.7.9-1.4,1.7-1.9,2.6q-1.3,2.1-2.4,4.2-1.2,2.2-2.2,4.3-.7,1.7-1.4,3.4t-1.3,3.4c2.5-2.7,5.5-5.2,8.7-7.2c3.1-2.1,6.6-3.7,10.1-4.8c1.4-.4,2.4-.5,3.2-.1s1.3,1.2,1.7,2.7c0,2.9-1.4,5-3.3,6.6-2,1.6-4.4,2.7-6.5,3.8Z",
    fill: "url(#eIoXAxwJW5C135-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050,906.7L2037.5,923L2025,939.4l-4,5.3-4.1,5.3q-4-.7-7.9-2-3.8-1.2-7.5-2.8-3.6-1.6-6.9-3.6-3.3-2.1-6.3-4.5q0-3.3.5-6.6.4-3.4,1.1-6.8c.8-3.8,1.7-7.7,2.8-11.5c1.2-3.8,2.6-7.5,4.2-11.1q1-2.1,2.2-4.3q1.1-2.1,2.4-4.2c.5-.9,1.2-1.7,1.9-2.6.8-.9,1.5-1.8,2.1-2.7c4.5,3.3,9.3,6.3,14.3,8.9s10.2,4.8,15.5,6.6q.7.3,1.6.6.8.2,1.6.5q2.8.8,5.7,1.5q2.9.8,5.8,1.3Z",
    fill: "url(#eIoXAxwJW5C136-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050,906.7L2037.5,923L2025,939.4q0-.4.1-.7q0-.3.1-.6c.6-4.3,1.8-8.4,3.6-12.3s4.1-7.6,6.9-10.9q-1.4-.1-2.9-.4-1.4-.4-2.7-1.1-.6-.3-1.2-.7-.5-.5-.9-1.1c-.3-.6-.3-1.2-.3-1.8.1-.6.3-1.2.6-1.8q.6-.8,1.3-1.4t1.5-1.2q1-.7,2-1.3q1.1-.7,2.2-1.3.7.3,1.6.6.8.2,1.6.5q2.8.8,5.7,1.5q2.9.8,5.8,1.3Z",
    fill: "url(#eIoXAxwJW5C137-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2012.3,887.8q-1.7-.8-3.3-1.8-1.7-.9-3.3-1.9-3.9-2.3-7.8-4.7t-7.7-5q.1.5.3,1q.2.4.3.8q1.3.8,2.6,1.7q1.3.8,2.6,1.6q3.8,2.4,7.5,4.7q3.8,2.3,7.7,4.3h.1q.8.3,1.8.4q1,.2,2.1.2-.1,0-.1-.1q0,0-.1,0c-.5-.2-.9-.3-1.4-.5-.4-.2-.8-.4-1.3-.7Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2008.1,904.1c-3.5-2.6-7-5.1-10.6-7.7-3.6-2.5-7.2-5-10.7-7.6q-1-.8-2-1.5-1-.8-2-1.5.5.7,1,1.3t.9,1q-.2-.1-.4-.1-.3-.1-.5-.2.2.3.5.4.2.2.4.4q2.6,1.9,5.1,3.8q2.6,1.8,5.1,3.6q2.9,2,5.7,4q2.9,2,5.7,4.1.4.4.9.7.4.3.9.6-.1-.1-.2-.3t-.2-.3q.5.2,1,.4.6.2,1.2.2-.5-.3-.9-.6-.5-.4-.9-.7Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1994,912.2q-3.4-2.2-6.8-4.5-3.3-2.3-6.5-4.8-1.2-1-2.4-1.9-1.3-1-2.5-2c.6.7,1.2,1.4,1.8,2c.7.6,1.3,1.1,1.9,1.5q-.1-.1-.4,0-.2,0-.5.1q1.7,1.4,3.5,2.7q1.7,1.3,3.5,2.6q2.9,2.1,5.8,4q3,1.9,6.1,3.6-.4-.5-.8-.9-.3-.4-.6-.7.7.5,1.7.9.9.4,2,.7-1.5-.7-3-1.6-1.4-.8-2.8-1.7Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2023.2,885.9c-.8,1.1-2,1.9-3.4,2.4s-3.1.8-4.6.8q-1.1,0-2.1-.2-1-.1-1.8-.4c2.3,1.8,4.2,3.5,5.4,5.3c1.2,1.9,1.8,3.9,1.4,6.4-.2,1.7-1.3,3.1-2.8,4.1-1.6.9-3.5,1.4-5.4,1.1q-.6,0-1.2-.2-.5-.2-1-.4.1.1.2.3t.2.4c.7,1.4.8,5.5.8,5.5s-1,3.8-2.6,4.5c-.8.4-1.9.6-3,.6-1.1-.1-2.3-.3-3.5-.6q-1.1-.3-2-.7-1-.4-1.7-.9.3.3.6.7.4.4.9,1c1,1.2,2.1,2.6,2.7,4.2s.7,3.4-.2,5.1q-.1.2-.2.5-.1.2-.3.5c-1.4,1.5-4.3,1.4-7.1.6-2.9-.8-5.8-2.3-7.3-3.4q-1.8-1.1-3.3-2.5-1.6-1.4-3-3-.7-.8-1.3-1.6-.7-.9-1.2-1.7c-.2-.3-.7-1-1.2-1.7-.4-.7-.8-1.4-.7-1.6q.5-1.2,1.2-2.3.6-1.1,1.5-2c.6-.6,1.4-1.1,2.2-1.5.8-.3,1.6-.4,2.5-.3-1-1.6-2-3.3-2.8-5-.7-1.8-1.2-3.6-1.2-5.4q.1-.5.2-1q0-.5.3-.9.2-.3.6-.6.3-.2.7-.4c1.1-.7,2.3-1.1,3.6-1.3s2.6-.2,3.8,0q-.9-1.3-1.6-2.7q0,0-1.2-2.9c-.2-.6-.4-1.2-.5-1.8c0-.7,0-1.3.3-1.9.2-.6.7-1.1,1.2-1.4.6-.4,1.2-.7,1.8-.9q1.5-.5,3-.6q1.5,0,3.1.3c-.3-1.3-.8-2.4-1.1-3.6-.4-1.2-.7-2.4-.6-3.6c0-1.3.4-2.5,1.1-3.6.6-1,1.5-1.9,2.5-2.7.5-.3,1.1-.7,1.7-1.1.6-.3,1.3-.6,1.9-.7.7-.1,1.4.1,2.2.4.8.2,1.5.5,2.1.8q.8.2,1.5.5t1.4.6c2.3.9,4.5,2.3,6.6,3.8c2,1.5,4,3.1,5.9,4.6c1.7,1.4,3.6,3.2,4.7,5.3c1.2,2.1,1.5,4.4.1,6.8Z",
    fill: "url(#eIoXAxwJW5C141-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2067.5,845.1h-.1c-.2-.5-.5-1.4-.8-2.2-.3-.9-.6-1.7-.9-2.4-.3-.8-.6-2-1-3.1-.3-1.1-.5-2-.5-2q.4.3.8.6.4.4.8.7.1.6.1,1.2.1.6.1,1q.2.8.4,1.6.1.8.3,1.6c.1.4.3,1,.5,1.5s.3,1,.3,1.5Z",
    fill: "url(#eIoXAxwJW5C142-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2063.1,909.3q-.7,2.7-1.7,5.4-1,2.6-2.2,5.1c-1.1,2.4-2.2,4.8-3.6,7.1-1.3,2.2-2.9,4.3-4.9,6.1q-.5.4-1,.8-.6.4-1.2.7c-2.7,1.7-5.9,2.3-9.2,2.4-3.2.2-6.5-.3-9.6-.9c2.2-4.4,5-8.3,7.9-12.2s6-7.7,8.8-11.6c.6-.7,1.1-1.4,1.5-2.2.5-.7.8-1.5,1.1-2.4-2.3-.1-4.6.1-6.9.1-2.3.1-4.6-.1-6.6-1.1q-.4-.2-.7-.4-.4-.2-.6-.6-.3-.5-.3-1.1.1-.6.4-1.1c.5-1.1,1.4-1.8,2.5-2.4c1-.6,2.2-1,3.2-1.4q1.1-.5,2.2-.9t2.1-.8q2.6-.9,5.3-1.5t5.5-.6c1.3,0,3.1,0,4.8.4c1.6.3,3.2,1,3.9,2.3.9,1.5.9,3.4.6,5.3-.3,2-.9,4-1.3,5.5Z",
    fill: "url(#eIoXAxwJW5C143-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2025,856q2.6,2.1,5.4,4q2.7,1.9,5.5,3.8q3.9,2.5,7.9,4.8q4.1,2.4,8.3,4.4q2.2,1,4.4,1.9q2.3.9,4.7,1.5c.3.1.6-.1.6-.3.1-.3,0-.6-.3-.7-2.9-.8-5.6-1.9-8.3-3.1-2.7-1.3-5.4-2.7-7.9-4.1q-3.8-2.1-7.4-4.5-3.6-2.3-7.1-4.8-1.3-.9-2.6-1.8t-2.5-1.9c-.2-.2-.6-.1-.8.1s-.2.5.1.7Z",
    fill: "url(#eIoXAxwJW5C144-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1997.8,925.1q.6,0,1.2-.1.6,0,1.1-.1-.1.2-.2.5-.1.2-.3.5c-1.1,1.5-3.1,1.7-5.2,1.5-2.2-.3-4.3-1-5.7-1.5q-.2,0-.4-.1-.2,0-.4-.1c-2-.7-3.9-1.7-5.8-2.9-1.8-1.1-3.6-2.3-5.4-3.5-1.6-1.1-3.5-2.6-4.7-4.4-1.3-1.7-2-3.7-1.2-5.9.4-.9.9-1.8,1.6-2.7.6-.9,1.3-1.7,2.1-2.2.6-.4,1.7-.9,2.7-1.3s1.9-.5,2.3-.3c-1.5-1.1-3.3-2.7-4.4-4.5-1.2-1.9-1.7-4.1-.8-6.3.9-1.8,2.5-3.2,4.4-3.8s4-.6,6,.2c-.9-1-2.3-2.6-3.2-4.4s-1.3-3.7-.2-5.3c.9-1.3,2.7-1.9,4.6-2.2c1.9-.2,4,0,5.2.5-1.1-1.9-1.8-4.6-1.7-7.1s1.1-4.8,3.5-6c1.6-.7,3.3-.9,5-.7c1.8.2,3.5.7,5.1,1.4-.7,0-1.5.2-2.2.5-.8.2-1.5.5-2,.7q-1.5.6-2.9,1.6-1.3.9-2.2,2.2c-1.5,2.1-1.3,4.1-.3,6c1.1,1.9,2.8,3.5,4.4,4.8.9.8,2.1,1.3,3.3,1.7c1.2.5,2.4,1,3.4,1.6-1.3-.4-3-.3-4.7-.1-1.6.2-3.3.6-4.7.8-.6.1-1.5.3-2.3.6s-1.6.7-2,1.3-.5,1.3-.3,2c.1.7.4,1.4.7,1.9.5.9,1.1,1.7,1.7,2.4.6.8,1.3,1.5,1.9,2.3-1.7,0-3.6.3-5.5.8-1.8.6-3.5,1.4-4.6,2.7-1.6,1.7-1.5,3.6-.7,5.3s2.2,3.3,3.3,4.4c-1.3.1-2.4,0-3.5.1-1,.1-2,.4-3,1.4-.9.8-1.3,1.6-1.4,2.5s.3,1.8.8,2.9c1.6,3.3,4.2,5.9,7.3,7.7c3.1,1.7,6.7,2.7,10.3,2.7Z",
    fill: "url(#eIoXAxwJW5C145-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2055.7,839.9c1.2.6,2.8,1.5,4.5,2.3c1.6.8,3.4,1.6,4.7,2.3q-.4-.1-.9-.2t-.9-.2c-.8-.2-1.6-.5-2.5-.8-.9-.2-1.7-.5-2.5-.5c0,1.1.3,2,.7,2.9s.9,1.8,1.1,2.8c.2.5.3.8.3,1.1-.1.2-.3.4-.7.8q-.7.6-1.3,1.2-.6.7-1.3,1.3-1.4,1.1-2.6,2.4-1.3,1.4-2.5,2.7c-1.4,1.7-2.9,3.3-4.3,5-1.5,1.6-2.9,3.3-4.2,5.1q-.4-.2-.8-.5t-.6-.7c1.4-1.6,3-3.3,4.5-5c1.6-1.7,3.2-3.5,4.5-5.1c1.2-1.3,3.4-3.4,5.3-5.2c1.9-1.7,3.6-3.1,3.6-3.1-.7-1-1.7-2.8-2.5-4.6-.9-1.7-1.6-3.4-1.6-4Z",
    fill: "url(#eIoXAxwJW5C146-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2049.1,932.9q.4,0,.8.1.4,0,.8,0-.5.4-1,.8-.6.4-1.2.7c-3.4,2.1-7.3,2.8-11.3,3.3-4,.4-8.1.5-11.9,1.2c3.6-5.4,7.1-10.4,10.7-15.1c3.6-4.8,7.2-9.3,11-13.9-2,.4-3.9.8-5.8,1s-3.9.2-5.9-.2c-2-.3-3.3-1.5-3.7-2.9s.1-3.1,1.7-4.5c.9-.7,1.9-1.4,3.1-2.1c1.1-.6,2.3-1.2,3.6-1.7-1.4,2,1,3.7,4,4.9c3.1,1.2,6.8,1.8,8.1,1.8.1,1.1-.4,2.4-1.1,3.6s-1.5,2.4-2,3.4c-.8,1.4-1.7,2.7-2.6,3.9-1,1.3-1.9,2.5-2.8,3.8-.7,1-1.6,2.1-2.2,3.2-.6,1.2-.9,2.4-.4,3.7.6,1.6,1.8,2.8,3.3,3.6s3.3,1.2,4.8,1.4Z",
    fill: "url(#eIoXAxwJW5C147-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2073.9,884.6c-.4,1-1.3,2.7-2.5,4-1.1,1.4-2.4,2.4-3.5,2.3-1.3-.2-2.8-.6-4.2-1-1.4-.5-2.8-1-4-1.5q-3.9-1.5-7.7-3.3-3.8-1.7-7.4-3.7c-2.9-1.5-5.6-2.9-8.2-4.4-2.7-1.5-5.3-3-8-4.7-2.8-1.8-5.7-3.6-8.7-5.5-2.9-1.8-5.8-3.7-8.4-5.7-1.6-1.2-3.1-2.5-4.5-3.8-1.5-1.3-2.9-2.6-4.3-4q-.2-.2-.4-.4-.1-.2-.2-.5q0-.2.1-.4q0-.2.1-.5.4-.9.9-1.7t1-1.6q.3-.5.6-.9.3-.5.6-.9c.9,1.8,2.7,3.7,4.6,5.3s3.9,3,5.1,4c2.2,1.6,4.3,3.2,6.4,4.8c2.2,1.6,4.4,3.1,6.6,4.5c3.9,2.4,7.8,4.8,11.8,7.1c3.9,2.3,7.9,4.5,12,6.6q2.8,1.3,5.7,2.4q2.8,1.1,5.8,1.9c1.7.4,3.4.6,5,.7s3.3.1,4.9-.1q.3.2.5.5.2.2.3.5Z",
    fill: "url(#eIoXAxwJW5C148-fill)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C149",
    transform: "translate(1820.312159 0)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2251.8,1008.9c-6.4,5.9-13.1,11.5-20,16.7-6.9,5.3-14,10.2-21.3,14.8-3.3,2-6.7,4-10.1,5.9-3.4,2-6.8,3.8-10.3,5.5-2.5,1.3-6.5,2.9-10.2,4.8s-7.2,4.1-8.6,6.5c-4.3,7.3-1,13.9,4.6,19s13.6,8.7,18.6,10.2c13.6,4,28.9,6,43.8,4.9c14.9-1,29.4-5.1,41.4-13.2c6.6-4.4,13-9.5,19-15c5.9-5.5,11.5-11.5,16.4-18c4.3-5.5,9.1-11.7,13.2-18.2s7.6-13.4,9.1-20.2c1.8-8.5-.6-14.9-5.1-20.1-4.6-5.1-11.3-9-18.1-12.4-2.5-1.2-4.9-2.6-7.3-3.9-2.5-1.4-4.9-2.7-7.5-3.8-2.2-1-4.9-2.1-7.6-2.7s-5.4-.6-7.8.6c-1.9,1.1-3.1,2.8-4.1,4.7s-1.7,4-2.7,5.8q-1.9,3.1-4.1,5.9t-4.6,5.5q-4,4.3-8.2,8.5-4.1,4.2-8.5,8.2Z",
    fill: "url(#eIoXAxwJW5C150-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C151",
    transform: "translate(0 797.889257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2042.9,1270q0,1.1-.1,2.1-.1,1.1-.2,2.2h-30.3-30.2q-.2-1.1-.3-2.2q0-1,0-2.1c0-5.1,1.2-9.8,3.3-14c2.2-4.1,5.3-7.7,9-10.5c2.6-1.9,5.4-3.4,8.5-4.4c3-1.1,6.3-1.7,9.8-1.7c7.9,0,15.1,3.1,20.6,8.1c5.4,5,9,11.9,9.7,19.6q.1.7.1,1.4.1.7.1,1.5Z",
    fill: "url(#eIoXAxwJW5C152-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2014,1239.5q0,3.4,0,6.8t0,6.7c0,.5-.4.8-.8.8s-.8-.3-.8-.8v-3.2-3.1q-.1-1.8-.1-3.6t0-3.6q.4,0,.8,0t.9,0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C155",
    transform: "translate(0 788.318916)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2404.9,1306.2h104.9h104.9c1.9,0,3.5.8,4.8,2c1.2,1.2,1.9,2.8,1.9,4.7v19.8v19.8c0,1.8-.7,3.5-1.9,4.7-1.3,1.2-2.9,1.9-4.8,1.9h-104.9-104.9c-1.8,0-3.5-.7-4.7-1.9s-2-2.9-2-4.7v-19.8-19.8c0-1.9.8-3.5,2-4.7s2.9-2,4.7-2Z",
    opacity: 0.4,
    fill: "url(#eIoXAxwJW5C157-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2572.2,1334.4c0,3.8,1.5,7.2,4,9.6c2.5,2.5,5.9,4,9.7,4c3.7,0,7.1-1.5,9.6-4c2.5-2.4,4-5.8,4-9.6s-1.5-7.2-4-9.6c-2.5-2.5-5.9-4-9.6-4-3.8,0-7.2,1.5-9.7,4-2.5,2.4-4,5.8-4,9.6Z",
    fill: "url(#eIoXAxwJW5C159-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2521.3,1334.4c0,3.8,1.5,7.2,4,9.6c2.5,2.5,5.9,4,9.6,4c3.8,0,7.2-1.5,9.7-4c2.4-2.4,4-5.8,4-9.6s-1.6-7.2-4-9.6c-2.5-2.5-5.9-4-9.7-4-3.7,0-7.1,1.5-9.6,4-2.5,2.4-4,5.8-4,9.6Z",
    fill: "url(#eIoXAxwJW5C160-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2471.5,1334.4c0,3.8,1.5,7.2,3.9,9.6c2.5,2.5,5.9,4,9.7,4s7.2-1.5,9.6-4c2.5-2.4,4-5.8,4-9.6s-1.5-7.2-4-9.6c-2.4-2.5-5.8-4-9.6-4s-7.2,1.5-9.7,4c-2.4,2.4-3.9,5.8-3.9,9.6Z",
    fill: "url(#eIoXAxwJW5C161-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2422,1334.4c0,3.8,1.5,7.2,4,9.6c2.4,2.5,5.9,4,9.6,4c3.8,0,7.2-1.5,9.7-4c2.4-2.4,4-5.8,4-9.6s-1.6-7.2-4-9.6c-2.5-2.5-5.9-4-9.7-4-3.7,0-7.2,1.5-9.6,4-2.5,2.4-4,5.8-4,9.6Z",
    fill: "url(#eIoXAxwJW5C162-fill)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2016,1274q-.7,5.1-1.8,10.2-1,5.1-2.4,10.1-1.3,4.7-3,9.2t-3.9,8.8q-2,4.1-4.5,7.8-2.5,3.8-5.5,7.1t-6.4,6q-3.5,2.8-7.3,4.9c-3,1.7-6.1,3-9.3,4-3.2,1.1-6.5,1.7-9.9,2-4,.3-8,.1-12-.5-3.9-.6-7.8-1.6-11.6-3.1q-4.4-1.7-8.5-4-4.2-2.4-7.9-5.3-3.8-3-7.2-6.4-3.4-3.5-6.4-7.3-3-4.1-5.6-8.5-2.5-4.4-4.5-9-2.1-5-3.5-10.1-1.4-5.2-2.2-10.4-.2-1.3-.3-2.6-.2-1.3-.3-2.6c0-.4-.2-.7-.4-.9-.2-.3-.6-.4-.9-.4-.4,0-.7.1-1,.4-.2.2-.4.5-.4.9q.5,5.5,1.7,11q1.1,5.4,3,10.7q1.7,5,4,9.7q2.4,4.8,5.3,9.2q2.8,4.2,6.2,8q3.3,3.9,7.1,7.2q3.6,3.3,7.7,6q4.1,2.8,8.5,4.9c3.6,1.7,7.4,3.1,11.2,4.1c3.9,1,7.8,1.6,11.8,1.7q3.1.2,6.2,0q3.1-.3,6.1-.9q2.6-.5,5-1.4q2.5-.8,4.9-1.8q4.2-1.9,8.1-4.5q3.9-2.5,7.3-5.7q3.3-3.1,6.2-6.8q2.9-3.6,5.2-7.6q2.5-4.3,4.5-8.8q1.9-4.5,3.5-9.2q1.6-4.9,2.8-10q1.3-5,2.1-10.1.3-1.4.5-2.7t.4-2.6c0-.4,0-.7-.2-1-.1-.3-.4-.6-.7-.7-.4,0-.7,0-1.1.2-.3.1-.5.4-.6.8Z",
    opacity: 0.7,
    fill: "url(#eIoXAxwJW5C164-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2138.6,1274.5q-2.2,8.5-4.9,16.9t-6.1,16.5q-3.3,8-7.2,15.7t-8.5,15q-4.4,7.2-9.6,13.9-5.1,6.7-10.9,12.8c-3.9,4.1-8,8-12.6,11.4-4.5,3.4-9.3,6.4-14.5,8.6-4.5,2-9.3,3.2-14.1,3.9-4.9.6-9.8.7-14.6.2s-9.4-1.5-13.9-3c-4.6-1.4-9-3.3-13.1-5.5-4.5-2.4-8.8-5.1-12.9-8.1-4-3-7.9-6.3-11.6-9.7q-5.8-5.6-11-11.7-5.1-6.2-9.6-12.8-4.5-6.7-8.4-13.8-3.8-7-6.9-14.4-1.8-4.2-3.3-8.5t-2.9-8.7q-1.2-3.9-2.1-7.8-.9-4-1.6-8-.1-.6-.2-1.1t-.1-1.1q-.1-.2-.1-.4t-.1-.4c0-.1,0-.1,0,0c0,0,0,0,0-.1q-.4.3-.8.6-.4.4-.9.7q0,0,0,0t0,0q-.2-.2-.4-.3-.2-.2-.4-.3c-.1-.3-.1-.3-.1-.2.1.1.1.3.1.4.2.8,1,1.1,1.6.9.7-.2,1.2-.8,1-1.6-.1-.3-.1-.7-.3-.9-.2-.3-.4-.5-.8-.6s-.8,0-1.1.2c-.3.3-.5.7-.5,1.1q-.1.3,0,.7t.2.7q0,.6.1,1.1.1.6.2,1.1.3,1.6.6,3.2.2,1.6.6,3.2c.6,3.3,1.5,6.5,2.5,9.7c1,3.3,2.2,6.4,3.3,9.6q2.8,7.8,6.4,15.3q3.6,7.4,7.9,14.5q4.3,7,9.2,13.6q5,6.5,10.6,12.5c3.6,3.8,7.5,7.5,11.5,10.9c4.1,3.4,8.3,6.5,12.8,9.3c4.2,2.6,8.6,4.9,13.1,6.8c4.6,1.9,9.3,3.4,14.1,4.4s9.7,1.5,14.5,1.5c4.9-.1,9.7-.7,14.5-1.9c5.5-1.4,10.6-3.7,15.5-6.5c4.9-2.9,9.4-6.4,13.6-10.1c4.3-3.9,8.3-8,12.1-12.4c3.8-4.5,7.3-9.1,10.6-13.8q5-7.2,9.3-14.8t8-15.6q3.7-8.1,6.9-16.5q3.1-8.5,5.6-17.1.6-2.1,1.1-4.2.6-2.2,1.2-4.3c.2-.8-.4-1.4-1-1.6s-1.4.1-1.6.9Z",
    opacity: 0.7,
    fill: "url(#eIoXAxwJW5C165-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2698.3,1278.1h-488.8-488.8v-3.5-3.6h488.8h488.8v3.6v3.5Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "eIoXAxwJW5C167",
    d: "M2313.7,1017.6c-.7-6.3-7.9-11.5-14.6-16.7-6.7-5.1-12.9-10.2-11.8-16.3.8-4.3,4.9-4.7,9.3-3.7c4.5,1.1,9.3,3.5,11.4,4.8c3.6,2.2,7.6,5.3,10.8,8.8c3.3,3.5,5.8,7.4,6.8,11.1c1.5,5.5-.3,9.3-3,11.4s-6.4,2.3-8.9.6Z",
    transform: "translate(1702.468897 0)",
    fill: "url(#eIoXAxwJW5C167-fill)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C168",
    transform: "translate(0-1266.780886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1885,1308.3q-.2,4.9-.6,9.6t-1.1,9.2q-.3,2.7-.7,5.2-.5,2.5-.9,4.9-1,4.6-2.1,9.1-1.2,4.5-2.6,8.8-1.3,3.8-2.8,7.5t-3.2,7.3c-1.5,3-3,5.7-4.8,8.4-1.7,2.6-3.7,5.2-6,7.6-.7.7-1.8,2.1-3.1,3.3-1.3,1.1-2.8,2-4.1,1.6-1.1-.3-1.6-1.5-1.8-2.8s-.2-2.7-.3-3.8c-.4-4.6-.7-9.5-1-14.3-.3-4.9-.7-9.7-1.5-14.3-.4-2.9-1.2-5.5-1.9-8.1-.8-2.6-1.7-5.2-2.4-8.1-.8-3.4-1.5-7.1-2.4-10.8-.8-3.7-1.8-7.3-3.1-10.6-2.4-6.2-4.8-12-7.6-17.6s-6-11-10.1-16.3c-3.4-4.5-7.5-8.3-12.3-11.2-4.7-2.9-10-4.9-15.6-5.6-1.7-.3-3.5-.4-5.3-.6s-3.5-.5-5.2-1.1c-.6-.2-1.2-.5-1.7-.8-.6-.4-1-.8-1.4-1.3-.8-1.5-.2-2.8.9-4c1-1.3,2.6-2.3,3.5-3q2.1-1.5,4.5-2.7q2.3-1.2,4.8-1.9c2.4-.7,5.5-1.6,8.6-1.8c3.1-.3,6.2.1,8.4,1.8-.6-1.3-1.4-3.1-1.9-4.8-.5-1.8-.6-3.6.2-5.2.9-1.8,2.8-2.4,4.8-2.5c2.1-.2,4.3.3,5.9.6c2.6.7,5.1,2.1,7.3,3.7c2.3,1.7,4.4,3.6,6.4,5.4q2.3,2,4.6,3.9q2.4,2,4.8,3.8-1.1-3.2-1.8-6.6-.6-3.3-.9-6.7c0-.9-.1-1.7,0-2.6.1-.8.3-1.7.7-2.4.6-1,1.4-1.8,2.5-2.2c1-.5,2.2-.7,3.3-.7c1.2,0,2.3.3,3.4.7c1,.3,2.1.8,3.1,1.4q3.6,1.9,6.9,4.3t6.2,5.3q1.4,1.4,2.8,3q1.3,1.5,2.5,3.1c.5.6.8,1,1,1.6.2.5.3,1.1.2,1.8c0,0,0,.4-.1.7c0,.4-.1.7-.1.7q.2.1.4.2.2.2.5.3c2.6,1.8,4.3,3.7,5.5,5.8s2,4.5,2.8,7.1c1.7,5.6,2.8,11.5,3.4,17.7s.7,12.7.5,19Z",
    fill: "#ffe292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1877,1355.1q-1.3,3.8-2.8,7.5t-3.2,7.3c-1.5,3-3,5.7-4.8,8.4-1.7,2.6-3.7,5.2-6,7.6-.7.7-1.8,2.1-3.1,3.3-1.3,1.1-2.8,2-4.1,1.6-1.1-.3-1.6-1.5-1.8-2.8s-.2-2.7-.3-3.8c-.4-4.6-.9-9.2-1.5-13.8-.5-4.6-1.1-9.2-1.9-13.8q-.7-4.3-1.5-8.6t-1.9-8.6q-1.2-5.2-2.8-10.3t-3.6-10.1c-2.5-6.2-4.8-12-7.6-17.6s-6-11-10.1-16.3c-3.7-4.8-7.2-8.3-10.9-10.5-3.8-2.3-7.9-3.3-12.7-3.6-3.1.1-5.6.1-7.8.1-2.2-.1-4.1-.1-6.4,0q-.3-.1-.6,0-.4,0-.7,0c-3.2.1-4.6-1.3-4.8-3.2-.3-1.8.7-4.2,2.1-6c2-2.4,4.3-4.5,6.8-6.2s5.2-2.9,8.1-3.8c2.4-.7,5.5-1.6,8.6-1.8c3.1-.3,6.2.1,8.4,1.8-.6-1.3-1.4-3.1-1.9-4.8-.5-1.8-.6-3.6.2-5.2.9-1.7,2.7-2.4,4.8-2.5c2,0,4.3.4,5.9.6c4.5.7,8,2.4,11.2,4.6s6,4.9,9.2,7.7c-.4-1.3-.9-2.5-1.4-3.7-.6-1.2-1.1-2.5-1.3-3.8-.3-1.2-.5-2.8-.6-4.4-.1-1.7,0-3.3.4-4.4.6-1.6,1.3-2.3,2.4-2.6c1-.2,2.3-.1,4,0c3.7.1,7.7,1.3,11.4,3.1s7.1,4.3,9.7,6.9c2.2,2.2,3.8,4.2,5,5.9s1.9,3.1,2.4,4.3c-3.6-.3-8.6,2.1-13.3,4.8-4.6,2.7-8.9,5.7-11,6.5-2.5.9-4.9,1.2-7.5,1.5-2.5.2-5,.2-7.6.4-3.4.3-5.2,1.2-5.7,2.7s.3,3.5,2.1,6.1c3.7,5.7,7.2,11,10.2,16.6s5.5,11.4,7.5,17.9c1.9,6.4,3.2,12.7,5.1,18.8c1.8,6.1,4.2,12,8.3,17.5c2.3,3,4.8,5.2,7.6,6.6c2.9,1.4,6.1,2.1,9.8,2.1Z",
    fill: "url(#eIoXAxwJW5C170-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1858.1,1414q.1,1.6,0,3.1q0,1.6-.1,3.1.1,1.6,0,3.1-.1,1.6-.4,3.1-.1.8-.4,1.5-.2.8-.5,1.5q0,.1-.1.2t-.1.2q-.2.5-.5.8t-.7.4c-.9.4-1.6-.1-2-.8s-.6-1.7-.7-2.3c-.2-1.1-.2-2.1-.2-3.2s0-2.2,0-3.3q.1-1.7.1-3.4.1-1.6.1-3.3.1-1.7.2-3.4q0-1.7.2-3.4c0-.5.1-1.3.2-2c.2-.8.5-1.5,1-1.9q.1-.1.3-.2.3-.1.5-.1c.3,0,.6.2.8.4.2.3.4.6.5.9.6,1.5,1,2.9,1.3,4.5.3,1.5.4,3,.5,4.5Z",
    fill: "#ffe292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.1,1293.4c-.5,1.5-1.5,2.8-2.6,3.8-1.1,1.1-2.5,1.9-3.9,2.4-1.6.7-3.3,1-5,1.1-1.7,0-3.4-.2-5-.5-1.7-3.8-3.5-7.3-5.5-10.8-2-3.4-4.1-6.8-6.4-10.4q.8-.4,1.8-.7t2-.4q1.3-.2,2.7-.3q1.3,0,2.6,0q2.8.1,5.6.6q2.8.4,5.4,1.4c1.5.5,2.9,1.2,4.3,2c1.3.8,2.4,1.9,3.3,3.1.9,1.3,1.4,2.8,1.5,4.3s-.2,3-.8,4.4Z",
    fill: "url(#eIoXAxwJW5C172-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1885.3,1308.3q-.2,4.9-.6,9.6t-1.1,9.2q-1.2.5-2.5.7t-2.6.3q-2.1.1-4.4-.2-2.2-.3-4.3-.9c-1.2-.4-2.4-1-3.4-1.7s-1.9-1.6-2.5-2.7c-.5-1-.9-2.1-1-3.2-.2-1.1-.2-2.3.1-3.4.4-2.4,1.8-4.5,3.6-6.1s4.1-2.7,6.4-3.2q2.1-.5,4.3-.4t4.4.6q.9.3,1.8.6t1.8.8Z",
    fill: "url(#eIoXAxwJW5C173-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.6,1346.6c0,1.3-.2,2.5-.7,3.6-.4,1.2-1.1,2.2-2,3.1-1.1,1.2-2.6,2.2-4.3,2.8s-3.5.8-5.2.5q-.7-4.3-1.5-8.6-.9-4.3-1.9-8.6.6-.3,1.3-.6.7-.2,1.5-.3c1.5-.3,3-.3,4.5-.1s2.9.7,4.3,1.5c1.2.7,2.2,1.7,2.8,2.8.7,1.2,1.1,2.5,1.2,3.9Z",
    fill: "#b20909"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1870.9,1289.1q0,.1,0,0q0,0,0-.2q0,.1,0,.1q0,.1,0,.1q0,.1,0,.1q0,.1,0,.2q0,0,0,0q0,.1,0,.1c0,.1,0,.1,0,0s0-.1,0,0q0,.1-.1.1q0,.1,0,.2-.1.4-.2.8t-.3.8q-.1.2-.1.4-.1.2-.2.4c0,.2,0,.1,0,.1c0-.1.1-.2,0,0q0,0,0,.1-.1,0-.1,0q0,.1-.1.2q0,.1,0,.2-.2.3-.4.7-.1.3-.3.6c-.1.2-.2.5-.1.8s.2.6.5.7q.4.2.8.1.5-.1.7-.5.5-.8.8-1.6.4-.8.7-1.6c.2-.6.4-1.2.5-1.8s.1-1.2,0-1.7c0-.3-.2-.6-.5-.7s-.6-.2-.8-.1q-.5.2-.7.5-.2.4-.1.9Z",
    fill: "#7a7703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.3,1311.9c0,0,.1,0,.1,0c.1,0,.2.1.2.1s-.1-.1-.1-.1s0,0,.1.1q0,0,0,0q.1,0,.1.1.2,0,.4.1t.3.2q.4.2.8.5.4.2.8.4c.5.3,1,.6,1.5.8.6.2,1.2.4,1.7.4.3,0,.6-.1.8-.3s.4-.5.4-.8q-.1-.5-.4-.8t-.8-.3q0,0,0,0-.1,0-.1,0c-.1,0-.1,0-.1,0s.1,0,.1,0q0-.1-.1-.1t-.2,0-.2,0q-.1-.1-.1-.1-.1,0-.1,0-.1,0-.1-.1q0,0,0,0-.1,0-.1,0-.1,0,0,0q0,0,.1,0-.1,0-.2-.1-.1,0-.1,0-.1-.1-.2-.1-.1-.1-.2-.1-.2-.1-.4-.2t-.4-.2q-.7-.5-1.4-.9-.8-.4-1.6-.7c-.2-.1-.5,0-.8.1-.3.2-.5.4-.5.7q-.1.5.1.8.2.4.7.6Z",
    fill: "#7a7703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1867.3,1354.1q.7-.5,1.3-1q.7-.5,1.3-1q.6-.6,1.2-1.3.5-.7.7-1.5c.1-.3,0-.6-.1-.8-.1-.3-.4-.5-.7-.6q-.4-.1-.8.1-.4.3-.5.7q0,.1-.1.2q0,0,0,.1c0-.2,0-.2,0-.2s0,.1,0,.1q0,.1,0,.1-.1,0-.1.1-.1.1-.1.3-.1.1-.2.2c.1-.1.1-.1,0,0c0,0-.1.1-.1.1q-.1.1-.1.2-.1,0-.2.1-.1.2-.2.3-.2.1-.3.2-.2.2-.3.3t-.3.2q-.1.1-.1.2-.1,0-.2.1q0,0-.1,0q0,.1,0,.1c-.1.1-.1,0,0,0c0-.1.1-.1,0,0q-.3.2-.5.4-.3.2-.6.4-.2.1-.3.3-.1.1-.2.3q0,.3,0,.5t.1.4c.2.2.4.4.7.5s.6.1.8-.1Z",
    fill: "#7a7703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1856.2,1367.9q.2.8.4,1.6t.4,1.6q0,.2.1.4q0,.2,0,.4c0,0,.1.1.1.2s0,.1,0,0q0,.1,0,.2t0,.1q.1.5.1.9q0,.5-.1.9c0,.3.1.6.3.8.3.2.5.3.8.3q.5,0,.8-.3t.3-.8c.1-1.2,0-2.3-.3-3.5-.2-1.1-.5-2.2-.7-3.4-.1-.2-.3-.5-.6-.6-.2-.2-.5-.2-.8-.1q-.5.1-.7.5t-.1.8Z",
    fill: "#7a7703"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1872.9,1258.7c-.4-.1-1.5-.6-3.1-1s-3.8-.8-6.6-.7c-1.6.1-3.1.3-4.7.7-1.5.4-3,.8-4.5,1.3-3.7,1.1-7.5,2.5-11.3,3.3-3.9.7-7.8.7-11.5-1q-1.2-.5-2.2-1.1-1.1-.6-2.2-1.2c-1.6-.8-3.3-1.4-5-1.8s-3.5-.7-5.3-.8q-4.8-.5-9.6-.1-4.9.4-9.6,1.7c-3.3.9-6.7,2.2-9.7,4.1-2.9,1.9-5.5,4.3-7.2,7.3-.4.7-.7,1.2-1.1,1.4-.4.1-.9,0-1.6-.6q-.6-.4-.9-1t-.4-1.3c-.2-1,0-2.2.5-3.2.4-1.1,1-2,1.7-2.8c1.9-2.4,4.2-4.5,6.7-6.2s5.2-2.9,8.1-3.8c2.4-.7,5.6-1.6,8.7-1.8c3.1-.3,6.1.1,8.3,1.8-.6-1.3-1.4-3.1-1.9-4.8-.5-1.8-.6-3.6.2-5.2.9-1.7,2.8-2.4,4.8-2.5c2.1,0,4.3.4,5.9.6c2.8.5,5.3,1.3,7.6,2.4c2.2,1.2,4.2,2.6,6.2,4.2q.9.8,1.8,1.6q1,.8,2,1.7.1,0,.1,0q.1.1.1.2.7.5,1.3,1.1.7.5,1.3,1.1c-.3-1.3-.9-2.5-1.4-3.7s-1.1-2.5-1.3-3.8c-.3-1.2-.5-2.8-.6-4.4-.1-1.7,0-3.3.4-4.4.6-1.6,1.3-2.3,2.4-2.6c1-.2,2.4-.1,4,0c3.7.1,7.7,1.3,11.4,3.1s7.1,4.3,9.7,6.9c5.1,5.2,7.1,8.9,7.8,11.3.6,2.4,0,3.5,0,3.5q.2.1.4.2.1.2.3.3Z",
    fill: "url(#eIoXAxwJW5C180-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1852.8,1239.4c-1.6-.9-4-1.6-6-1.4-2,.1-3.7,1.1-4.1,3.5-.3,2.2,1.2,4.8,3.1,7c2,2.2,4.4,4.1,6.1,5c2.1,1.2,4.4,2,6.1,1.7c1.7-.2,2.9-1.5,2.9-4.6c0-2.2-.9-4.6-2.3-6.6-1.5-2-3.5-3.7-5.8-4.6Z",
    fill: "#ffe292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.3,1262c-3.7-.3-7.2-1.2-10.8-1.9-3.5-.8-7.1-1.6-10.8-1.7-3.6-.2-7.3.1-10.9.8-3.6.8-7.1,1.9-10.4,3.4q-1.6.7-3.1,1.6-1.4.9-2.8,2c-.8.7-1.4,1.5-2,2.4-.6.8-1.2,1.7-1.8,2.5q-.4,0-.7,0t-.6,0c-3.2.1-4.6-1.4-4.9-3.5-.3-2,.6-4.6,2.1-6.4c2-2.4,4.3-4.5,6.8-6.2c2.5-1.6,5.2-2.9,8.1-3.8c2.4-.7,5.5-1.5,8.6-1.8s6.2.1,8.4,1.8c-.6-1.3-1.4-3.1-1.9-4.8-.5-1.8-.6-3.6.2-5.2.9-1.7,2.7-2.3,4.8-2.4c2-.1,4.3.3,5.9.5c2.8.5,5.3,1.3,7.5,2.4c2.3,1.2,4.3,2.6,6.2,4.1-3-1.3-6.9-1.6-9.7-.8s-4.5,2.7-3.1,5.9c1,2.2,3.2,4.1,5.9,5.9s6,3.5,9,5.2Z",
    fill: "#c6590e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1864.6,1276.7c1.2,1.1,2,2.6,2,4.3s-.8,3.2-2,4.3-2.8,1.8-4.7,1.8c-1.8,0-3.5-.7-4.7-1.8s-1.9-2.6-1.9-4.3.7-3.2,1.9-4.3s2.9-1.8,4.7-1.8c1.9,0,3.5.7,4.7,1.8Zm-1.7,5.6c.5-.7.7-1.4.5-2.2s-.8-1.3-1.5-1.7c-.8-.3-1.7-.4-2.7-.1-.9.2-1.7.7-2.2,1.4-.4.6-.6,1.4-.4,2.2.2.7.7,1.3,1.4,1.6.8.4,1.7.5,2.7.3.9-.3,1.7-.9,2.2-1.5Z",
    fill: "#2e2c33",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1858.5,1321.2c1.2,1.1,1.9,2.6,1.9,4.3s-.7,3.2-1.9,4.3-2.9,1.8-4.7,1.8-3.5-.7-4.7-1.8-2-2.6-2-4.3.8-3.2,2-4.3s2.9-1.8,4.7-1.8s3.5.7,4.7,1.8Zm-1.7,5.6c.4-.7.6-1.5.4-2.3-.2-.7-.7-1.3-1.5-1.6-.7-.3-1.6-.4-2.6-.2-1,.3-1.7.8-2.2,1.5-.5.6-.7,1.4-.5,2.1.2.8.8,1.4,1.5,1.7.8.4,1.7.5,2.7.2.9-.3,1.7-.8,2.2-1.4Z",
    fill: "#2e2c33",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1856.5,1429.8q-.2.5-.5.8t-.7.4c-.9.4-1.6-.1-2-.8s-.6-1.7-.7-2.3c-.2-1.1-.2-2.1-.2-3.2s0-2.2,0-3.3q.1-1.7.1-3.4.1-1.6.1-3.3.1-1.7.2-3.4q0-1.7.2-3.4c0-.5.1-1.3.2-2c.2-.8.5-1.5,1-1.9-.1,1.2-.2,2.4-.2,3.5-.1,1.2-.1,2.4-.2,3.5-.1,2.1-.3,4.2-.4,6.4c0,2.1.1,4.3.5,6.3q.3,1.6.9,3q.6,1.5,1.4,2.8.1.1.2.2q0,0,.1.1Z",
    fill: "url(#eIoXAxwJW5C186-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1842.6,1300.2h-.1c-1.7-.4-3.4-1-5-1.7-1.7-.7-3.2-1.6-4.7-2.6-1.2-.8-2.4-1.9-3.4-3.1s-1.7-2.5-2.1-4.1q-.4-1.3-.4-2.6t.4-2.6c.1-.9.4-1.7.9-2.4s1.1-1.3,1.8-1.8q.2-.1.3-.1.2-.1.4-.2c2.3,3.6,4.4,7,6.4,10.4c2,3.5,3.8,7,5.5,10.8Z",
    fill: "#b20909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C188",
    transform: "translate(0-1214.030641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2565.4,1255.6c-.6,3.4-1.5,6.6-3.1,9.3s-3.7,4.9-6.7,6.2h-43-42.9q-1-.1-2.1-.2-1.1-.2-2.2-.3-1-.3-2-.8-.9-.6-1.7-1.4c-3.5-3.5-4.4-8.4-3.6-13.2.9-4.8,3.4-9.4,6.9-12.3c2.2-1.9,4.8-3.3,7.5-4.3c2.8-1.1,5.7-1.8,8.5-2.4c3.4-.8,6.7-1.5,9.9-2c3.3-.6,6.5-1.1,9.8-1.5q1.8-.2,3.7-.4q1.8-.3,3.6-.4q2.4-.3,4.8-.5t4.8-.3q6.5-.4,12.9-.3q6.5.2,12.9,1c2.9.3,6.8.5,10.4,1.3c3.7.9,7.1,2.3,9.1,4.9q.2.3.4.6t.3.7c1.4,2.4,2,5.2,2.2,8s0,5.7-.4,8.3Z",
    fill: "url(#eIoXAxwJW5C189-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2563.6,1239.3c-1.6.3-2.8.9-3.9,1.4-1.1.4-2.1.7-3.3.4-1.6,2.4-3.3,4.9-5.2,7.2-1.8,2.4-3.8,4.6-5.9,6.6-.9.9-1.8,1.8-2.8,2.3-.9.6-1.9.6-3-.4-.9-.9-2.1-2-3.4-3s-2.6-1.9-3.7-2.7c-.6-.4-2.2-1.4-3.9-2.4-1.6-.9-3.2-1.7-3.7-1.9-.4,1.3-1.2,3-2.3,4.6-1,1.6-2.2,3.1-3.3,4-1.1-.9-2.2-1.8-3.4-2.7-1.3-1-2.7-2.1-4.4-3.2-1.3-.9-2.1-1.5-3-1.8-.8-.3-1.7-.2-3.1.2-2.6.7-5.1,1.4-7.6,1.6s-4.9,0-7.5-1.3c-1.4-.6-2.6-1.7-3.8-2.8-1.3-1-2.5-2-3.9-2.4.2,0,.3,1.3.4,2.7.2,1.4.3,2.9.3,3.3q.3,1.3.8,2.6t1.2,2.5c.9,1.8,2,3.4,3.3,4.8c1.4,1.4,2.8,2.7,4.4,3.9c2.4,1.7,5,3,7.7,4.2c2.6,1.1,5.4,2.1,8.2,2.9q1.1.3,2.2.6t2.2.6h-23-23q-.9,0-1.8-.1t-1.8-.3q-1-.2-2-.8-.9-.5-1.7-1.4c-3.5-3.5-4.4-8.4-3.6-13.1.9-4.8,3.4-9.4,6.9-12.4c2.2-1.9,4.8-3.2,7.5-4.3c2.8-1,5.7-1.8,8.5-2.4q5.3-1.2,10.7-2.1q5.4-.8,10.8-1.5q1.8-.2,3.7-.4q1.8-.3,3.6-.4q2.4-.3,4.8-.5t4.8-.3q6.5-.4,12.9-.3q6.5.2,12.9,1c2.9.3,6.8.5,10.4,1.3c3.7.9,7.1,2.3,9.1,4.9q.2.3.4.6t.3.7Z",
    fill: "url(#eIoXAxwJW5C190-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2499.5,1241.5c3.6,0,8,1,12.1,2.8c4,1.8,7.6,4.4,9.4,7.5c1.3-2.4,2.6-4.8,3.6-7.4s1.8-5.3,1.9-8.1c-2.1-1-4.4-1.8-6.8-2.3-2.4-.6-4.9-.9-7.2-1-2.3-.2-5.2-.2-8.1.1-2.8.2-5.6.8-7.8,1.7.1,1.4.4,2.7.8,3.9.5,1.2,1.2,2.2,2.1,2.8Z",
    fill: "#ffd3ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2556.4,1230.3q0,1.6-.3,3.4-.3,1.7-.9,3.4-.7,2.1-1.6,4.1-.9,1.9-2,3.7c-.8,1.2-2.8,3.9-4.9,6.2-2.2,2.2-4.4,4.1-5.7,3.7-.7-.1-1.6-1-2.5-1.9-1-1-1.9-2-2.4-2.4q-1.2-1.1-2.4-2-1.3-.9-2.7-1.7c-1.6-1-3.1-1.9-4.7-2.7s-3.1-1.5-4.8-2.1q-.9-.3-1.7-.6t-1.7-.6c-1.8-.6-3.7-1.5-5.5-2.2-1.9-.8-3.7-1.4-5.7-1.5-2.3-2.5,1.7-4.5,6.7-6c5.1-1.5,11-2.4,12.4-2.5c5.1-.7,10.2-.8,15.3-.5c5,.4,10.1,1.1,15.1,2.2Z",
    fill: "#ffe2c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2556.4,1230.3q0,1.6-.3,3.4-.3,1.7-.9,3.4c-.8-.5-1.7-.8-2.7-1-.9-.2-1.9-.3-2.6-.3-1.4-.2-2.6,0-3.7.4-1.2.4-2.3.9-3.5,1.4-2.4,1-4.9,1-7.4.8-2.4-.1-5-.3-7.4.3-1.2.3-2.3.8-3.3,1.4-1.1.5-2.1,1.2-3.1,1.9q-.9-.3-1.7-.6t-1.7-.6c-1.8-.6-3.7-1.5-5.5-2.2-1.9-.8-3.7-1.4-5.7-1.5-2.3-2.5,1.7-4.5,6.7-6c5.1-1.5,11-2.4,12.4-2.5c5.1-.7,10.2-.8,15.3-.5c5,.4,10.1,1.1,15.1,2.2Z",
    fill: "#ffc88d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2508.6,1238.8c3-1.4,6.5-2.1,10.1-2.3c3.7-.3,7.4-.1,10.8,0c3.7.2,7.3.7,11,1.3c3.6.5,7.2,1.2,10.9,1.7q2.4.3,4.8.3q2.5,0,4.8-.5c2.9-.6,3-1.9,2-3.2-.9-1.3-3-2.6-4.4-3.2-5.3-2.4-11.2-3.5-17.3-3.7-6-.3-12.1.2-17.8.8-2.9.3-6.1.8-9.1,1.6-3.1.9-6,2-8.4,3.7-.8.5-1.7,1.2-2.3,2-.5.9-.7,1.8.2,2.7.8.8,1.7.6,2.6.3.9-.4,1.8-1.1,2.6-1.5c0,.1,0,.2-.1.2c0,0-.2-.1-.4-.2Z",
    fill: "#7a3b08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2557.1,1226.5c-1.6.5-4,0-6.3-.6s-4.7-1.5-6.3-1.8q-3.7-.7-7.5-1.2-3.7-.4-7.6-.8c-5.4-.7-10.9-.9-16.4-.7s-11,.7-16.4,1.5q-4.3.6-8.5,1.4-4.3.8-8.5,1.8c-1.3.3-2.7.7-4,1.1-1.4.4-2.8.8-4.1,1.1-1.3.2-2,.2-2.7-.1s-1.4-.9-2.4-1.7c-.7-.5-1.4-1.1-2.1-1.7s-1.3-1.2-1.8-2c-1.3-1.8-1.8-4-1.8-6.3c0-2.2.5-4.6,1.1-6.7q1-3.2,2.4-6.3q1.3-3,3.1-5.9c1.2-2,2.4-3.4,3.7-4.6s2.7-2.2,4.5-3.6q.3-.1.5-.3.2-.1.4-.2c6.5-3.7,14.8-6.2,23.3-7.5c8.5-1.2,17.2-1.2,24.5.3c7.8,1.5,15,4,20.8,8c5.9,4.1,10.5,9.7,13,17.5.2.7.5,1.6.8,2.7.2,1,.5,2.3.7,3.6.4,2.7.7,5.7.4,8.2-.3,2.4-1.1,4.3-2.8,4.8Z",
    fill: "url(#eIoXAxwJW5C195-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2510.9,1193.5q.3.4.7.7.3.4.7.7c4.1,3.9,8.2,7.1,12.7,9.5s9.4,4,15.1,4.6c1.8.2,3.9.5,5.9.4s3.9-.6,5.4-1.9c3.2-2.9,1.3-6.7-1.8-10-3.1-3.4-7.5-6.3-9.5-7.5-3.7-2.3-7.8-3.9-12-4.8s-8.6-1-12.9-.2c-2.2.4-4,1.2-5,2.6-.9,1.3-1,3.2.5,5.5q0,.1.1.2q0,.1.1.2Z",
    fill: "url(#eIoXAxwJW5C197-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2557.1,1226.5c-1.6.5-4,0-6.3-.6s-4.7-1.5-6.3-1.8q-3.7-.7-7.5-1.2-3.7-.4-7.6-.8c-11.8-1.3-24.1-.7-36.2,1.3-12.1,1.9-24,5.2-35.1,9.2-.2-.2-.4-.7-.6-1.1-.1-.5-.3-.9-.5-1.2-3.8-7.6-2.3-15.9,1.6-23.3c4-7.3,10.5-13.7,16.9-17.6c3.2,5.3,8.1,9.5,13.6,12.7s11.7,5.5,17.7,7.1c8.6,2.2,17.4,3.8,26.2,4.5s17.7.7,26.5-.2c.4,2.7.7,5.7.4,8.2-.3,2.4-1.1,4.3-2.8,4.8Z",
    fill: "url(#eIoXAxwJW5C198-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2487.1,1270.7c.1,2.2.3,4.4.2,6.6c0,2.2-.2,4.4-.7,6.5-.1.5-.3,1.1-.6,1.7-.3.5-.6,1.1-1.1,1.4-.4.4-.8.6-1.3.7-.5,0-1-.2-1.6-.6-.7-.5-1-1.7-1.1-2.9s0-2.5,0-3.3c.2-4.3.7-8.6,1-12.9.3-4.2.4-8.5-.1-12.9-.1-1-.2-2.4-.4-3.9s-.5-3-.9-4.5c-.3-.9-.6-1.9-1-2.7s-.8-1.5-1.4-2c-.7-.6-1.5-.9-2.4-1.1s-1.8-.2-2.7,0c-1.2.1-2.3.4-3.4.6-1.2.3-2.2.5-3.2.5-.4-.3-.8-.5-1.2-.7s-.8-.4-1.2-.6c1.5-2.5,4.8-4,8.4-4.9c3.6-.8,7.4-1.1,10-1.1c1.2,0,2.7,0,4,.4c1.3.3,2.4,1,2.8,2.4.3,1.1,0,2.5-.5,3.8s-1.2,2.5-1.5,3.6q-.1.2-.2.5t-.1.6c-1.2,4.2-1.3,8.3-1,12.4s1,8.2,1.2,12.4Z",
    fill: "#e24040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2487.2,1244.8q-.1.2-.2.5t-.1.6c-.5-.4-1.3-.5-2.2-.4-.8.1-1.8.4-2.7.7q.1.8.3,1.6.2.9.3,1.7.3,2,.3,3.9.1,2,.1,4q0,3.4-.2,6.8-.1,3.4-.4,6.8-.1,2-.3,4-.1,2-.3,3.9c-.1,1.4-.2,2.9.1,4.3.4,1.4,1,2.6,2.4,3.4q.2.1.3.2.2.1.3.1c-.4.4-.8.6-1.3.7-.5,0-1-.2-1.6-.6-.7-.5-1-1.7-1.1-2.9s0-2.5,0-3.3c.2-4.3.7-8.6,1-12.9.3-4.2.4-8.5-.1-12.9-.1-1-.2-2.4-.4-3.9s-.5-3-.9-4.5c-.3-.9-.6-1.9-1-2.7s-.8-1.5-1.4-2c-.7-.6-1.5-.9-2.4-1.1s-1.8-.2-2.7,0c-1.2.1-2.3.4-3.4.6-1.2.3-2.2.5-3.2.5-.4-.3-.8-.5-1.2-.7s-.8-.4-1.2-.6c1.5-2.5,4.8-4,8.4-4.9c3.6-.8,7.4-1.1,10-1.1c1.2,0,2.7,0,4,.4c1.3.3,2.4,1,2.8,2.4.3,1.1,0,2.5-.5,3.8s-1.2,2.5-1.5,3.6Z",
    fill: "#b20909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2572.5,1222.2c-.5,1.1-1.2,2-1.7,3s-.8,2-.8,3.3c0,.8.3,1.7.5,2.5s.4,1.6.3,2.3q-.1.5-.4.9t-.9.8c-.8.5-1.7.7-2.7.8-.9.1-1.9.1-2.8.2-1.2.2-2.3.5-3.4.7s-2.2.2-3.4,0c-2-.4-4.1-1.3-6.1-2-2.1-.8-4.2-1.6-6.4-1.7q-.2,0-.4,0-.2-.1-.4-.1t-.4.1q-.3,0-.5.1c-1,.1-1.8.4-2.7.8-.8.4-1.7.8-2.6,1-1.2.3-2.3.1-3.3-.3s-2-.9-3.2-1.2q-.4-.1-.9-.2t-.9-.2c-2-.3-4.1-.3-6.1,0-2,.4-3.9,1-5.5,2.1q-1.2.8-2.3,1.7-1.1,1-2,2-.4.4-.7.9-.3.4-.6.9c-1.7,2.5-3.6,4.2-5.8,4.9-2.3.7-4.7.3-7.5-1.5-1.2-.8-2.2-1.7-3.3-2.6-1.1-1-2.2-1.9-3.4-2.7-2.5-1.8-5.5-2.9-8.4-4-2.9-1.2-5.7-2.5-8-4.6-.3-.3-.7-.7-1-1.2-.2-.4-.4-.9-.3-1.4c0-.4.2-.8.4-1.2.3-.3.6-.6,1-.9c4.5-4,9.3-6.2,14.3-7.3c5.1-1.1,10.5-1.3,16.2-1.3q2.5,0,5,.1t5.1.3q3.4.2,6.7.5q3.4.4,6.7.8c3.7.5,7.4,1.2,11,2c3.7.7,7.3,1.4,11,1.9c1.2.1,2.5,0,3.8-.1c1.3-.2,2.5-.4,3.5-.2c1.3.2,2.1.8,3,1.2.8.4,1.7.5,3.2-.3.9-.5,1.7-1.6,2.5-2.6.8-1.1,1.6-2,2.5-2.4c1.7-.6,2.4,0,2.6,1s-.1,2.3-.5,3.2Z",
    fill: "#c8cc2b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2493,1200q-.1.2-.2.4q0,.2-.1.3q0,.1,0,.2-.1,0-.1.1q0,0,0,0q0,.1,0,.1-.1.1-.1.2-.1.1-.2.3-.2.4-.3.8-.2.5-.3,1q0,.2.1.4t.3.2q.2.1.4,0t.3-.3q.1-.3.1-.6.1-.3.2-.6q0-.1.1-.1q0,0,0-.1q0,0,0,0t0,0q0-.1.1-.1q0-.1,0-.1.2-.4.4-.9.2-.4.3-.9.1-.2,0-.4t-.3-.3q-.3,0-.5.1-.1.1-.2.3Z",
    fill: "url(#eIoXAxwJW5C203-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2507,1188.9q-.2-.1-.4.1-.2.1-.3.3q0,.2.1.4t.3.3c0,0,0,0,0,0c0-.1-.1-.1,0,0q0,0,0,0t0,0q.1,0,.1,0q.1.1.1.1.1.1.2.1.1.1.2.2q0,0,.1,0q0,0,0,0c.1.1,0,.1,0,.1c0-.1,0-.1,0,0q.1,0,.2.1q0,0,.1,0q.1.1.2.3.1.1.3.2.5.4,1,.9t.9.9q.2.2.4.2.3,0,.4-.2.2-.1.2-.4q0-.2-.2-.3-.5-.6-1-1-.5-.5-1-1-.5-.4-.9-.7-.5-.4-1-.6Z",
    fill: "url(#eIoXAxwJW5C204-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2516.5,1205q-.2.1-.2.4q0,.2.2.3.2.2.4.2t.4-.2q.9-.7,1.7-1.6.9-.8,1.7-1.6.2-.2.2-.4t-.2-.4-.4-.2-.4.2q-.8.8-1.7,1.7-.8.8-1.7,1.6Z",
    fill: "url(#eIoXAxwJW5C205-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2545.9,1203.1q-.3.2-.5.4-.3.2-.6.4q0,.1,0,.1-.1.1-.1.1-.1,0-.1,0t0,.1q-.1,0-.2.1q0,0-.1.1-.4.3-.9.6-.4.3-.8.6-.2.1-.3.3q0,.2.1.4t.3.3q.2,0,.4-.1.5-.3.9-.6t.9-.6q.4-.3.9-.7.4-.3.8-.7.2-.2.2-.4t-.2-.4q-.1-.1-.4-.1-.2,0-.3.1Z",
    fill: "url(#eIoXAxwJW5C206-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2474.1,1208.4q-.1,0-.1,0-.1,0-.1-.1-.1,0-.1,0-.1,0,0,0-.1,0-.2-.1-.1,0-.2,0-.4-.3-.9-.5t-.9-.4q-.2-.1-.5-.1-.2.1-.3.3t0,.4q0,.2.2.3.5.3,1,.5.4.2.9.4.5.3,1,.5.6.2,1.1.4.2,0,.4-.1t.3-.3q0-.3-.1-.4-.1-.2-.3-.3-.3-.1-.6-.2t-.6-.3Z",
    fill: "url(#eIoXAxwJW5C207-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2482.9,1189.9q-.2.5-.5,1-.2.4-.5.9-.2.5-.4,1-.2.4-.4.9-.1.2-.1.4q0,.3.3.4.1.1.4,0q.2,0,.3-.2.2-.5.4-1q.3-.5.5-1q.2-.4.5-.9.2-.4.5-.9.1-.2,0-.4q0-.2-.2-.4-.2-.1-.4,0-.3,0-.4.2Z",
    fill: "url(#eIoXAxwJW5C208-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2506.4,1216.8q2.5,0,5,.1t5.1.3q-.4.2-.7.4-.4.2-.7.4c-2.5,1.3-5,2.4-7.5,3.4-2.5,1.1-5,2-7.5,3.1-1.2.5-4.4,1.6-7,3-2.7,1.5-4.9,3.3-4.3,5.2.5,1.3,2.3,1.6,4.2,1.6c2,0,4.1-.3,5.1-.3c1.9,0,3.6,0,5.2.4c1.6.3,3.1.9,4.8,1.9.9.6,1.8,1.1,2.7,1.6.8.4,1.7.8,2.7.9q-.4.4-.7.9-.3.4-.6.9c-.8,1.1-1.4,2.1-2.2,3-.7.8-1.6,1.4-2.8,1.8q-1.3.3-2.6.6-1.2.2-2.5.4c-.6.1-1.1.3-1.7.5-.5.1-1.1.2-1.8.2-1.5-.1-3-.4-4.4-.9-1.4-.4-2.8-1.1-4-2-1.5-1.1-3-2.2-4.6-3.1-1.6-1-3.3-1.9-5.1-2.4-2.7-.9-5.3-.3-7.8.9-2.4,1.2-4.8,2.8-7,4-.6.2-1.1.5-1.6.7-.6.2-1.1.3-1.7.4s-1.2,0-1.8-.1c-.6-.2-1.1-.5-1.5-.9q-.3-.5-.5-.9-.2-.5-.4-.9c-.3-1.1-.6-2.3-1-3.4s-1-2-2.2-2.6c-1-.5-2-.5-2.9-.1s-1.6,1.2-2.2,2.1c-.7.8-1.3,2.1-2,3.2-.7,1.2-1.5,2.2-2.6,2.7-.8.4-2,.4-2.9.1s-1.6-.9-1.7-1.7c-.2-2.6,1.5-5.2,3.7-7.4c2.2-2.3,4.9-4.2,6.8-5.4q2.8-1.8,5.7-3.3t5.9-2.6c6.9-2.8,14.1-4.4,21.4-5.4s14.8-1.3,22.2-1.3Z",
    fill: "url(#eIoXAxwJW5C209-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2493.8,1200q0,.2-.1.4t-.1.3-.1.2q0,0,0,.1c0,0,0,0,0,0s0-.1,0,0q0,0,0,0q0,.1-.1.1q0,.1-.1.2q0,.1-.1.3-.2.4-.4.8-.1.5-.2,1-.1.2,0,.4t.4.2q.2.1.4,0t.2-.3q.1-.3.2-.6t.2-.6q0-.1,0-.1q0-.1.1-.1c0,0,0,0-.1,0c0,.1,0,.1,0,.1q0-.1,0-.1.1,0,.1,0q0-.1,0-.1q0-.1.1-.1.2-.4.4-.9.2-.4.3-.9.1-.2,0-.4-.2-.2-.4-.3-.2,0-.4.1t-.3.3Z",
    fill: "#ffe5d4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2507.6,1190c0,0,0,0-.1,0c0-.1,0-.1,0,0q0,0,.1,0q0,0,0,0t.1,0q0,.1.1.1.1.1.2.1.1.1.2.2q0,0,0,0t.1,0c0,.1,0,.1,0,.1c0-.1,0-.1,0,0q.1,0,.1.1.1,0,.1,0q.1.1.3.3.1.1.2.2.5.4,1,.9t1,.9q.2.2.4.2t.4-.2q.1-.1.1-.4q0-.2-.1-.3-.5-.6-1-1-.5-.5-1.1-1-.4-.4-.9-.7-.4-.4-.9-.6-.3-.1-.5.1-.2.1-.2.3-.1.2,0,.4t.4.3Z",
    fill: "#ffe5d4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2518.1,1205.7q.9-.7,1.8-1.6.8-.8,1.7-1.6.1-.2.1-.4t-.1-.4q-.2-.2-.4-.2-.3,0-.4.2-.9.8-1.7,1.7-.9.8-1.8,1.6-.1.1-.1.4q0,.2.1.3.2.2.4.2t.4-.2Z",
    fill: "#ffe5d4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2544,1206.5q.4-.3.9-.6.4-.3.8-.6.5-.3.9-.7.5-.3.9-.7.2-.2.2-.4t-.2-.4q-.2-.1-.4-.1t-.4.1q-.2.2-.5.4-.2.2-.5.4q0,.1-.1.1q0,.1-.1.1q0,0,0,0t-.1.1c0,0,0,0,0,0c.1-.1.1-.1.1-.1q-.1.1-.2.2-.1,0-.1.1-.5.3-.9.6t-.8.6q-.2.1-.3.3t.1.4q.1.2.3.3.2,0,.4-.1Z",
    fill: "#ffe5d4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2471.9,1208.2q.4.3.9.5t1,.4q.5.3,1,.5t1.1.4q.2,0,.4-.1t.2-.3q.1-.3,0-.4-.1-.2-.3-.3-.3-.1-.7-.2-.3-.1-.6-.3q0,0-.1,0q0,0-.1-.1q0,0-.1,0q0,0,0,0t-.1-.1q-.1,0-.2,0-.5-.3-.9-.5-.5-.2-1-.4-.2-.1-.4-.1-.2.1-.3.3t-.1.4q.1.2.3.3Z",
    fill: "#ffe5d4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2483.8,1189.9q-.3.5-.5,1-.3.4-.5.9t-.5,1q-.2.4-.4.9-.1.2,0,.4q0,.3.2.4t.4,0q.3,0,.4-.2.2-.5.4-1t.5-.9q.2-.5.4-1q.3-.4.5-.9.1-.2.1-.4-.1-.2-.3-.4-.2-.1-.4,0-.2,0-.3.2Z",
    fill: "#ffe5d4"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2485.2,1282.7c.5-.5.8-1.4.9-2.4.2-1,.2-2,.3-2.7.1-1.1.1-2.3,0-3.5s-.3-2.3-.6-3.4q0-.2-.1-.3-.1-.2-.3-.2-.2.1-.3.2q0,.2-.1.4-.3,1.8-.5,3.6t-.5,3.6c-.1.6-.3,2.3-.3,3.6.1,1.3.4,2.2,1.5,1.1Z",
    fill: "#ffc0c0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C224",
    transform: "translate(0-1139.480713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2565.4,1181.1c-.7,4-1.9,7.8-4.1,10.8-2.1,2.9-5.2,5.1-9.5,6-3.8.7-7.9,1.2-11.9,1.4-4,.3-8.1.3-12.1.3h-1-1c-7,0-14.1-.1-21.3-.4-7.1-.2-14.3-.6-21.4-1.2q-.9,0-1.7-.1-.9,0-1.8-.2c-2.7-.2-4.9-.4-7.1-.7s-4.5-.7-7.1-1q-1-.2-2-.8-.9-.5-1.7-1.4c-3.5-3.5-4.4-8.4-3.6-13.2.9-4.7,3.4-9.3,6.9-12.3c2.2-1.9,4.8-3.3,7.5-4.3c2.8-1.1,5.7-1.8,8.5-2.4c6.3-1.4,12.2-2.5,18.2-3.3s12.1-1.3,18.4-1.8q6.5-.4,12.9-.2q6.5.1,12.9.9c2.9.3,6.8.6,10.4,1.4c3.7.8,7.1,2.2,9.1,4.9q.2.3.4.6t.3.6c1.4,2.4,2,5.2,2.2,8s0,5.7-.4,8.4Z",
    fill: "url(#eIoXAxwJW5C225-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2563.6,1164.7c-1.6.4-2.8,1-3.9,1.4s-2.1.7-3.3.4c-1.6,2.5-3.3,4.9-5.2,7.3-1.8,2.3-3.8,4.5-5.9,6.6-.9.8-1.8,1.8-2.8,2.3-.9.5-1.9.6-3-.5-.9-.9-2.1-1.9-3.4-2.9s-2.6-2-3.7-2.8c-.6-.4-2.2-1.4-3.9-2.3-1.6-1-3.2-1.8-3.7-2-.4,1.4-1.2,3.1-2.3,4.7-1,1.6-2.2,3-3.3,3.9-1.1-.8-2.2-1.7-3.4-2.7-1.3-1-2.7-2-4.4-3.2-1.3-.9-2.1-1.5-3-1.8-.8-.2-1.7-.2-3.1.2-2.6.8-5.1,1.5-7.6,1.7s-4.9-.1-7.5-1.4c-1.4-.6-2.6-1.7-3.8-2.7-1.3-1.1-2.5-2.1-3.9-2.5.2,0,.3,1.4.4,2.8.2,1.4.3,2.9.3,3.2q.3,1.4.8,2.7t1.2,2.5c.9,1.7,2,3.3,3.3,4.7c1.4,1.5,2.8,2.8,4.4,3.9c2.4,1.7,5,3.1,7.7,4.2c2.6,1.2,5.4,2.1,8.2,2.9q4.7,1.4,9.4,2.5q4.8,1.1,9.6,1.8h-1-1c-7,0-14.1-.1-21.3-.4-7.1-.2-14.3-.6-21.4-1.2q-.9,0-1.7-.1-.9,0-1.8-.2-4-.3-8-.7t-8-.8q-1-.3-2-.8-.9-.6-1.7-1.4c-3.5-3.5-4.4-8.4-3.6-13.2.9-4.8,3.4-9.4,6.9-12.3c2.2-1.9,4.8-3.3,7.5-4.4c2.8-1,5.7-1.7,8.5-2.4c6.3-1.4,12.7-2.4,19.1-3.3c6.5-.8,13-1.4,19.3-1.9q6.5-.4,12.9-.2q6.5.1,12.9.9c2.9.3,6.8.6,10.4,1.4c3.7.8,7.1,2.2,9.1,4.9q.2.3.4.6t.3.6Z",
    fill: "url(#eIoXAxwJW5C226-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2499.5,1166.9c3.6,0,8,1,12.1,2.8c4,1.8,7.6,4.4,9.4,7.6c1.3-2.4,2.6-4.9,3.6-7.5s1.8-5.3,1.9-8.1c-2.1-1-4.4-1.7-6.8-2.3s-4.9-.9-7.2-1-5.2-.1-8.1.1c-2.8.3-5.6.8-7.8,1.8.1,1.3.4,2.6.8,3.8.5,1.2,1.2,2.2,2.1,2.8Z",
    fill: "#ffd3ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2556.4,1155.7q0,1.7-.3,3.4t-.9,3.4q-.7,2.1-1.6,4.1t-2,3.8c-.8,1.1-2.8,3.8-4.9,6.1-2.2,2.3-4.4,4.2-5.7,3.8-.7-.2-1.6-1.1-2.5-2-1-.9-1.9-1.9-2.4-2.4q-1.2-1-2.4-1.9-1.3-1-2.7-1.8c-1.6-.9-3.1-1.8-4.7-2.6s-3.1-1.5-4.8-2.1q-.9-.4-1.7-.7t-1.7-.6c-1.8-.6-3.7-1.4-5.5-2.2-1.9-.7-3.7-1.4-5.7-1.5-2.3-2.4,1.7-4.5,6.7-6c5.1-1.4,11-2.3,12.4-2.5c5.1-.7,10.2-.8,15.3-.4c5,.3,10.1,1.1,15.1,2.1Z",
    fill: "#ffe2c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2556.4,1155.7q0,1.7-.3,3.4t-.9,3.4c-.8-.4-1.7-.7-2.7-.9-.9-.2-1.9-.3-2.6-.4-1.4-.2-2.6,0-3.7.4-1.2.4-2.3,1-3.5,1.5-2.4.9-4.9.9-7.4.8-2.4-.1-5-.3-7.4.3-1.2.3-2.3.8-3.3,1.3-1.1.6-2.1,1.3-3.1,2q-.9-.4-1.7-.7t-1.7-.6c-1.8-.6-3.7-1.4-5.5-2.2-1.9-.7-3.7-1.4-5.7-1.5-2.3-2.4,1.7-4.5,6.7-6c5.1-1.4,11-2.3,12.4-2.5c5.1-.7,10.2-.8,15.3-.4c5,.3,10.1,1.1,15.1,2.1Z",
    fill: "#ffc88d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2508.6,1164.2c3-1.4,6.5-2,10.1-2.3c3.7-.2,7.4-.1,10.8.1c3.7.2,7.3.6,11,1.2c3.6.6,7.2,1.2,10.9,1.7q2.4.4,4.8.4q2.5,0,4.8-.5c2.9-.6,3-1.9,2-3.2-.9-1.3-3-2.6-4.4-3.3-5.3-2.4-11.2-3.4-17.3-3.7-6-.3-12.1.2-17.8.8-2.9.3-6.1.8-9.1,1.7-3.1.8-6,2-8.4,3.6-.8.5-1.7,1.3-2.3,2.1-.5.8-.7,1.7.2,2.6.8.8,1.7.7,2.6.3s1.8-1.1,2.6-1.5c0,.1,0,.2-.1.2c0,0-.2,0-.4-.2Z",
    fill: "#7a3b08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2557.1,1152c-1.6.4-4,0-6.3-.7-2.3-.6-4.7-1.4-6.3-1.8q-3.7-.6-7.5-1.1-3.7-.5-7.6-.9c-5.4-.7-10.9-.8-16.4-.7-5.5.2-11,.7-16.4,1.5q-4.3.6-8.5,1.4-4.3.8-8.5,1.8c-1.3.4-2.7.8-4,1.2-1.4.4-2.8.8-4.1,1-1.3.3-2,.2-2.7-.1s-1.4-.9-2.4-1.6c-.7-.6-1.4-1.1-2.1-1.7s-1.3-1.3-1.8-2c-1.3-1.9-1.8-4.1-1.8-6.3c0-2.3.5-4.6,1.1-6.8q1-3.2,2.4-6.3q1.3-3,3.1-5.9c1.2-2,2.4-3.3,3.7-4.5s2.7-2.3,4.5-3.6q.3-.2.5-.3.2-.2.4-.3c6.5-3.7,14.8-6.2,23.3-7.4c8.5-1.3,17.2-1.2,24.5.2c7.8,1.6,15,4,20.8,8.1c5.9,4,10.5,9.6,13,17.4.2.7.5,1.6.8,2.7.2,1.1.5,2.3.7,3.6.4,2.7.7,5.8.4,8.2-.3,2.5-1.1,4.4-2.8,4.9Z",
    fill: "url(#eIoXAxwJW5C231-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2510.9,1118.9q.3.4.7.8.3.3.7.7c4.1,3.8,8.2,7,12.7,9.4s9.4,4,15.1,4.7c1.8.2,3.9.4,5.9.3s3.9-.5,5.4-1.9c3.2-2.9,1.3-6.6-1.8-10s-7.5-6.3-9.5-7.5c-3.7-2.3-7.8-3.9-12-4.8-4.2-.8-8.6-.9-12.9-.2-2.2.4-4,1.3-5,2.6-.9,1.4-1,3.2.5,5.5q0,.1.1.2q0,.1.1.2Z",
    fill: "url(#eIoXAxwJW5C233-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2557.1,1152c-1.6.4-4,0-6.3-.7-2.3-.6-4.7-1.4-6.3-1.8q-3.7-.6-7.5-1.1-3.7-.5-7.6-.9c-11.8-1.3-24.1-.7-36.2,1.3s-24,5.2-35.1,9.3c-.2-.3-.4-.8-.6-1.2-.1-.5-.3-.9-.5-1.2-3.8-7.6-2.3-15.9,1.6-23.2c4-7.4,10.5-13.8,16.9-17.6c3.2,5.3,8.1,9.4,13.6,12.6s11.7,5.5,17.7,7.1c8.6,2.3,17.4,3.8,26.2,4.5c8.8.8,17.7.7,26.5-.2.4,2.7.7,5.8.4,8.2-.3,2.5-1.1,4.4-2.8,4.9Z",
    fill: "url(#eIoXAxwJW5C234-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2487.1,1196.2c.1,2.1.3,4.4.2,6.6c0,2.2-.2,4.4-.7,6.4-.1.5-.3,1.2-.6,1.7-.3.6-.6,1.1-1.1,1.5-.4.3-.8.6-1.3.6s-1-.1-1.6-.6c-.7-.5-1-1.6-1.1-2.8s0-2.5,0-3.3c.2-4.4.7-8.6,1-12.9s.4-8.6-.1-13c-.1-1-.2-2.4-.4-3.8-.2-1.5-.5-3.1-.9-4.5-.3-1-.6-1.9-1-2.8-.4-.8-.8-1.4-1.4-1.9-.7-.6-1.5-1-2.4-1.2-.9-.1-1.8-.1-2.7,0-1.2.2-2.3.4-3.4.7-1.2.2-2.2.4-3.2.5-.4-.3-.8-.5-1.2-.7s-.8-.4-1.2-.6c1.5-2.6,4.8-4.1,8.4-4.9c3.6-.9,7.4-1.1,10-1.2c1.2,0,2.7,0,4,.4s2.4,1.1,2.8,2.4c.3,1.2,0,2.5-.5,3.8s-1.2,2.6-1.5,3.6q-.1.3-.2.5-.1.3-.1.6c-1.2,4.2-1.3,8.3-1,12.4s1,8.2,1.2,12.5Z",
    fill: "#e24040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2487.2,1170.2q-.1.3-.2.5-.1.3-.1.6c-.5-.4-1.3-.4-2.2-.3-.8,0-1.8.3-2.7.6q.1.8.3,1.7.2.8.3,1.7.3,1.9.3,3.9.1,2,.1,3.9q0,3.5-.2,6.9-.1,3.4-.4,6.8-.1,2-.3,3.9-.1,2-.3,4c-.1,1.4-.2,2.9.1,4.2.4,1.4,1,2.6,2.4,3.5q.2,0,.3.1.2.1.3.2c-.4.3-.8.6-1.3.6s-1-.1-1.6-.6c-.7-.5-1-1.6-1.1-2.8s0-2.5,0-3.3c.2-4.4.7-8.6,1-12.9s.4-8.6-.1-13c-.1-1-.2-2.4-.4-3.8-.2-1.5-.5-3.1-.9-4.5-.3-1-.6-1.9-1-2.8-.4-.8-.8-1.4-1.4-1.9-.7-.6-1.5-1-2.4-1.2-.9-.1-1.8-.1-2.7,0-1.2.2-2.3.4-3.4.7-1.2.2-2.2.4-3.2.5-.4-.3-.8-.5-1.2-.7s-.8-.4-1.2-.6c1.5-2.6,4.8-4.1,8.4-4.9c3.6-.9,7.4-1.1,10-1.2c1.2,0,2.7,0,4,.4s2.4,1.1,2.8,2.4c.3,1.2,0,2.5-.5,3.8s-1.2,2.6-1.5,3.6Z",
    fill: "#b20909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2572.5,1147.7c-.5,1.1-1.2,2-1.7,2.9-.5,1-.8,2-.8,3.3c0,.9.3,1.7.5,2.6.2.8.4,1.6.3,2.3q-.1.4-.4.9-.3.4-.9.7c-.8.5-1.7.7-2.7.8-.9.1-1.9.1-2.8.2-1.2.2-2.3.5-3.4.7s-2.2.3-3.4,0c-2-.4-4.1-1.2-6.1-2-2.1-.8-4.2-1.5-6.4-1.6q-.2-.1-.4-.1t-.4,0-.4,0q-.3,0-.5.1c-1,.2-1.8.5-2.7.9-.8.3-1.7.7-2.6.9-1.2.3-2.3.1-3.3-.3-1-.3-2-.8-3.2-1.1q-.4-.2-.9-.3t-.9-.1c-2-.3-4.1-.3-6.1,0s-3.9.9-5.5,2q-1.2.8-2.3,1.8-1.1.9-2,2-.4.4-.7.8-.3.5-.6,1c-1.7,2.4-3.6,4.2-5.8,4.9-2.3.7-4.7.3-7.5-1.5-1.2-.8-2.2-1.7-3.3-2.7-1.1-.9-2.2-1.9-3.4-2.7-2.5-1.7-5.5-2.8-8.4-4s-5.7-2.4-8-4.5c-.3-.4-.7-.8-1-1.2-.2-.5-.4-.9-.3-1.4c0-.5.2-.9.4-1.2.3-.4.6-.7,1-1c4.5-4,9.3-6.1,14.3-7.3c5.1-1.1,10.5-1.2,16.2-1.2q2.5,0,5,.1t5.1.3q3.4.1,6.7.5q3.4.3,6.7.7c3.7.5,7.4,1.3,11,2c3.7.7,7.3,1.5,11,1.9c1.2.2,2.5,0,3.8-.1c1.3-.2,2.5-.3,3.5-.2c1.3.2,2.1.8,3,1.2.8.4,1.7.6,3.2-.3.9-.5,1.7-1.6,2.5-2.6s1.6-2,2.5-2.4c1.7-.6,2.4,0,2.6,1s-.1,2.4-.5,3.3Z",
    fill: "#c8cc2b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2493,1125.5q-.1.1-.2.3q0,.2-.1.4q0,0,0,.1-.1.1-.1.1t0,.1q0,0,0,0-.1.1-.1.3-.1.1-.2.2-.2.4-.3.9-.2.4-.3.9q0,.2.1.4t.3.3q.2,0,.4-.1t.3-.3q.1-.3.1-.6.1-.3.2-.6q0,0,.1-.1q0,0,0,0t0,0q0-.1,0-.1t.1-.1q0,0,0-.1.2-.4.4-.8.2-.5.3-.9.1-.3,0-.5t-.3-.2q-.3-.1-.5,0-.1.1-.2.4Z",
    fill: "url(#eIoXAxwJW5C239-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2507,1114.3q-.2,0-.4.1t-.3.3q0,.3.1.5.1.1.3.2c0,0,0,0,0,0s-.1,0,0,0q0,0,0,0t0,0q.1.1.1.1.1,0,.1,0q.1.1.2.2.1,0,.2.1q0,0,.1,0q0,.1,0,.1c.1,0,0,0,0,0s0,0,0,0q.1.1.2.1q0,0,.1.1t.2.2.3.2q.5.5,1,.9.5.5.9,1q.2.1.4.1.3,0,.4-.1.2-.2.2-.4t-.2-.4q-.5-.5-1-1t-1-1q-.5-.3-.9-.7-.5-.3-1-.6Z",
    fill: "url(#eIoXAxwJW5C240-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2516.5,1130.4q-.2.2-.2.4t.2.4q.2.1.4.1t.4-.1q.9-.8,1.7-1.6.9-.8,1.7-1.7.2-.1.2-.4q0-.2-.2-.4-.2-.1-.4-.1t-.4.1q-.8.9-1.7,1.7-.8.8-1.7,1.6Z",
    fill: "url(#eIoXAxwJW5C241-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2545.9,1128.6q-.3.2-.5.4-.3.2-.6.4q0,0,0,.1-.1,0-.1,0-.1,0-.1.1q0,0,0,0-.1,0-.2.1q0,.1-.1.1-.4.3-.9.6-.4.3-.8.6-.2.1-.3.3q0,.3.1.5.1.1.3.2t.4,0q.5-.3.9-.6t.9-.6q.4-.4.9-.7.4-.4.8-.8.2-.1.2-.3q0-.3-.2-.4-.1-.2-.4-.2-.2,0-.3.2Z",
    fill: "url(#eIoXAxwJW5C242-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2474.1,1133.9q-.1,0-.1-.1-.1,0-.1,0-.1,0-.1-.1-.1,0,0,.1-.1-.1-.2-.1-.1-.1-.2-.1-.4-.2-.9-.4-.5-.3-.9-.5-.2-.1-.5,0-.2,0-.3.2t0,.4q0,.3.2.4.5.2,1,.4.4.3.9.5t1,.4q.6.2,1.1.4.2.1.4,0q.2-.2.3-.4q0-.2-.1-.4t-.3-.3q-.3-.1-.6-.2t-.6-.2Z",
    fill: "url(#eIoXAxwJW5C243-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2482.9,1115.4q-.2.4-.5.9-.2.5-.5.9-.2.5-.4,1t-.4,1q-.1.2-.1.4t.3.3q.1.1.4.1.2-.1.3-.3.2-.5.4-.9.3-.5.5-1t.5-.9q.2-.5.5-1q.1-.2,0-.4q0-.2-.2-.3t-.4-.1q-.3.1-.4.3Z",
    fill: "url(#eIoXAxwJW5C244-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2506.4,1142.3q2.5,0,5,.1t5.1.3q-.4.2-.7.4-.4.2-.7.3c-2.5,1.3-5,2.4-7.5,3.5-2.5,1-5,2-7.5,3-1.2.5-4.4,1.6-7,3.1-2.7,1.4-4.9,3.2-4.3,5.1.5,1.3,2.3,1.7,4.2,1.6c2,0,4.1-.3,5.1-.3c1.9,0,3.6.1,5.2.4s3.1.9,4.8,1.9c.9.6,1.8,1.1,2.7,1.6.8.4,1.7.8,2.7,1q-.4.4-.7.8-.3.5-.6,1c-.8,1-1.4,2.1-2.2,2.9-.7.8-1.6,1.5-2.8,1.8q-1.3.4-2.6.6-1.2.2-2.5.4c-.6.2-1.1.4-1.7.5-.5.2-1.1.3-1.8.2-1.5,0-3-.3-4.4-.8s-2.8-1.2-4-2c-1.5-1.1-3-2.2-4.6-3.2s-3.3-1.8-5.1-2.4c-2.7-.9-5.3-.2-7.8.9-2.4,1.2-4.8,2.9-7,4-.6.3-1.1.5-1.6.7-.6.2-1.1.4-1.7.4-.6.1-1.2.1-1.8-.1s-1.1-.5-1.5-.9q-.3-.4-.5-.9-.2-.4-.4-.9c-.3-1.1-.6-2.3-1-3.4-.4-1-1-2-2.2-2.5-1-.6-2-.5-2.9-.1s-1.6,1.2-2.2,2c-.7.9-1.3,2.1-2,3.3-.7,1.1-1.5,2.2-2.6,2.7-.8.3-2,.3-2.9,0-.9-.2-1.6-.8-1.7-1.7-.2-2.6,1.5-5.1,3.7-7.4c2.2-2.2,4.9-4.1,6.8-5.3q2.8-1.9,5.7-3.3q2.9-1.5,5.9-2.7c6.9-2.7,14.1-4.4,21.4-5.4c7.3-.9,14.8-1.2,22.2-1.2Z",
    fill: "url(#eIoXAxwJW5C245-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2493.8,1125.5q0,.1-.1.3t-.1.4q0,0-.1.1q0,.1,0,.1c0,.1,0,.1,0,0c0,0,0,0,0,0q0,0,0,.1q0,0-.1,0q0,.1-.1.3q0,.1-.1.2-.2.4-.4.9-.1.4-.2.9-.1.2,0,.4t.4.3q.2,0,.4-.1t.2-.3q.1-.3.2-.6t.2-.6q0,0,0-.1q0,0,.1,0c0-.1,0-.1-.1,0c0,0,0,0,0,0q0,0,0,0q.1,0,.1-.1q0,0,0-.1q0,0,.1-.1.2-.4.4-.8.2-.5.3-.9.1-.3,0-.5-.2-.2-.4-.2-.2-.1-.4,0t-.3.4Z",
    fill: "#ffe5d4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2507.6,1115.4c0,0,0,0-.1,0c0,0,0,0,0,0q0,0,.1,0q0,0,0,0q0,.1.1.1q0,0,.1,0q.1.1.2.2.1,0,.2.1q0,0,0,0q0,.1.1.1c0,0,0,0,0,0s0,0,0,0q.1.1.1.1.1,0,.1.1.1.1.3.2.1.1.2.2.5.5,1,.9.5.5,1,1q.2.1.4.1t.4-.1q.1-.2.1-.4t-.1-.4q-.5-.5-1-1t-1.1-1q-.4-.3-.9-.7-.4-.3-.9-.6-.3,0-.5.1t-.2.3q-.1.3,0,.5.1.1.4.2Z",
    fill: "#ffe5d4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2518.1,1131.2q.9-.8,1.8-1.6.8-.8,1.7-1.7.1-.1.1-.4q0-.2-.1-.4-.2-.1-.4-.1-.3,0-.4.1-.9.9-1.7,1.7-.9.8-1.8,1.6-.1.2-.1.4t.1.4q.2.1.4.1t.4-.1Z",
    fill: "#ffe5d4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2544,1132q.4-.3.9-.6.4-.3.8-.6.5-.4.9-.7.5-.4.9-.8.2-.1.2-.3q0-.3-.2-.4-.2-.2-.4-.2t-.4.2-.5.4q-.2.2-.5.4q0,0-.1.1q0,0-.1,0q0,.1,0,.1t-.1,0c0,0,0,0,0,0c.1,0,.1,0,.1,0q-.1,0-.2.1t-.1.1q-.5.3-.9.6t-.8.6q-.2.1-.3.3-.1.3.1.5.1.1.3.2t.4,0Z",
    fill: "#ffe5d4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2471.9,1133.7q.4.2.9.4.5.3,1,.5t1,.4t1.1.4q.2.1.4,0q.2-.2.2-.4.1-.2,0-.4t-.3-.3q-.3-.1-.7-.2-.3-.1-.6-.2q0,0-.1-.1q0,0-.1,0q0,0-.1-.1q0,0,0,.1q0-.1-.1-.1-.1-.1-.2-.1-.5-.2-.9-.4-.5-.3-1-.5-.2-.1-.4,0-.2,0-.3.2t-.1.4q.1.3.3.4Z",
    fill: "#ffe5d4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2483.8,1115.4q-.3.4-.5.9-.3.5-.5.9-.2.5-.5,1-.2.5-.4,1-.1.2,0,.4q0,.2.2.3t.4.1q.3-.1.4-.3.2-.5.4-.9.2-.5.5-1q.2-.5.4-.9.3-.5.5-1q.1-.2.1-.4-.1-.2-.3-.3t-.4-.1q-.2.1-.3.3Z",
    fill: "#ffe5d4"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2485.2,1208.2c.5-.6.8-1.5.9-2.5.2-.9.2-1.9.3-2.6.1-1.2.1-2.4,0-3.5-.1-1.2-.3-2.4-.6-3.5q0-.1-.1-.3-.1-.1-.3-.1t-.3.2q0,.1-.1.3-.3,1.8-.5,3.6t-.5,3.6c-.1.6-.3,2.4-.3,3.7.1,1.3.4,2.1,1.5,1.1Z",
    fill: "#ffc0c0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C260",
    transform: "translate(0-1142.296388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2050.1,1120l3.9-3.5l4-3.4l140.8-2.2l140.8-2.1l3.9,3.8l4,3.7-148.7,1.9-148.7,1.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2347.4,1116.3l-10.7,64.7-10.7,64.7-2.1,12.6-2.1,12.6h-122.1-122.2l-13.7-75.4-13.7-75.5h2.9l2.9-.1l145.8-1.8l145.7-1.8Z",
    fill: "url(#eIoXAxwJW5C262-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2228.9,1199.6c0-6.7-2.9-12.7-7.6-17-4.8-4.3-11.4-7-18.6-7s-13.8,2.7-18.5,7c-4.8,4.3-7.7,10.3-7.7,17c0,6.6,2.9,12.6,7.7,16.9c4.7,4.4,11.3,7,18.5,7s13.8-2.6,18.6-7c4.7-4.3,7.6-10.3,7.6-16.9Z",
    fill: "url(#eIoXAxwJW5C263-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2325.3,1136.1h-12.1-12.1v-1.4-1.3h12.1h12.1v1.3v1.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2325.3,1144h-12.1-12.1v-1.3-1.4h12.1h12.1v1.4v1.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2325.3,1151.9h-12.1-12.1v-1.3-1.3h12.1h12.1v1.3v1.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2226.1,1201c0-6.6-3-12.6-7.7-17-4.8-4.3-11.3-7-18.6-7-7.2,0-13.8,2.7-18.5,7-4.8,4.4-7.7,10.4-7.7,17s2.9,12.6,7.7,16.9c4.7,4.4,11.3,7.1,18.5,7.1c7.3,0,13.8-2.7,18.6-7.1c4.7-4.3,7.7-10.3,7.7-16.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2326,1245.7l-2.1,12.6-2.1,12.6h-122.1-122.2l-13.7-75.4-13.7-75.5h2.9l2.9-.1c.4,1,.9,1.9,1.3,2.8.5.9.9,1.8,1.2,2.6c1.6,4,3.5,7.8,5.6,11.5c2.1,3.8,4.4,7.4,6.7,11q9.1,14.3,20.2,26.9t24.1,23.6c23.2,19.3,51,31.7,80.4,39.3c29.4,7.5,60.3,10.2,89.7,10q10.3,0,20.5-.5t20.4-1.4Z",
    fill: "url(#eIoXAxwJW5C269-fill)"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.353416 0 0 0.364577-175.822972 298.992858)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1972.05-1389.91)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1.00112 0-111.246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2005.8,781.4c1.3,3.5,3.1,6.9,4.9,10.2c1.9,3.4,3.8,6.7,5.3,10.1c1.7,3.8,3.5,7.6,5.3,11.4s3.5,7.6,5.1,11.4q1.1,2.6,2.1,5.1q1.1,2.6,2.4,5c0,0-10.5-9.6-20.9-19.7-10.3-10-20.4-20.4-19.7-22s4.2-3.6,7.8-5.6c3.5-1.9,7.1-3.8,8-5.1l-.1-.4-.2-.4Z",
    transform: "matrix(0 0 0 0 2010.58 808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.688186 9.559332)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-2.5869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C335",
    transform: "matrix(0 0 0 0 1352.310158 429.144276)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1671.1,948.8l80.5-.1l80.4-.2c8.8,0,16.7,3.9,22,10.1c5.3,6.1,8,14.4,6.6,23.2v.2.2c-1.1,7-4.7,13.2-9.8,17.5-5.1,4.4-11.7,7-18.8,7h-80.4-80.4c-9,0-16.8-4-22.1-10.2s-7.9-14.7-6.5-23.5c1.2-7,4.8-13,9.9-17.3c5-4.3,11.6-6.9,18.6-6.9Z",
    opacity: 0.9,
    fill: "url(#eIoXAxwJW5C337-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1894.6,1049.8c-.7-.7-4.9-4.5-10.2-9.6-5.4-5.1-12-11.4-17.6-17.1q-.8.1-1.6.2-.8,0-1.6,0h-80.4-80.4c-9,0-16.8-4-22.1-10.2-5.3-6.3-7.9-14.7-6.5-23.5.6-3.5,1.8-6.7,3.5-9.6c1.7-3,3.8-5.5,6.4-7.7c2.5-2.1,5.4-3.9,8.5-5.1c3.2-1.1,6.6-1.8,10.1-1.8l80.4-.1l80.5-.2c8.8,0,16.7,3.9,22,10c5.2,6.2,8,14.5,6.6,23.3v.2.2c-.6,4-2.1,7.7-4.1,11-2,3.2-4.7,6-7.8,8.2c1.6,3.6,3.3,7.2,5.1,10.8c1.7,3.7,3.4,7.3,4.8,10.9q1.1,2.6,2.2,5.2q1.1,2.5,2.2,4.9Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1711,994.3c0,2.8-1.2,5.4-3,7.3-1.9,1.9-4.5,3.1-7.4,3.1s-5.4-1.2-7.3-3.1-3.1-4.5-3.1-7.3c0-2.9,1.2-5.5,3.1-7.4c1.9-1.8,4.4-3,7.3-3s5.5,1.2,7.4,3c1.8,1.9,3,4.5,3,7.4Z",
    fill: "url(#eIoXAxwJW5C341-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1861.7,989.3h-67.7-67.7v-2.1-2h67.7h67.7v2v2.1Z",
    fill: "url(#eIoXAxwJW5C342-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1861.7,1001.9h-67.7-67.7v-2-2.1h67.7h67.7v2.1v2Z",
    fill: "url(#eIoXAxwJW5C343-fill)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1786.2,876.5c1.2,3.5,3,6.8,4.8,10.2c1.9,3.3,3.8,6.6,5.3,10c1.7,3.9,3.5,7.7,5.3,11.4c1.8,3.8,3.5,7.6,5.1,11.5q1.1,2.5,2.1,5.1q1.1,2.5,2.4,5c0,0-10.5-9.7-20.9-19.7-10.3-10.1-20.4-20.5-19.7-22.1.7-1.5,4.2-3.6,7.8-5.5c3.5-2,7.1-3.9,8-5.2l-.1-.3-.1-.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1788.9,910.8h-23.3-23.2c-3.1,0-5.9-1.2-7.9-3.2s-3.2-4.8-3.2-7.9v-23.2-23.3c0-3,1.2-5.8,3.2-7.8s4.8-3.3,7.9-3.3h23.2h23.3c3,0,5.8,1.3,7.8,3.3s3.3,4.8,3.3,7.8v23.3v23.2c0,3.1-1.3,5.9-3.3,7.9s-4.8,3.2-7.8,3.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.8,865.3h-22.2-22.2v-2.1-2h22.2h22.2v2v2.1Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.7,878.5h-22.2-22.2v-2.1-2h22.2h22.2v2v2.1Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.7,891.8h-22.2-22.2v-2.1-2h22.2h22.2v2v2.1Z",
    fill: "#ccc4cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C349",
    transform: "translate(593.030645-380.748234)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8909-3.32246)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2689.6,863.3c3.1,8.4,9.3,14.7,16.8,18.1c7.5,3.5,16.4,4.1,24.7,1c8.4-3.1,14.7-9.3,18.2-16.9c3.4-7.5,4-16.3.9-24.7-3.1-8.3-9.3-14.7-16.8-18.1-7.5-3.5-16.4-4-24.7-.9-8.4,3.1-14.7,9.3-18.2,16.8-3.4,7.5-4,16.3-.9,24.7Z",
    fill: "#e53e53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2719.9,895.2c-11.9,0-22.7-4.9-30.5-12.7s-12.6-18.6-12.6-30.4c0-11.9,4.8-22.7,12.6-30.5s18.6-12.7,30.5-12.7s22.7,4.9,30.5,12.7s12.6,18.6,12.6,30.5c0,11.8-4.8,22.6-12.6,30.4s-18.6,12.7-30.5,12.7Zm0-83.6c-11.2,0-21.3,4.5-28.6,11.9-7.3,7.3-11.9,17.4-11.9,28.6c0,11.1,4.6,21.2,11.9,28.6c7.3,7.3,17.4,11.8,28.6,11.8s21.3-4.5,28.6-11.8c7.3-7.4,11.9-17.5,11.9-28.6c0-11.2-4.6-21.3-11.9-28.6-7.3-7.4-17.4-11.9-28.6-11.9Z",
    fill: "url(#eIoXAxwJW5C353-fill)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2720.7,873.3c-1.1,0-2-.4-2.7-1-.6-.7-1-1.6-1-2.7c0-1,.4-1.9,1-2.6.7-.7,1.6-1.1,2.7-1.1c1,0,1.9.4,2.6,1.1s1.1,1.6,1.1,2.6c0,1.1-.4,2-1.1,2.7-.7.6-1.6,1-2.6,1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2724.4,859.8h-3.5-3.5l-.5-15.4-.6-15.5h4.5h4.5l-.5,15.5-.4,15.4Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2665.8,897.8h-103.5-103.5c-3,0-5.8,1.2-7.8,3.2s-3.2,4.8-3.2,7.9v40.4v40.5c0,3,1.2,5.8,3.2,7.8s4.8,3.3,7.8,3.3h103.5h103.5c3,0,5.8-1.3,7.8-3.3s3.3-4.8,3.3-7.8v-40.5-40.4c0-3.1-1.3-5.9-3.3-7.9s-4.8-3.2-7.8-3.2Z",
    fill: "url(#eIoXAxwJW5C357-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2718.7,925.9h-103.5-103.4c-3.1,0-5.9,1.2-7.9,3.2-2,2.1-3.2,4.8-3.2,7.9v40.4v40.5c0,3.1,1.2,5.8,3.2,7.8s4.8,3.3,7.9,3.3h103.4h103.5c3.1,0,5.8-1.3,7.8-3.3c2.1-2,3.3-4.7,3.3-7.8v-40.5-40.4c0-3.1-1.2-5.8-3.3-7.9-2-2-4.7-3.2-7.8-3.2Z",
    fill: "url(#eIoXAxwJW5C358-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2713.8,1000.9h-98.6-98.5v-3.4-3.4h98.5h98.6v3.4v3.4Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2713.8,957.6h-98.6-98.5v-3.4-3.3h98.5h98.6v3.3v3.4Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2713.8,979.2h-98.6-98.5v-3.3-3.4h98.5h98.6v3.4v3.3Z",
    fill: "#ccc4cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C362",
    transform: "matrix(0 0 0 0 1524.326743 338.503259)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2308.7,585.6c3.1,8.4,9.3,14.7,16.8,18.1c7.5,3.5,16.3,4.1,24.7,1s14.7-9.3,18.1-16.8c3.5-7.6,4.1-16.4,1-24.8-3.1-8.3-9.3-14.6-16.8-18.1-7.6-3.4-16.4-4-24.8-.9-8.3,3.1-14.6,9.3-18.1,16.8-3.4,7.5-4,16.3-.9,24.7Z",
    fill: "#1fb090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2339,616.8c-11.7,0-22.3-4.8-30-12.5-7.7-7.6-12.4-18.2-12.4-29.9s4.7-22.3,12.4-30s18.3-12.4,30-12.4s22.3,4.7,29.9,12.4c7.7,7.7,12.5,18.3,12.5,30s-4.8,22.3-12.5,29.9c-7.6,7.7-18.2,12.5-29.9,12.5Zm0-82.2c-11,0-20.9,4.5-28.1,11.7s-11.7,17.1-11.7,28.1c0,10.9,4.5,20.9,11.7,28.1s17.1,11.6,28.1,11.6c10.9,0,20.9-4.4,28.1-11.6s11.6-17.2,11.6-28.1c0-11-4.4-20.9-11.6-28.1s-17.2-11.7-28.1-11.7Z",
    fill: "url(#eIoXAxwJW5C365-fill)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2337.1,591.2q-.5,0-.9-.3-.5-.2-.8-.6l-5.9-7.8-5.9-7.7l1.7-1.3l1.8-1.4l4.9,6.4l4.8,6.4l7.7-14l7.6-14l1.9,1.1l2,1-8.5,15.5-8.4,15.5q-.3.5-.8.8-.4.3-1,.4q0,0-.1,0q0,0-.1,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2555.2,655.7v55.2v55.2c0,3.7-1.4,7.1-3.7,9.5s-5.4,3.9-8.9,3.9h-111.7-111.7c-3.4-.1-6.5-1.6-8.7-4-2.3-2.4-3.7-5.7-3.7-9.4v-55.2-55.2c0-3.7,1.5-7,3.8-9.4c2.2-2.4,5.4-3.9,8.9-3.9h111.6h111.5c3.5,0,6.6,1.5,8.9,3.9s3.7,5.7,3.7,9.4Z",
    fill: "url(#eIoXAxwJW5C369-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2555.2,645.8v6.3v6.2h-124.2-124.2v-6.2-6.3c0-3.9,1.5-7.5,3.8-10.2c2.2-2.6,5.4-4.2,8.9-4.2h111.6h111.5c3.5,0,6.6,1.6,8.9,4.2c2.3,2.7,3.7,6.3,3.7,10.2Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2372.2,681.7h-23-23v-3.3-3.4h23h23v3.4v3.3Z",
    fill: "#1fb090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2535,696.7h-98.5-98.5v-3.4-3.4h98.5h98.5v3.4v3.4Z",
    fill: "#e54053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2535,711.6h-98.5-98.5v-3.4-3.4h98.5h98.5v3.4v3.4Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2392.9,726.5h-33.3-33.4v-3.4-3.4h33.4h33.3v3.4v3.4Z",
    fill: "#e54053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2535,741.4h-98.5-98.5v-3.4-3.4h98.5h98.5v3.4v3.4Z",
    fill: "#1fb090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2517.8,756.3h-89.9-89.9v-3.4-3.4h89.9h89.9v3.4v3.4Z",
    fill: "#010019"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2533.3,644.9c0,1.4.6,2.8,1.6,3.7c1,1,2.3,1.6,3.8,1.6c1.4,0,2.7-.6,3.7-1.6c1-.9,1.6-2.3,1.6-3.7c0-1.5-.6-2.8-1.6-3.8-1-.9-2.3-1.5-3.7-1.5-1.5,0-2.8.6-3.8,1.5-1,1-1.6,2.3-1.6,3.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2514.4,644.9c0,1.4.6,2.8,1.5,3.7c1,1,2.3,1.6,3.8,1.6c1.4,0,2.8-.6,3.7-1.6c1-.9,1.6-2.3,1.6-3.7c0-1.5-.6-2.8-1.6-3.8-.9-.9-2.3-1.5-3.7-1.5-1.5,0-2.8.6-3.8,1.5-.9,1-1.5,2.3-1.5,3.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2495.4,644.9c0,1.4.6,2.8,1.5,3.7c1,1,2.3,1.6,3.8,1.6c1.4,0,2.8-.6,3.7-1.6c1-.9,1.6-2.3,1.6-3.7c0-1.5-.6-2.8-1.6-3.8-.9-.9-2.3-1.5-3.7-1.5-1.5,0-2.8.6-3.8,1.5-.9,1-1.5,2.3-1.5,3.8Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "eIoXAxwJW5C382",
    transform: "matrix(0 0 0 0 1397.107947 386.257444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2062.1,775.9h-109.9-109.8c-3.1,0-5.9-1.3-7.9-3.3s-3.2-4.8-3.2-7.8v-63.5-63.5c0-3,1.2-5.8,3.2-7.8s4.8-3.2,7.9-3.2h109.8h109.9c3,0,5.8,1.2,7.8,3.2s3.2,4.8,3.2,7.8v63.5v63.5c0,3-1.2,5.8-3.2,7.8s-4.8,3.3-7.8,3.3Z",
    fill: "url(#eIoXAxwJW5C383-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2024.8,808.1h-109.9-109.8c-3.1,0-5.9-1.3-7.9-3.3s-3.2-4.8-3.2-7.8v-63.5-63.4c0-3.1,1.2-5.9,3.2-7.9s4.8-3.2,7.9-3.2h109.8h109.9c3,0,5.8,1.2,7.8,3.2s3.3,4.8,3.3,7.9v63.4v63.5c0,3-1.3,5.8-3.3,7.8s-4.8,3.3-7.8,3.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1958.6,701.3q-.5-.3-1.2-.5t-1.5-.2h-44.8-44.7q-.8,0-1.5.2t-1.2.5l23.7,20.3l23.7,20.3l23.8-20.3l23.7-20.3Z",
    fill: "url(#eIoXAxwJW5C386-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.2,705.9v34v33.9c0,1.5-.6,2.8-1.6,3.7-.9,1-2.3,1.6-3.7,1.6h-44.8-44.7c-1.5,0-2.8-.6-3.8-1.6-.9-.9-1.5-2.2-1.5-3.7v-33.9-34q0-.7.2-1.4.1-.6.6-1.1l24.6,21l24.6,21l24.7-21l24.6-21q.4.5.6,1.1.2.7.2,1.4Z",
    opacity: 0.9,
    fill: "url(#eIoXAxwJW5C387-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1941.6,709.8c1.7,4.5,5,7.9,9.1,9.7c4,1.9,8.7,2.2,13.2.5c4.5-1.6,7.9-5,9.7-9c1.9-4,2.2-8.8.5-13.3-1.6-4.4-4.9-7.8-9-9.7-4-1.8-8.7-2.1-13.2-.5-4.5,1.7-7.9,5-9.8,9-1.8,4.1-2.1,8.8-.5,13.3Z",
    fill: "#e53e53"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1952.3,707.5q0-1.7.9-2.8.9-1.2,2.5-1.9v-.1c-1-.4-1.7-1-2.1-1.7-.5-.7-.7-1.4-.7-2.2c0-1.4.6-2.5,1.6-3.3.9-.8,2.3-1.3,3.8-1.3c1.7,0,3,.5,3.8,1.3s1.3,1.9,1.3,3c0,.7-.2,1.5-.7,2.2-.4.7-1.1,1.3-2.2,1.8v.1c1.1.4,2,1,2.6,1.8s.9,1.7.9,2.7c0,1.5-.6,2.8-1.7,3.7s-2.6,1.4-4.2,1.4c-1.8,0-3.3-.6-4.3-1.4-1-.9-1.5-2.1-1.5-3.3Zm9.3-.1c0-1.1-.3-1.9-1-2.5s-1.6-1-2.8-1.3q-1.5.4-2.3,1.3-.8,1-.8,2.2c-.1.9.2,1.8.8,2.4s1.5,1,2.6,1s2-.4,2.6-.9c.6-.6.9-1.3.9-2.2Zm-6.4-8.7c0,.8.3,1.5.9,2c.5.5,1.4.9,2.4,1.2.7-.3,1.4-.7,1.9-1.2.4-.5.7-1.2.7-2c0-.7-.2-1.4-.7-1.9-.4-.6-1.2-.9-2.2-.9s-1.8.3-2.3.8-.7,1.2-.7,2Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M2005.7,783.4c.6.1,1,.5,1.4,1c.3.5.5,1.2.8,1.8q.6,1.3,1.3,2.6t1.4,2.6q1.4,2.5,2.8,5.1q1.4,2.5,2.6,5.2c1.7,3.8,3.5,7.6,5.3,11.4s3.5,7.6,5.1,11.4q1.1,2.6,2.1,5.1q1.1,2.6,2.4,5c0,0-10.5-9.6-20.9-19.7-10.3-10-20.4-20.4-19.7-22c.5-1,1.5-1.9,2.6-2.7c1.2-.7,2.4-1.3,3.4-1.9q1-.6,2.1-1.2t2.2-1.2c.7-.4,1.4-.9,2.1-1.4.7-.4,1.5-.8,2.2-1q.2-.1.4-.1t.4,0Z",
    fill: "#fff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome11);
export default __webpack_public_path__ + "static/media/home11.0857b285c3d230546deb2e40e9d51b34.svg";
export { ForwardRef as ReactComponent };